import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8ccf2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-7 text-gray-800 flex-grow-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Đang mở chỉnh sửa", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Hồ sơ đã chốt", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square me-1" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock me-1" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "card mb-5 mb-xl-5"
}
const _hoisted_7 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_8 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " Giấy chứng nhận TNTT/ Bằng tốt nghiệp THPT ", -1))
const _hoisted_10 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_11 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_12 = {
  id: "kt_account_deactivate",
  class: "collapse show"
}
const _hoisted_13 = { class: "card-body border-top mb-3 pt-4" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-semibold fs-7 text-gray-700 mb-2" }, "Nhập mã số", -1))
const _hoisted_16 = { class: "fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng chờ ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Cách lấy mã số", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
  /*#__PURE__*/_createTextVNode(" Nhập số mã vạch trên Giấy chứng nhận kỳ thi tốt nghiệp THPT Quốc Gia 2022 hoặc số hiệu Bằng tốt nghiệp THPT "),
  /*#__PURE__*/_createElementVNode("i", { class: "text-gray-600" }, "(Theo quy định mỗi thí sinh chỉ được quyền xác nhận nhập học vào 01 trường, nên nếu thí sinh đồng ý xác nhận nhập học vào Trường UMT thì cung cấp số mã vạch/số hiệu bằng và không được nộp cho trường khác.)")
], -1))
const _hoisted_25 = { class: "card mb-5 mb-xl-5" }
const _hoisted_26 = {
  class: "card-header border-0 cursor-pointer position-relative",
  style: {"min-height":"auto","padding-top":"1.1rem","padding-bottom":"0.2rem"},
  role: "button"
}
const _hoisted_27 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_28 = { class: "d-flex align-items-center gap-2" }
const _hoisted_29 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_30 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_33 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_34 = { class: "card-body border-top pt-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_38 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Họ và tên:", -1))
const _hoisted_40 = { class: "fw-semibold text-gray-800 text-transform-capitalize" }
const _hoisted_41 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_42 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày sinh:", -1))
const _hoisted_44 = { class: "fw-semibold text-gray-800" }
const _hoisted_45 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_46 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi sinh:", -1))
const _hoisted_48 = { class: "fw-semibold text-gray-800" }
const _hoisted_49 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_50 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Giới tính:", -1))
const _hoisted_52 = { class: "fw-semibold text-gray-800" }
const _hoisted_53 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_54 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Quốc tịch:", -1))
const _hoisted_56 = { class: "fw-semibold text-gray-800" }
const _hoisted_57 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_58 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Dân tộc:", -1))
const _hoisted_60 = { class: "fw-semibold text-gray-800" }
const _hoisted_61 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_62 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Tôn giáo:", -1))
const _hoisted_64 = { class: "fw-semibold text-gray-800" }
const _hoisted_65 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_66 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "CMND/CCCD:", -1))
const _hoisted_68 = { class: "fw-semibold text-gray-800" }
const _hoisted_69 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_70 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày cấp:", -1))
const _hoisted_72 = { class: "fw-semibold text-gray-800" }
const _hoisted_73 = { class: "col-lg-8 col-md-6 col-12" }
const _hoisted_74 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi cấp:", -1))
const _hoisted_76 = { class: "fw-semibold text-gray-800" }
const _hoisted_77 = {
  key: 0,
  class: "col-lg-6 col-12"
}
const _hoisted_78 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-85px" }, " Đã từng nhập học tại UMT với MSSV: ", -1))
const _hoisted_80 = { class: "fw-semibold text-gray-800" }
const _hoisted_81 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_82 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa thông tin cá nhân", -1))
const _hoisted_84 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1))
const _hoisted_86 = { class: "card-body border-top py-5" }
const _hoisted_87 = { class: "row g-3" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Họ và tên", -1))
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Ngày sinh", -1))
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Nơi sinh", -1))
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Giới tính", -1))
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Tôn giáo", -1))
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Dân tộc", -1))
const _hoisted_100 = { class: "col-md-6" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Quốc tịch", -1))
const _hoisted_102 = { class: "col-md-6" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "CMND/CCCD", -1))
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Ngày cấp", -1))
const _hoisted_106 = { class: "col-md-6" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Nơi cấp", -1))
const _hoisted_108 = { class: "col-md-6" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Loại Đào tạo", -1))
const _hoisted_110 = { class: "col-md-6" }
const _hoisted_111 = { class: "ps-0 fw-bold fs-6 form-check form-check-inline form-check-solid me-5 mb-3" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "enrolledUmt",
  class: "fw-bolder fs-8 ps-2 me-3"
}, " Đã từng nhập học tại UMT ", -1))
const _hoisted_113 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  id: "kt_account_profile_details_submit",
  class: "btn btn-primary"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu thay đổi "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_115 = { class: "card mb-5 mb-xl-5" }
const _hoisted_116 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_117 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_118 = { class: "d-flex align-items-center gap-2" }
const _hoisted_119 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_120 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_123 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_124 = { class: "card-body border-top pt-3" }
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_127 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày vào Đảng:", -1))
const _hoisted_129 = { class: "fw-semibold text-gray-800" }
const _hoisted_130 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_131 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi kết nạp Đảng:", -1))
const _hoisted_133 = { class: "fw-semibold text-gray-800" }
const _hoisted_134 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_135 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày vào Đoàn:", -1))
const _hoisted_137 = { class: "fw-semibold text-gray-800" }
const _hoisted_138 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_139 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi kết nạp Đoàn:", -1))
const _hoisted_141 = { class: "fw-semibold text-gray-800" }
const _hoisted_142 = { class: "col-lg-4 col-12" }
const _hoisted_143 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, " Đảng viên dự bị ", -1))
const _hoisted_145 = { class: "fw-semibold text-gray-800 ps-0 col-form-label form-check form-check-inline form-check-solid p-0 disabled" }
const _hoisted_146 = ["checked"]
const _hoisted_147 = { class: "col-lg-4 col-12" }
const _hoisted_148 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, " Đảng viên ", -1))
const _hoisted_150 = { class: "fw-semibold text-gray-800 ps-0 col-form-label form-check form-check-inline form-check-solid p-0 disabled" }
const _hoisted_151 = ["checked"]
const _hoisted_152 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_153 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa thông tin Đoàn, Đảng", -1))
const _hoisted_155 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_156 = { class: "card-body py-3" }
const _hoisted_157 = { class: "row g-4" }
const _hoisted_158 = { class: "col-12" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Ngày vào Đảng", -1))
const _hoisted_160 = { class: "col-12" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nơi kết nạp Đảng", -1))
const _hoisted_162 = { class: "col-12" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Ngày vào Đoàn", -1))
const _hoisted_164 = { class: "col-12" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nơi kết nạp Đoàn", -1))
const _hoisted_166 = { class: "col-6" }
const _hoisted_167 = { class: "ps-0 col-form-label fw-bold fs-6 form-check form-check-inline form-check-solid w-100" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dvdb",
  class: "fw-bolder fs-7 pe-2"
}, " Đảng viên dự bị ", -1))
const _hoisted_169 = { class: "col-6" }
const _hoisted_170 = { class: "ps-0 col-form-label fw-bold fs-6 form-check form-check-inline form-check-solid w-100" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dvct",
  class: "fw-bolder fs-7 pe-2"
}, " Đảng viên chính thức ", -1))
const _hoisted_172 = { class: "card-footer d-flex justify-content-end py-4 px-9" }
const _hoisted_173 = { class: "card mb-5 mb-xl-5" }
const _hoisted_174 = {
  class: "card-header border-0 cursor-pointer position-relative",
  style: {"min-height":"auto","padding-top":"1.1rem","padding-bottom":"0.2rem"}
}
const _hoisted_175 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_176 = { class: "d-flex align-items-center gap-2" }
const _hoisted_177 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_178 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_179 = { key: 0 }
const _hoisted_180 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_181 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_182 = { class: "card-body border-top pt-3" }
const _hoisted_183 = { class: "mb-8" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1))
const _hoisted_185 = { class: "row" }
const _hoisted_186 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_187 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Số di động:", -1))
const _hoisted_189 = { class: "fw-semibold text-gray-800" }
const _hoisted_190 = { class: "col-lg-8 col-md-6 col-12" }
const _hoisted_191 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Email:", -1))
const _hoisted_193 = { class: "fw-semibold text-gray-800 text-break" }
const _hoisted_194 = { class: "mb-4" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-3 mt-4 umt-subhead" }, "Hộ khẩu thường trú", -1))
const _hoisted_196 = { class: "row" }
const _hoisted_197 = { class: "col-12" }
const _hoisted_198 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder flex-shrink-0" }, "Địa chỉ (Số nhà, tên đường, khu phố):", -1))
const _hoisted_200 = { class: "fw-semibold text-gray-800" }
const _hoisted_201 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_202 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Phường/Xã:", -1))
const _hoisted_204 = { class: "fw-semibold text-gray-800" }
const _hoisted_205 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_206 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Tỉnh/Thành phố:", -1))
const _hoisted_208 = { class: "fw-semibold text-gray-800" }
const _hoisted_209 = { class: "mb-4" }
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-3 umt-subhead" }, "Địa chỉ liên lạc", -1))
const _hoisted_211 = { class: "row" }
const _hoisted_212 = { class: "col-12" }
const _hoisted_213 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder flex-shrink-0" }, "Địa chỉ (Số nhà, tên đường, khu phố):", -1))
const _hoisted_215 = { class: "fw-semibold text-gray-800" }
const _hoisted_216 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_217 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Phường/Xã:", -1))
const _hoisted_219 = { class: "fw-semibold text-gray-800" }
const _hoisted_220 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_221 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Tỉnh/Thành phố:", -1))
const _hoisted_223 = { class: "fw-semibold text-gray-800" }
const _hoisted_224 = {
  id: "kt_signin_email_edit",
  class: "flex-row-fluid"
}
const _hoisted_225 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_226 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa thông tin liên lạc", -1))
const _hoisted_228 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1))
const _hoisted_230 = { class: "card-body py-3" }
const _hoisted_231 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-5 text-gray-900 mb-3" }, "Thông tin liên lạc", -1))
const _hoisted_233 = { class: "row g-3" }
const _hoisted_234 = { class: "col-md-6" }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Số di động", -1))
const _hoisted_236 = { class: "col-md-6" }
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Email", -1))
const _hoisted_238 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-5 text-gray-900 mb-3" }, "Hộ khẩu thường trú", -1))
const _hoisted_240 = { class: "row g-3" }
const _hoisted_241 = { class: "col-md-6" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Tỉnh/Thành phố", -1))
const _hoisted_243 = { class: "col-md-6" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Phường/xã", -1))
const _hoisted_245 = { class: "col-12" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)", -1))
const _hoisted_247 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_248 = { class: "d-flex flex-wrap align-items-center justify-content-between mb-5" }
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-5 text-gray-900" }, "Địa chỉ liên lạc", -1))
const _hoisted_250 = { class: "wrap-check-aotufill" }
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkPostalSameContact",
  class: "ms-2 text-muted fs-7"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Giống địa chỉ thường trú")
], -1))
const _hoisted_252 = { class: "row g-3" }
const _hoisted_253 = { class: "col-md-6" }
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Tỉnh/Thành phố", -1))
const _hoisted_255 = { class: "col-md-6" }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Phường/xã", -1))
const _hoisted_257 = { class: "col-12" }
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)", -1))
const _hoisted_259 = {
  key: 1,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  id: "kt_account_signin_method_submit",
  class: "btn btn-primary"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu thay đổi "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_261 = { class: "card mb-5 mb-xl-5" }
const _hoisted_262 = {
  class: "card-header border-0 cursor-pointer position-relative",
  style: {"min-height":"auto","padding-top":"1.1rem","padding-bottom":"0.2rem"}
}
const _hoisted_263 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_264 = { class: "d-flex align-items-center gap-2" }
const _hoisted_265 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_266 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_267 = {
  key: 0,
  class: "text-muted fs-8 fst-italic ms-2"
}
const _hoisted_268 = { key: 0 }
const _hoisted_269 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_270 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_271 = { class: "collapse show" }
const _hoisted_272 = { class: "card-body border-top pt-3" }
const _hoisted_273 = { class: "d-flex flex-wrap flex-column mb-8" }
const _hoisted_274 = { class: "row mb-4 mx-0" }
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-3 umt-subhead" }, " Thông tin cha ")
], -1))
const _hoisted_276 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_277 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Họ và tên:", -1))
const _hoisted_279 = { class: "fw-semibold text-gray-800" }
const _hoisted_280 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_281 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày sinh:", -1))
const _hoisted_283 = { class: "fw-semibold text-gray-800" }
const _hoisted_284 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_285 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nghề nghiệp:", -1))
const _hoisted_287 = { class: "fw-semibold text-gray-800" }
const _hoisted_288 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_289 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Di động:", -1))
const _hoisted_291 = { class: "fw-semibold text-gray-800" }
const _hoisted_292 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_293 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_294 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Email:", -1))
const _hoisted_295 = { class: "fw-semibold text-gray-800" }
const _hoisted_296 = { class: "col-lg-12 col-md-12 col-12" }
const _hoisted_297 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi ở hiện tại:", -1))
const _hoisted_299 = { class: "fw-semibold text-gray-800" }
const _hoisted_300 = { class: "row mb-4 mx-0" }
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-3 umt-subhead" }, " Thông tin mẹ ")
], -1))
const _hoisted_302 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_303 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Họ và tên:", -1))
const _hoisted_305 = { class: "fw-semibold text-gray-800" }
const _hoisted_306 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_307 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày sinh:", -1))
const _hoisted_309 = { class: "fw-semibold text-gray-800" }
const _hoisted_310 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_311 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_312 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nghề nghiệp:", -1))
const _hoisted_313 = { class: "fw-semibold text-gray-800" }
const _hoisted_314 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_315 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Di động:", -1))
const _hoisted_317 = { class: "fw-semibold text-gray-800" }
const _hoisted_318 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_319 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Email:", -1))
const _hoisted_321 = { class: "fw-semibold text-gray-800" }
const _hoisted_322 = { class: "col-lg-12 col-md-12 col-12" }
const _hoisted_323 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_324 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi ở hiện tại:", -1))
const _hoisted_325 = { class: "fw-semibold text-gray-800" }
const _hoisted_326 = { class: "row mb-4 mx-0" }
const _hoisted_327 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-3 umt-subhead" }, " Thông tin người khác ")
], -1))
const _hoisted_328 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_329 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_330 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Họ và tên:", -1))
const _hoisted_331 = { class: "fw-semibold text-gray-800" }
const _hoisted_332 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_333 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_334 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày sinh:", -1))
const _hoisted_335 = { class: "fw-semibold text-gray-800" }
const _hoisted_336 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_337 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nghề nghiệp:", -1))
const _hoisted_339 = { class: "fw-semibold text-gray-800" }
const _hoisted_340 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_341 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_342 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Di động:", -1))
const _hoisted_343 = { class: "fw-semibold text-gray-800" }
const _hoisted_344 = { class: "col-lg-4 col-md-4 col-12" }
const _hoisted_345 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Email:", -1))
const _hoisted_347 = { class: "fw-semibold text-gray-800" }
const _hoisted_348 = { class: "col-lg-12 col-md-12 col-12" }
const _hoisted_349 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_350 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi ở hiện tại:", -1))
const _hoisted_351 = { class: "fw-semibold text-gray-800" }
const _hoisted_352 = { class: "row mb-4 mx-0" }
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-primary mb-3 umt-subhead" }, " Đồng ý cho UMT thông báo với người thân ")
], -1))
const _hoisted_354 = { class: "col-lg-6 col-12" }
const _hoisted_355 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Thông báo học tập:", -1))
const _hoisted_357 = { class: "fw-semibold text-gray-800" }
const _hoisted_358 = { class: "col-lg-6 col-12" }
const _hoisted_359 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_360 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Liên hệ khẩn cấp:", -1))
const _hoisted_361 = { class: "fw-semibold text-gray-800" }
const _hoisted_362 = { class: "flex-row-fluid" }
const _hoisted_363 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_364 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_365 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa thông tin người thân", -1))
const _hoisted_366 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_367 = { class: "card-body py-3 d-flex flex-column" }
const _hoisted_368 = { class: "row g-3" }
const _hoisted_369 = { class: "col-md-4" }
const _hoisted_370 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Họ và tên", -1))
const _hoisted_371 = { class: "col-md-4" }
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Ngày sinh", -1))
const _hoisted_373 = { class: "col-md-4" }
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nghề nghiệp", -1))
const _hoisted_375 = { class: "col-md-4" }
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Di động", -1))
const _hoisted_377 = { class: "col-md-8" }
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Email", -1))
const _hoisted_379 = { class: "col-12" }
const _hoisted_380 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nơi ở hiện tại (Địa chỉ sau sáp nhập)", -1))
const _hoisted_381 = { class: "row g-3" }
const _hoisted_382 = { class: "col-md-4" }
const _hoisted_383 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Họ và tên", -1))
const _hoisted_384 = { class: "col-md-4" }
const _hoisted_385 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Ngày sinh", -1))
const _hoisted_386 = { class: "col-md-4" }
const _hoisted_387 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nghề nghiệp", -1))
const _hoisted_388 = { class: "col-md-4" }
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Di động", -1))
const _hoisted_390 = { class: "col-md-8" }
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Email", -1))
const _hoisted_392 = { class: "col-12" }
const _hoisted_393 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nơi ở hiện tại (Địa chỉ sau sáp nhập)", -1))
const _hoisted_395 = { class: "wrap-check-aotufill" }
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkMotherSameFatherAddress",
  class: "ms-2 text-muted fs-7"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Giống địa chỉ cha")
], -1))
const _hoisted_397 = { class: "row g-3" }
const _hoisted_398 = { class: "col-md-4" }
const _hoisted_399 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Họ và tên", -1))
const _hoisted_400 = { class: "col-md-4" }
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Ngày sinh", -1))
const _hoisted_402 = { class: "col-md-4" }
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nghề nghiệp", -1))
const _hoisted_404 = { class: "col-md-4" }
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Di động", -1))
const _hoisted_406 = { class: "col-md-8" }
const _hoisted_407 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Email", -1))
const _hoisted_408 = { class: "col-12" }
const _hoisted_409 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Nơi ở hiện tại (Địa chỉ sau sáp nhập)", -1))
const _hoisted_410 = { class: "mb-5" }
const _hoisted_411 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-primary mb-3 mt-2 umt-subhead" }, "Đồng ý cho UMT thông báo với người thân", -1))
const _hoisted_412 = { class: "row g-3" }
const _hoisted_413 = { class: "col-12" }
const _hoisted_414 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-1 required" }, "Thông báo tình hình học tập", -1))
const _hoisted_415 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_416 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Cha", -1))
const _hoisted_417 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_418 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Mẹ", -1))
const _hoisted_419 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Người khác", -1))
const _hoisted_421 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Không đồng ý", -1))
const _hoisted_423 = { class: "col-12" }
const _hoisted_424 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-1 required" }, "Thông báo trường hợp khẩn cấp", -1))
const _hoisted_425 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_426 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Cha", -1))
const _hoisted_427 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_428 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Mẹ", -1))
const _hoisted_429 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_430 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Người khác", -1))
const _hoisted_431 = {
  key: 1,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_432 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  id: "kt_relatives_submit",
  class: "btn btn-primary"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu thay đổi "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_433 = { class: "card mb-5 mb-xl-5" }
const _hoisted_434 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_435 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_436 = { class: "d-flex align-items-center gap-2" }
const _hoisted_437 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_438 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_439 = { key: 0 }
const _hoisted_440 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_441 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_442 = { class: "card-body border-top p-9 pt-4 pb-2" }
const _hoisted_443 = { class: "row" }
const _hoisted_444 = { class: "col-lg-12 col-12" }
const _hoisted_445 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_446 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Trường năm lớp 12:", -1))
const _hoisted_447 = { class: "fw-semibold text-gray-800" }
const _hoisted_448 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_449 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_450 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Năm tốt nghiệp:", -1))
const _hoisted_451 = { class: "fw-semibold text-gray-800" }
const _hoisted_452 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_453 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_454 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Số hiệu bằng:", -1))
const _hoisted_455 = { class: "fw-semibold text-gray-800" }
const _hoisted_456 = {
  key: 0,
  class: "mt-3 mb-2 p-5 rounded bg-light-primary"
}
const _hoisted_457 = { class: "d-flex align-items-center flex-wrap mb-3" }
const _hoisted_458 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-primary me-2" }, "Liên thông", -1))
const _hoisted_459 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "Bằng Trung cấp/Cao đẳng (nhập học)", -1))
const _hoisted_460 = { class: "svg-icon svg-icon-primary svg-icon-3 me-1" }
const _hoisted_461 = {
  key: 0,
  class: "d-flex align-items-center flex-wrap bg-light-warning rounded px-3 py-2 mb-3"
}
const _hoisted_462 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2 fs-7" }, null, -1))
const _hoisted_463 = { class: "fs-8 text-gray-700" }
const _hoisted_464 = {
  key: 0,
  class: "ms-auto d-flex gap-3 flex-wrap"
}
const _hoisted_465 = {
  key: 1,
  class: "row"
}
const _hoisted_466 = { class: "col-lg-6 col-12" }
const _hoisted_467 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_468 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Trường tốt nghiệp:", -1))
const _hoisted_469 = { class: "fw-semibold text-gray-800" }
const _hoisted_470 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_471 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_472 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Hệ đào tạo:", -1))
const _hoisted_473 = { class: "fw-semibold text-gray-800" }
const _hoisted_474 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_475 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_476 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Hình thức:", -1))
const _hoisted_477 = { class: "fw-semibold text-gray-800" }
const _hoisted_478 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_479 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_480 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Điểm TB (GPA):", -1))
const _hoisted_481 = { class: "fw-semibold text-gray-800" }
const _hoisted_482 = {
  key: 0,
  class: "badge badge-light-primary fw-semibold fs-8 ms-2"
}
const _hoisted_483 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_484 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_485 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Số hiệu bằng:", -1))
const _hoisted_486 = { class: "fw-semibold text-gray-800" }
const _hoisted_487 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_488 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_489 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Số vào sổ:", -1))
const _hoisted_490 = { class: "fw-semibold text-gray-800" }
const _hoisted_491 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_492 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_493 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Năm tốt nghiệp:", -1))
const _hoisted_494 = { class: "fw-semibold text-gray-800" }
const _hoisted_495 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_496 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_497 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày cấp bằng:", -1))
const _hoisted_498 = { class: "fw-semibold text-gray-800" }
const _hoisted_499 = {
  key: 0,
  class: "col-lg-6 col-12"
}
const _hoisted_500 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_501 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Trung cấp (nguồn LT):", -1))
const _hoisted_502 = { class: "fw-semibold text-gray-800" }
const _hoisted_503 = { key: 0 }
const _hoisted_504 = {
  key: 2,
  class: "text-muted fst-italic fs-7"
}
const _hoisted_505 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Chỉnh sửa", -1))
const _hoisted_506 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_507 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_508 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa bằng Trung cấp/Cao đẳng", -1))
const _hoisted_509 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_510 = { class: "card-body py-3" }
const _hoisted_511 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mb-4" }, "Bản dùng cho nhập học, tách khỏi hồ sơ xét tuyển liên thông gốc. Sửa ở đây không ảnh hưởng hồ sơ xét tuyển.", -1))
const _hoisted_512 = { class: "mb-3" }
const _hoisted_513 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Trường tốt nghiệp", -1))
const _hoisted_514 = { class: "row" }
const _hoisted_515 = { class: "col-6 mb-3" }
const _hoisted_516 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Hệ đào tạo", -1))
const _hoisted_517 = { class: "col-6 mb-3" }
const _hoisted_518 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Hình thức đào tạo", -1))
const _hoisted_519 = { class: "row" }
const _hoisted_520 = { class: "col-6 mb-3" }
const _hoisted_521 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Thang điểm", -1))
const _hoisted_522 = { class: "col-6 mb-3" }
const _hoisted_523 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Điểm trung bình (GPA)", -1))
const _hoisted_524 = { class: "row" }
const _hoisted_525 = { class: "col-6 mb-3" }
const _hoisted_526 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Số hiệu bằng", -1))
const _hoisted_527 = { class: "col-6 mb-3" }
const _hoisted_528 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Số vào sổ TN", -1))
const _hoisted_529 = { class: "row" }
const _hoisted_530 = { class: "col-6 mb-3" }
const _hoisted_531 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Năm tốt nghiệp", -1))
const _hoisted_532 = { class: "col-6 mb-3" }
const _hoisted_533 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Ngày cấp bằng", -1))
const _hoisted_534 = { class: "mb-3" }
const _hoisted_535 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_536 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7" }, "Tốt nghiệp Cao đẳng theo hình thức liên thông từ Trung cấp", -1))
const _hoisted_537 = {
  key: 0,
  class: "border border-gray-300 rounded p-4 mb-3"
}
const _hoisted_538 = { class: "row" }
const _hoisted_539 = { class: "col-12 mb-3" }
const _hoisted_540 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Trường tốt nghiệp", -1))
const _hoisted_541 = { class: "col-6 mb-3" }
const _hoisted_542 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Hình thức đào tạo", -1))
const _hoisted_543 = { class: "col-6 mb-3" }
const _hoisted_544 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Hệ", -1))
const _hoisted_545 = { class: "col-6 mb-3" }
const _hoisted_546 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Số hiệu bằng", -1))
const _hoisted_547 = { class: "col-6 mb-3" }
const _hoisted_548 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Số vào sổ TN", -1))
const _hoisted_549 = { class: "col-6 mb-3" }
const _hoisted_550 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Năm tốt nghiệp", -1))
const _hoisted_551 = { class: "col-6 mb-3" }
const _hoisted_552 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold" }, "Ngày cấp bằng", -1))
const _hoisted_553 = { class: "card-footer py-4 px-6 d-flex justify-content-end" }
const _hoisted_554 = ["disabled"]
const _hoisted_555 = { key: 0 }
const _hoisted_556 = { key: 1 }
const _hoisted_557 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_558 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_559 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa quá trình học tập", -1))
const _hoisted_560 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_561 = { class: "card-body py-3" }
const _hoisted_562 = { class: "row g-3" }
const _hoisted_563 = { class: "col-12 fv-row d-flex flex-column" }
const _hoisted_564 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bold mb-1" }, "Tỉnh/Thành phố (lớp 12)", -1))
const _hoisted_565 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_566 = { class: "col-12 fv-row d-flex flex-column" }
const _hoisted_567 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bold mb-1" }, [
  /*#__PURE__*/_createTextVNode("Trường (lớp 12) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "· gõ tên trường để tìm")
], -1))
const _hoisted_568 = {
  key: 0,
  class: "text-muted fs-8"
}
const _hoisted_569 = { class: "col-12 fv-row d-flex flex-column" }
const _hoisted_570 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required form-label fw-bold mb-1" }, "Năm tốt nghiệp", -1))
const _hoisted_571 = { class: "col-12 fv-row d-flex flex-column" }
const _hoisted_572 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Số hiệu bằng", -1))
const _hoisted_573 = { class: "card-footer d-flex justify-content-end py-4 px-9" }
const _hoisted_574 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu thay đổi"),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_575 = {
  key: 0,
  class: "card-header border-0 cursor-pointer"
}
const _hoisted_576 = { class: "card-title m-0 w-100 mt-3" }
const _hoisted_577 = { class: "d-flex flex-stack mb-3 w-100" }
const _hoisted_578 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "fw-semibold m-0 fs-5 text-primary umt-subhead",
  role: "button",
  "aria-controls": "kt_account_email_preferences"
}, " Trường Trung cấp, Cao đẳng hoặc Đại học khác ", -1))
const _hoisted_579 = { class: "svg-icon svg-icon-primary svg-icon-2" }
const _hoisted_580 = {
  key: 1,
  id: "kt_account_email_preferences",
  class: "collapse show"
}
const _hoisted_581 = { class: "card-body border-top px-6 pt-4" }
const _hoisted_582 = { class: "col-lg-12 col-12 fv-row d-flex flex-column" }
const _hoisted_583 = { class: "fv-row" }
const _hoisted_584 = { class: "menu-link text-gray-600" }
const _hoisted_585 = { class: "menu-link text-gray-600" }
const _hoisted_586 = { class: "menu-link text-gray-600" }
const _hoisted_587 = { class: "menu-link text-gray-600" }
const _hoisted_588 = { class: "menu-link text-gray-600" }
const _hoisted_589 = { class: "text-center" }
const _hoisted_590 = ["onClick"]
const _hoisted_591 = ["onClick"]
const _hoisted_592 = {
  key: 0,
  class: "form-add-record mt-4"
}
const _hoisted_593 = { class: "border border-gray-300 border-dashed rounded p-5" }
const _hoisted_594 = { class: "row g-3" }
const _hoisted_595 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_596 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Tên ngành", -1))
const _hoisted_597 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_598 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Cấp độ học", -1))
const _hoisted_599 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_600 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 required" }, "Địa điểm học", -1))
const _hoisted_601 = { class: "col-lg-3 col-md-6 col-12" }
const _hoisted_602 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Thời gian", -1))
const _hoisted_603 = { class: "col-12" }
const _hoisted_604 = {
  class: "form-check form-check-custom form-check-solid",
  for: "collegesUniversitiesStatus"
}
const _hoisted_605 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fs-7 fw-semibold" }, "Đã tốt nghiệp / hoàn thành chương trình", -1))
const _hoisted_606 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_607 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Lưu", -1))
const _hoisted_608 = {
  key: 2,
  class: "card mb-5 mb-xl-5"
}
const _hoisted_609 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_notifications",
  "aria-expanded": "true",
  "aria-controls": "kt_account_notifications"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " Thông tin về các hoạt động gần nhất (nếu có) ")
  ])
], -1))
const _hoisted_610 = {
  id: "kt_account_notifications",
  class: "collapse show"
}
const _hoisted_611 = { class: "form" }
const _hoisted_612 = { class: "card-body border-top px-9 pt-3 pb-4" }
const _hoisted_613 = {
  key: 0,
  class: "col-lg-12 col-12 fv-row d-flex flex-column mt-4"
}
const _hoisted_614 = { class: "fv-row row" }
const _hoisted_615 = { class: "fv-row row" }
const _hoisted_616 = { class: "card mb-5 mb-xl-5" }
const _hoisted_617 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_618 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_619 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_620 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_621 = { key: 0 }
const _hoisted_622 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_623 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_624 = {
  id: "kt_account_connected_accounts",
  class: "collapse show"
}
const _hoisted_625 = { class: "card-body border-top p-9 pt-4 pb-2" }
const _hoisted_626 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_627 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Dịch vụ tư vấn:", -1))
const _hoisted_628 = { class: "fw-semibold text-gray-800" }
const _hoisted_629 = {
  key: 0,
  class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200"
}
const _hoisted_630 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Mô tả (Khác):", -1))
const _hoisted_631 = { class: "fw-semibold text-gray-800" }
const _hoisted_632 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_633 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_634 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa tư vấn hỗ trợ sinh viên", -1))
const _hoisted_635 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_636 = { class: "card-body py-3" }
const _hoisted_637 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_638 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 mb-0" }, "Sinh viên lựa chọn các dịch vụ sau để được tư vấn")
], -1))
const _hoisted_639 = { class: "row g-0 mb-3" }
const _hoisted_640 = { class: "col-md-6 col-6 mb-3 form-check form-check-solid align-items-start" }
const _hoisted_641 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 mb-0" }, "Xe buýt")
], -1))
const _hoisted_642 = { class: "col-md-6 col-6 mb-3 form-check form-check-solid align-items-start" }
const _hoisted_643 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 mb-0" }, "Nhà trọ")
], -1))
const _hoisted_644 = { class: "col-md-6 col-6 mb-3 form-check form-check-solid align-items-start" }
const _hoisted_645 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 mb-0" }, "CLB sinh viên")
], -1))
const _hoisted_646 = { class: "col-md-6 col-6 mb-3 form-check form-check-solid align-items-start" }
const _hoisted_647 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 mb-0" }, "Việc làm thêm")
], -1))
const _hoisted_648 = { class: "col-12 d-flex gap-5" }
const _hoisted_649 = { class: "mb-3 form-check form-check-solid align-items-start" }
const _hoisted_650 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 mb-0" }, "Khác")
], -1))
const _hoisted_651 = {
  key: 0,
  class: "fv-row flex-grow-1"
}
const _hoisted_652 = { class: "fv-plugins-message-container" }
const _hoisted_653 = { class: "fv-help-block" }
const _hoisted_654 = { class: "card-footer d-flex justify-content-end py-4 px-9" }
const _hoisted_655 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu ", -1))
const _hoisted_656 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_657 = [
  _hoisted_655,
  _hoisted_656
]
const _hoisted_658 = { class: "card mb-5 mb-xl-5" }
const _hoisted_659 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_660 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_661 = { class: "d-flex align-items-center gap-2" }
const _hoisted_662 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_663 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_664 = { key: 0 }
const _hoisted_665 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_666 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_667 = {
  id: "kt_account_eng",
  class: "collapse show"
}
const _hoisted_668 = { class: "card-body border-top p-9 pt-4 pb-2" }
const _hoisted_669 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_670 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Hình thức:", -1))
const _hoisted_671 = { class: "fw-semibold text-gray-800" }
const _hoisted_672 = {
  key: 0,
  class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200"
}
const _hoisted_673 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Điểm thi THPT:", -1))
const _hoisted_674 = { class: "fw-semibold text-gray-800" }
const _hoisted_675 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_676 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Chứng chỉ:", -1))
const _hoisted_677 = { class: "fw-semibold text-gray-800" }
const _hoisted_678 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_679 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Điểm:", -1))
const _hoisted_680 = { class: "fw-semibold text-gray-800" }
const _hoisted_681 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_682 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Ngày thi / Thời hạn:", -1))
const _hoisted_683 = { class: "fw-semibold text-gray-800" }
const _hoisted_684 = { class: "row mt-3" }
const _hoisted_685 = { class: "col-12" }
const _hoisted_686 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_687 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_688 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa đăng ký thi xếp lớp Tiếng Anh", -1))
const _hoisted_689 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_690 = { class: "card-body py-3 umt-form" }
const _hoisted_691 = { class: "row g-3 mb-2" }
const _hoisted_692 = { class: "col-md-6 d-flex" }
const _hoisted_693 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7" }, "Không kiểm tra xếp lớp Tiếng Anh"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Bắt đầu chương trình Tiếng Anh tại UMT từ cấp độ Tiếng Anh 1")
], -1))
const _hoisted_694 = { class: "col-md-6 d-flex" }
const _hoisted_695 = { class: "d-flex flex-column" }
const _hoisted_696 = { class: "fw-bolder fs-7" }
const _hoisted_697 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Xếp lớp theo điểm Tiếng Anh của kỳ thi tốt nghiệp THPT", -1))
const _hoisted_698 = { class: "col-md-6 d-flex" }
const _hoisted_699 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7" }, "Đăng ký kiểm tra xếp lớp Tiếng Anh do UMT tổ chức"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Ngày thi xếp lớp được xếp theo lịch của trường")
], -1))
const _hoisted_700 = { class: "col-md-6 d-flex" }
const _hoisted_701 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7" }, "Có chứng chỉ Tiếng Anh còn hạn"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8" }, "Còn hạn tối thiểu 06 tháng — các loại chứng chỉ Trường UMT chấp nhận")
], -1))
const _hoisted_702 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-4 mt-3 mb-2"
}
const _hoisted_703 = { class: "fw-bolder text-gray-800 fs-7 mb-3" }
const _hoisted_704 = { class: "row g-3" }
const _hoisted_705 = { class: "col-4" }
const _hoisted_706 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded p-4 mt-3 mb-2"
}
const _hoisted_707 = { class: "row g-3" }
const _hoisted_708 = { class: "col-12" }
const _hoisted_709 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Tên chứng chỉ", -1))
const _hoisted_710 = {
  key: 0,
  class: "col-4"
}
const _hoisted_711 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Điểm", -1))
const _hoisted_712 = { class: "form-label fw-bold mb-1" }
const _hoisted_713 = { class: "col-4" }
const _hoisted_714 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 d-block" }, "Ngày thi", -1))
const _hoisted_715 = { class: "col-4" }
const _hoisted_716 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1 d-block" }, "Thời hạn", -1))
const _hoisted_717 = { class: "mt-4" }
const _hoisted_718 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_719 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "kt_account_deactivate_account_submit",
  type: "submit",
  class: "btn btn-primary fw-bold"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_720 = {
  key: 3,
  class: "card mb-5 mb-xl-5"
}
const _hoisted_721 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_722 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_723 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_724 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_725 = { key: 0 }
const _hoisted_726 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_727 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_728 = {
  id: "kt_account_deactivate",
  class: "collapse show"
}
const _hoisted_729 = { class: "card-body border-top p-9 pt-4 pb-2" }
const _hoisted_730 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_731 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "BHYT:", -1))
const _hoisted_732 = { class: "fw-semibold text-gray-800" }
const _hoisted_733 = {
  key: 0,
  class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200"
}
const _hoisted_734 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Nơi KCB ban đầu:", -1))
const _hoisted_735 = { class: "fw-semibold text-gray-800" }
const _hoisted_736 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_737 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Mã số thẻ:", -1))
const _hoisted_738 = { class: "fw-semibold text-gray-800" }
const _hoisted_739 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_740 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Hiệu lực đến:", -1))
const _hoisted_741 = { class: "fw-semibold text-gray-800" }
const _hoisted_742 = {
  key: 2,
  class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200"
}
const _hoisted_743 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Lý do không ĐK:", -1))
const _hoisted_744 = { class: "fw-semibold text-gray-800" }
const _hoisted_745 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_746 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "BH tai nạn (UMT tài trợ):", -1))
const _hoisted_747 = { class: "fw-semibold text-gray-800" }
const _hoisted_748 = {
  key: 3,
  class: "d-flex gap-3 mb-2"
}
const _hoisted_749 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Tổng tiền:", -1))
const _hoisted_750 = { class: "fw-bolder text-danger" }
const _hoisted_751 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_752 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_753 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chỉnh sửa đăng ký bảo hiểm", -1))
const _hoisted_754 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_755 = { class: "card-body border-top p-9 pt-0" }
const _hoisted_756 = { class: "row" }
const _hoisted_757 = { class: "mt-4" }
const _hoisted_758 = { class: "row ps-5 rounded border-gray-500 border-1 border-gray-300 border-dashed px-3 py-3 mb-6" }
const _hoisted_759 = { class: "col-12 px-0" }
const _hoisted_760 = { class: "mt-3 mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_761 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_762 = { class: "fw-bolder fs-6 mb-0" }
const _hoisted_763 = { class: "text-muted fs-6" }
const _hoisted_764 = {
  key: 0,
  class: "ps-12"
}
const _hoisted_765 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 col-lg-6 col-md-6 col-12 white-space-nowrap" }, "Nơi đăng ký khám chữa bệnh ban đầu", -1))
const _hoisted_766 = { class: "fv-row col-lg-6 col-md-6 col-12" }
const _hoisted_767 = { class: "fv-plugins-message-container" }
const _hoisted_768 = { class: "fv-help-block" }
const _hoisted_769 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_770 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_771 = { class: "fw-bolder fs-6 mb-0" }
const _hoisted_772 = { class: "text-muted fs-6" }
const _hoisted_773 = {
  key: 1,
  class: "ps-12 row"
}
const _hoisted_774 = { class: "col-lg-5 col-md-5 col-12 d-flex gap-3 mb-lg-3 mb-md-3" }
const _hoisted_775 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 white-space-nowrap" }, "Mã số thẻ", -1))
const _hoisted_776 = { class: "fv-row" }
const _hoisted_777 = { class: "fv-plugins-message-container" }
const _hoisted_778 = { class: "fv-help-block" }
const _hoisted_779 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 white-space-nowrap" }, "Thời gian còn hiệu lực", -1))
const _hoisted_780 = { class: "fv-row" }
const _hoisted_781 = { class: "d-none" }
const _hoisted_782 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_783 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 mb-0" }, " Không đăng ký thẻ BHYT")
], -1))
const _hoisted_784 = {
  key: 2,
  class: "row ps-12"
}
const _hoisted_785 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-semibold fs-7 text-gray-700 mb-2" }, "Lý do", -1))
const _hoisted_786 = { class: "fv-row col-lg-8 col-12" }
const _hoisted_787 = { class: "d-none" }
const _hoisted_788 = { class: "fv-plugins-message-container" }
const _hoisted_789 = { class: "fv-help-block" }
const _hoisted_790 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_791 = { class: "col-12" }
const _hoisted_792 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder fs-6 mb-4 ms-12" }, " Đăng ký bảo hiểm tai nạn (Trường UMT tài trợ) ", -1))
const _hoisted_793 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_794 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_795 = { class: "fs-6 mb-0" }
const _hoisted_796 = { class: "col-lg-4 col-md-12 col-12 d-flex align-items-start justify-content-center" }
const _hoisted_797 = {
  key: 0,
  class: "mt-4 w-100 notice bg-light-primary rounded border-primary border border-dashed mb-9 p-6"
}
const _hoisted_798 = {
  key: 0,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_799 = {
  key: 1,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_800 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_801 = { class: "text-end" }
const _hoisted_802 = { class: "text-danger fw-bolder fs-4" }
const _hoisted_803 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_804 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "kt_account_deactivate_account_submit",
  type: "submit",
  class: "btn btn-primary fw-bold"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_805 = {
  key: 4,
  class: "card mb-5 mb-xl-5"
}
const _hoisted_806 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_807 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_808 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_809 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_810 = {
  id: "",
  class: "collapse show"
}
const _hoisted_811 = { class: "card-body border-top p-9 pt-4" }
const _hoisted_812 = { class: "row mb-6" }
const _hoisted_813 = { class: "row" }
const _hoisted_814 = {
  key: 0,
  class: "col-lg-4 col-md-4 col-12"
}
const _hoisted_815 = {
  id: "carouselExampleIndicators",
  class: "carousel slide",
  "data-bs-ride": "carousel",
  "data-bs-touch": "true",
  "data-bs-interval": "true"
}
const _hoisted_816 = /*#__PURE__*/_createStaticVNode("<div class=\"carousel-indicators\" data-v-1f8ccf2d><button type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide-to=\"0\" class=\"active\" aria-current=\"true\" aria-label=\"Slide 1\" data-v-1f8ccf2d></button><button type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide-to=\"1\" aria-label=\"Slide 2\" data-v-1f8ccf2d></button><button type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide-to=\"2\" aria-label=\"Slide 3\" data-v-1f8ccf2d></button><button type=\"button\" data-bs-target=\"#carouselExampleIndicators\" data-bs-slide-to=\"3\" aria-label=\"Slide 3\" data-v-1f8ccf2d></button></div><div class=\"carousel-inner\" data-v-1f8ccf2d><div class=\"carousel-item active\" data-bs-interval=\"2000\" data-v-1f8ccf2d><img src=\"/media/images/ao.png\" class=\"d-block w-100 h-200px object-fit-contain\" alt=\"...\" data-v-1f8ccf2d></div><div class=\"carousel-item\" data-bs-interval=\"2000\" data-v-1f8ccf2d><img src=\"/media/images/ao-1.png\" class=\"d-block w-100 h-200px object-fit-contain\" alt=\"...\" data-v-1f8ccf2d></div><div class=\"carousel-item\" data-bs-interval=\"2000\" data-v-1f8ccf2d><img src=\"/media/images/quan.png\" class=\"d-block w-100 h-200px object-fit-contain\" alt=\"...\" data-v-1f8ccf2d></div><div class=\"carousel-item\" data-bs-interval=\"2000\" data-v-1f8ccf2d><img src=\"/media/images/quan-1.png\" class=\"d-block w-100 h-200px object-fit-contain\" alt=\"...\" data-v-1f8ccf2d></div></div>", 2)
const _hoisted_818 = {
  class: "carousel-control-prev",
  type: "button",
  "data-bs-target": "#carouselExampleIndicators",
  "data-bs-slide": "prev"
}
const _hoisted_819 = {
  "aria-hidden": "true",
  class: "svg-icon svg-icon-gray svg-icon-2 me-2"
}
const _hoisted_820 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Previous", -1))
const _hoisted_821 = {
  class: "carousel-control-next",
  type: "button",
  "data-bs-target": "#carouselExampleIndicators",
  "data-bs-slide": "next"
}
const _hoisted_822 = {
  "aria-hidden": "true",
  class: "svg-icon svg-icon-gray svg-icon-2 me-2"
}
const _hoisted_823 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Next", -1))
const _hoisted_824 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_825 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Đồng phục thể dục (tặng):", -1))
const _hoisted_826 = { class: "fw-semibold text-gray-800" }
const _hoisted_827 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_828 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-2 cursor-pointer" }, "Thay đổi size", -1))
const _hoisted_829 = [
  _hoisted_828
]
const _hoisted_830 = { class: "d-flex gap-3 mb-2 pb-2 border-bottom border-gray-200" }
const _hoisted_831 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-800 fw-bolder min-w-120px flex-shrink-0" }, "Mua thêm sản phẩm:", -1))
const _hoisted_832 = { class: "fw-semibold text-gray-800" }
const _hoisted_833 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary p-2 cursor-pointer" }, "Mua thêm", -1))
const _hoisted_834 = [
  _hoisted_833
]
const _hoisted_835 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 mt-3\" data-v-1f8ccf2d><span data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_create_size\" class=\"min-w-button-edit text-primary cursor-pointer d-flex\" data-v-1f8ccf2d>Bảng size tham khảo</span></div><div class=\"row\" data-v-1f8ccf2d><div class=\"col-12\" data-v-1f8ccf2d><h6 class=\"fw-bolder fs-5 pt-3\" data-v-1f8ccf2d> Trường UMT tặng bạn các sản phẩm sau: </h6><div class=\"d-flex justify-content-center wrap-gift-img\" data-v-1f8ccf2d><img src=\"/media/images/BO-QUA-TANG-SV-HINH-ANH-08.png\" alt=\"\" data-v-1f8ccf2d><img src=\"/media/images/BO-QUA-TANG-SV-HINH-ANH-13.png\" alt=\"\" data-v-1f8ccf2d><img src=\"/media/images/BO-QUA-TANG-SV-HINH-ANH-01.png\" alt=\"\" data-v-1f8ccf2d><img src=\"/media/images/BO-QUA-TANG-SV-HINH-ANH-14.png\" alt=\"\" data-v-1f8ccf2d><img src=\"/media/images/BO-QUA-TANG-SV-HINH-ANH-09.png\" alt=\"\" data-v-1f8ccf2d><img src=\"/media/images/BO-QUA-TANG-SV-HINH-ANH-07.png\" alt=\"\" data-v-1f8ccf2d></div></div></div>", 2)
const _hoisted_837 = { class: "d-flex flex-stack fs-6 mb-2" }
const _hoisted_838 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_839 = {
  key: 0,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_840 = { class: "" }
const _hoisted_841 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_842 = { class: "text-end" }
const _hoisted_843 = { class: "text-danger fw-bolder fs-4" }
const _hoisted_844 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_845 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_846 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Chọn size đồng phục thể dục", -1))
const _hoisted_847 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_848 = { class: "card-body py-3" }
const _hoisted_849 = { class: "fv-plugins-message-container" }
const _hoisted_850 = { class: "fv-help-block" }
const _hoisted_851 = { class: "w-100" }
const _hoisted_852 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-bold fs-6 white-space-nowrap mb-3" }, "Chọn size", -1))
const _hoisted_853 = { class: "d-none" }
const _hoisted_854 = {
  class: "nav-group nav-group-outline",
  "data-kt-buttons": "true"
}
const _hoisted_855 = ["onClick"]
const _hoisted_856 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "data-bs-toggle": "modal",
    "data-bs-target": "#kt_modal_create_size",
    class: "min-w-button-edit text-primary cursor-pointer d-flex"
  }, "Bảng size tham khảo")
], -1))
const _hoisted_857 = { class: "card-footer d-flex justify-content-end py-4 px-9" }
const _hoisted_858 = {
  class: "btn btn-primary",
  ref: "submitButton5"
}
const _hoisted_859 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu ", -1))
const _hoisted_860 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_861 = [
  _hoisted_859,
  _hoisted_860
]
const _hoisted_862 = { style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_863 = { class: "d-flex align-items-center justify-content-between mb-4 px-3 pt-2" }
const _hoisted_864 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Mua thêm sản phẩm", -1))
const _hoisted_865 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_866 = { class: "card-body py-3" }
const _hoisted_867 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_868 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_869 = {
  key: 0,
  class: "w-100"
}
const _hoisted_870 = { class: "fw-bolder fs-6" }
const _hoisted_871 = { key: 1 }
const _hoisted_872 = { class: "fw-bolder fs-6" }
const _hoisted_873 = {
  key: 2,
  class: "w-100 d-flex gap-2"
}
const _hoisted_874 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-semibold fs-7 text-gray-700 mb-2" }, "Chọn size", -1))
const _hoisted_875 = {
  class: "nav-group d-flex flex-center",
  "data-kt-buttons": "true"
}
const _hoisted_876 = ["onClick"]
const _hoisted_877 = { class: "w-100 d-flex gap-2" }
const _hoisted_878 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required fw-semibold fs-7 text-gray-700 mb-2 w-80px" }, "Số lượng", -1))
const _hoisted_879 = { class: "d-flex gap-2 flex-center" }
const _hoisted_880 = ["onClick"]
const _hoisted_881 = { class: "badge badge-secondary d-flex flex-center w-30px h-30px" }
const _hoisted_882 = ["onClick"]
const _hoisted_883 = { class: "col-lg-6 col-md-6 col-12 wrap-img-item" }
const _hoisted_884 = ["src"]
const _hoisted_885 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_886 = { class: "card-footer d-flex justify-content-end py-4 px-9" }
const _hoisted_887 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu ", -1))
const _hoisted_888 = [
  _hoisted_887
]
const _hoisted_889 = { class: "card mb-5 mb-xl-5 umt-fee-neutral" }
const _hoisted_890 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_891 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_892 = { class: "d-flex align-items-center gap-2" }
const _hoisted_893 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_894 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_895 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle fs-4 text-primary" }, null, -1))
const _hoisted_896 = [
  _hoisted_895
]
const _hoisted_897 = { key: 0 }
const _hoisted_898 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_899 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_900 = {
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_901 = { class: "d-flex align-items-start justify-content-between mb-4" }
const _hoisted_902 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-4 umt-drawer-title text-gray-900",
  style: {"font-weight":"700"}
}, "Ghi chú — Thông tin học phí", -1))
const _hoisted_903 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_904 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_905 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-2" }, "Các khoản lấy từ đâu", -1))
const _hoisted_906 = {
  class: "fs-7 text-gray-700",
  style: {"line-height":"1.7"}
}
const _hoisted_907 = { class: "mb-2" }
const _hoisted_908 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mức học phí", -1))
const _hoisted_909 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_910 = { class: "mb-2" }
const _hoisted_911 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Ưu đãi", -1))
const _hoisted_912 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_913 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "1 ưu đãi chính", -1))
const _hoisted_914 = { class: "mb-2" }
const _hoisted_915 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Học bổng", -1))
const _hoisted_916 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_917 = {
  key: 3,
  class: "text-gray-500"
}
const _hoisted_918 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
  /*#__PURE__*/_createTextVNode("• "),
  /*#__PURE__*/_createElementVNode("b", null, "Miễn giảm anh/chị/em ruột"),
  /*#__PURE__*/_createTextVNode(" — nhập Mã hồ sơ + họ tên người thân ngay trong form.")
], -1))
const _hoisted_919 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Miễn giảm Tiếng Anh / môn học vượt", -1))
const _hoisted_920 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_921 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-2" }, "Cách tính (theo thứ tự)"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "fs-7 text-gray-700",
    style: {"line-height":"1.7"}
  }, [
    /*#__PURE__*/_createTextVNode(" Học phí gói → trừ miễn giảm Tiếng Anh → cộng môn học vượt / trừ môn được miễn → trừ miễn giảm anh/chị/em ruột → trừ ưu đãi (loại "),
    /*#__PURE__*/_createElementVNode("b", null, "%"),
    /*#__PURE__*/_createTextVNode(" tính trên số tiền còn lại sau các bước trước) → trừ "),
    /*#__PURE__*/_createElementVNode("b", null, "học bổng sau cùng"),
    /*#__PURE__*/_createTextVNode(" = "),
    /*#__PURE__*/_createElementVNode("b", null, "Tổng cộng"),
    /*#__PURE__*/_createTextVNode("."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Học bổng theo "),
    /*#__PURE__*/_createElementVNode("b", null, "%"),
    /*#__PURE__*/_createTextVNode(" tính trên học phí đã trừ "),
    /*#__PURE__*/_createElementVNode("b", null, "toàn bộ"),
    /*#__PURE__*/_createTextVNode(" ưu đãi ở các bước trên."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("b", null, "Tạm tính"),
    /*#__PURE__*/_createTextVNode(" = Tổng cộng − các khoản đã đóng (phí giữ chỗ, phiếu thu đã lập). ")
  ])
], -1))
const _hoisted_922 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-800 mb-2" }, "Lưu ý cho người phụ trách"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "fs-7 text-gray-700",
    style: {"line-height":"1.7"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
      /*#__PURE__*/_createTextVNode("• Thấy nút "),
      /*#__PURE__*/_createElementVNode("b", null, "\"Cập nhật Khuyến mãi\" / \"Cập nhật lại Học bổng\""),
      /*#__PURE__*/_createTextVNode(" nghĩa là ưu đãi đã lưu hết hạn hoặc học bổng vừa thay đổi — bấm để chọn lại, số tiền sẽ tính theo chương trình hiện hành.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
      /*#__PURE__*/_createTextVNode("• Khối này "),
      /*#__PURE__*/_createElementVNode("b", null, "khóa"),
      /*#__PURE__*/_createTextVNode(" khi phiếu thu đã khóa hoặc hồ sơ thuộc diện chuyển giao.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
      /*#__PURE__*/_createTextVNode("• Hồ sơ đã "),
      /*#__PURE__*/_createElementVNode("b", null, "Hoàn tất"),
      /*#__PURE__*/_createTextVNode(" hoặc "),
      /*#__PURE__*/_createElementVNode("b", null, "Đã hủy"),
      /*#__PURE__*/_createTextVNode(" bị "),
      /*#__PURE__*/_createElementVNode("b", null, "khóa chỉnh sửa toàn bộ"),
      /*#__PURE__*/_createTextVNode(" (đã sinh MSV/đẩy SIS — sửa tiếp gây lệch dữ liệu).")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
      /*#__PURE__*/_createTextVNode("• "),
      /*#__PURE__*/_createElementVNode("b", null, "\"Gửi báo phí\""),
      /*#__PURE__*/_createTextVNode(" (trong mục này, hồ sơ chưa hoàn tất) gửi email bảng tạm tính NHÁP; hồ sơ Hoàn tất dùng nút "),
      /*#__PURE__*/_createElementVNode("b", null, "\"Gửi email báo phí\""),
      /*#__PURE__*/_createTextVNode(" cuối trang.")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, [
      /*#__PURE__*/_createTextVNode("• "),
      /*#__PURE__*/_createElementVNode("b", null, "Cấp trước - chờ điều kiện"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hourglass-split text-warning" }),
      /*#__PURE__*/_createTextVNode(": bạn ĐƯỢC PHÉP chọn ưu đãi/học bổng khi ứng viên CHƯA thỏa điều kiện (vd chưa đóng phí giữ suất) — hệ thống sẽ hiện "),
      /*#__PURE__*/_createElementVNode("b", null, "cảnh báo vàng"),
      /*#__PURE__*/_createTextVNode(" liệt kê các khoản này và hỏi xác nhận khi Lưu. Lưu xong, "),
      /*#__PURE__*/_createElementVNode("b", null, "cổng nhập học của ứng viên sẽ ẨN và KHÔNG trừ"),
      /*#__PURE__*/_createTextVNode(" các khoản đó (hiện ở nhóm \"Chờ thỏa điều kiện\") cho tới khi ứng viên hoàn thành — nên "),
      /*#__PURE__*/_createElementVNode("b", null, "Tổng tiền 2 bên sẽ lệch trong thời gian chờ, đó KHÔNG phải lỗi"),
      /*#__PURE__*/_createTextVNode(". Nhớ dặn ứng viên hoàn thành điều kiện đúng hạn; mỗi lần lưu kiểu này đều được ghi vào "),
      /*#__PURE__*/_createElementVNode("b", null, "Ghi chú"),
      /*#__PURE__*/_createTextVNode(" của ứng viên để truy vết.")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createTextVNode("• Xác nhận & in phiếu ưu đãi/học bổng: tab "),
      /*#__PURE__*/_createElementVNode("b", null, "\"Xác nhận ưu đãi/học bổng\""),
      /*#__PURE__*/_createTextVNode(" trên trang này.")
    ])
  ])
], -1))
const _hoisted_923 = { class: "card-body border-top p-6 pt-4 position-relative" }
const _hoisted_924 = {
  key: 0,
  class: "wrap-click-to-update"
}
const _hoisted_925 = { class: "svg-icon svg-icon-primary svg-icon-2x ms-1" }
const _hoisted_926 = { class: "svg-icon svg-icon-primary svg-icon-2x ms-1" }
const _hoisted_927 = {
  key: 0,
  class: "notice bg-light-warning rounded border-warning border border-dashed p-4 mb-5"
}
const _hoisted_928 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left-right text-warning fs-3 me-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800" }, "Mức ưu đãi đã bị sửa sau khi ứng viên chọn")
], -1))
const _hoisted_929 = { class: "fs-7 text-gray-800 ps-6" }
const _hoisted_930 = { class: "mb-1" }
const _hoisted_931 = { class: "text-danger" }
const _hoisted_932 = { class: "mb-2" }
const _hoisted_933 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_934 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-2" }, "Bỏ xong nhớ báo lại mức phí mới cho ứng viên trước khi kế toán thu tiền.", -1))
const _hoisted_935 = { class: "row" }
const _hoisted_936 = { class: "d-flex flex-wrap align-items-center gap-3 mb-4" }
const _hoisted_937 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder required fs-5 mb-0 flex-shrink-0" }, "Thí sinh chọn mức học phí", -1))
const _hoisted_938 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 mb-0" }, "Ưu đãi đặc biệt dành riêng cho bạn")
], -1))
const _hoisted_939 = { class: "mb-3" }
const _hoisted_940 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_941 = ["onChange", "value"]
const _hoisted_942 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_943 = { class: "fs-6 mb-0" }
const _hoisted_944 = { class: "mb-4 form-check-label d-flex flex-column align-items-start" }
const _hoisted_945 = { class: "mb-3" }
const _hoisted_946 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_947 = ["value", "onUpdate:modelValue"]
const _hoisted_948 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_949 = { class: "fs-6 mb-0" }
const _hoisted_950 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_951 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 mb-0" }, "Ưu đãi cộng thêm")
], -1))
const _hoisted_952 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_953 = ["checked", "onChange"]
const _hoisted_954 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_955 = { class: "fs-6 mb-0" }
const _hoisted_956 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded p-4 mb-3 mt-4"
}
const _hoisted_957 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 text-danger mb-0" }, "Ưu đãi đóng phí sớm")
], -1))
const _hoisted_958 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_959 = ["value", "disabled"]
const _hoisted_960 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_961 = { class: "fs-6 mb-0" }
const _hoisted_962 = {
  key: 0,
  class: "fs-7 text-gray-600 mt-1"
}
const _hoisted_963 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Với điều kiện:", -1))
const _hoisted_964 = {
  key: 0,
  class: "mb-0 ps-4"
}
const _hoisted_965 = { key: 1 }
const _hoisted_966 = {
  key: 2,
  class: "w-100 notice bg-light-warning rounded border-warning border border-dashed mb-3 p-4"
}
const _hoisted_967 = { class: "mb-4 form-check-label d-flex flex-column align-items-start" }
const _hoisted_968 = { class: "fw-bolder fs-6 mb-0" }
const _hoisted_969 = { class: "mb-3" }
const _hoisted_970 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_971 = ["value"]
const _hoisted_972 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_973 = { class: "fs-6 mb-0" }
const _hoisted_974 = { class: "mb-4 form-check-label d-flex flex-column align-items-start" }
const _hoisted_975 = { class: "fw-bolder fs-6 mb-0" }
const _hoisted_976 = { class: "mb-3" }
const _hoisted_977 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_978 = ["name", "value", "checked"]
const _hoisted_979 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_980 = { class: "fs-6 mb-0" }
const _hoisted_981 = { class: "mb-3" }
const _hoisted_982 = {
  key: 0,
  class: ""
}
const _hoisted_983 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Đăng ký miễn giảm học phí")
], -1))
const _hoisted_984 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_985 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 mb-0" }, "Anh/chị/em ruột đang là sinh viên chính thức của UMT")
], -1))
const _hoisted_986 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "pt-0 pb-1 required fw-semibold fs-7 text-gray-700 mb-2" }, "Mã hồ sơ", -1))
const _hoisted_987 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "pt-0 pb-1 required fw-semibold fs-7 text-gray-700 mb-2" }, "Họ và tên", -1))
const _hoisted_988 = {
  key: 1,
  class: "w-100 rounded border border-gray-300 border-dashed p-4 mb-3"
}
const _hoisted_989 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start mt-3" }
const _hoisted_990 = ["value", "disabled"]
const _hoisted_991 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_992 = { class: "text-transform-capitalize fw-bolder fs-6 mb-0" }
const _hoisted_993 = {
  key: 0,
  class: "fs-6 fw-normal text-underline"
}
const _hoisted_994 = { key: 0 }
const _hoisted_995 = {
  key: 0,
  class: "mb-4 form-check-label d-flex flex-column align-items-start"
}
const _hoisted_996 = { class: "fw-bolder fs-6 mb-0" }
const _hoisted_997 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_998 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_999 = ["name", "value", "checked"]
const _hoisted_1000 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_1001 = { class: "fs-6 mb-0" }
const _hoisted_1002 = { class: "mb-4 form-check-label d-flex flex-column align-items-start" }
const _hoisted_1003 = {
  key: 0,
  class: "mb-4 mt-2 p-4 rounded bg-light-primary w-100"
}
const _hoisted_1004 = { class: "fw-bold fs-7 text-gray-700 mb-3" }
const _hoisted_1005 = { class: "text-primary text-transform-capitalize" }
const _hoisted_1006 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded p-4 mb-3 mt-4"
}
const _hoisted_1007 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_1008 = ["value"]
const _hoisted_1009 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_1010 = { class: "fs-6 mb-0" }
const _hoisted_1011 = {
  key: 0,
  class: "fs-7 text-gray-600 mt-1"
}
const _hoisted_1012 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Với điều kiện:", -1))
const _hoisted_1013 = {
  key: 0,
  class: "mb-0 ps-4"
}
const _hoisted_1014 = { key: 1 }
const _hoisted_1015 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded p-4 mb-3 mt-4"
}
const _hoisted_1016 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3 form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7 fw-normal text-muted fst-italic" }, "Ưu đãi áp dụng khi hoàn thành đóng phí đúng hạn theo điều kiện bên dưới.")
], -1))
const _hoisted_1017 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_1018 = ["checked", "onChange"]
const _hoisted_1019 = { class: "form-check-label d-flex flex-column align-items-start" }
const _hoisted_1020 = { class: "fs-6 mb-0" }
const _hoisted_1021 = {
  key: 0,
  class: "fs-7 text-gray-600 mt-1"
}
const _hoisted_1022 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Với điều kiện:", -1))
const _hoisted_1023 = {
  key: 0,
  class: "mb-0 ps-4"
}
const _hoisted_1024 = { key: 1 }
const _hoisted_1025 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-6" }, null, -1))
const _hoisted_1026 = { class: "bg-light rounded p-5" }
const _hoisted_1027 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3 mb-4 border-bottom border-gray-300" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-5 text-gray-900" }, "Kết quả xếp lớp Tiếng Anh (UMT tổ chức)"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7 mt-1" }, "Nhập điểm & cấp độ → hệ thống tự tính miễn giảm / học vượt Tiếng Anh vào học phí (điểm dùng chung với mục \"Đăng ký thi xếp lớp Tiếng Anh\").")
], -1))
const _hoisted_1028 = { class: "row g-3" }
const _hoisted_1029 = { class: "col-md-4 col-12" }
const _hoisted_1030 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Điểm kiểm tra", -1))
const _hoisted_1031 = { class: "col-md-8 col-12" }
const _hoisted_1032 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bold mb-1" }, "Cấp độ Tiếng Anh được học", -1))
const _hoisted_1033 = { class: "col-lg-6 col-12" }
const _hoisted_1034 = {
  key: 0,
  class: "w-100 notice bg-light-success rounded border-success border border-dashed mb-9 p-3"
}
const _hoisted_1035 = { class: "d-flex flex-stack fs-6 mb-2 fw-bolder" }
const _hoisted_1036 = { class: "ps-4" }
const _hoisted_1037 = {
  key: 0,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1038 = { class: "text-danger" }
const _hoisted_1039 = { class: "" }
const _hoisted_1040 = { class: "text-danger" }
const _hoisted_1041 = {
  key: 3,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1042 = { key: 0 }
const _hoisted_1043 = { class: "text-danger" }
const _hoisted_1044 = ["onClick"]
const _hoisted_1045 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1046 = [
  _hoisted_1045
]
const _hoisted_1047 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1048 = ["onClick"]
const _hoisted_1049 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1050 = [
  _hoisted_1049
]
const _hoisted_1051 = { class: "text-danger text-nowrap" }
const _hoisted_1052 = {
  key: 5,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1053 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1054 = [
  _hoisted_1053
]
const _hoisted_1055 = { class: "text-danger" }
const _hoisted_1056 = {
  key: 6,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1057 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1058 = [
  _hoisted_1057
]
const _hoisted_1059 = { class: "text-danger" }
const _hoisted_1060 = {
  key: 7,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1061 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1062 = [
  _hoisted_1061
]
const _hoisted_1063 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1064 = { class: "" }
const _hoisted_1065 = { class: "text-danger" }
const _hoisted_1066 = {
  key: 1,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1067 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1068 = [
  _hoisted_1067
]
const _hoisted_1069 = { class: "text-danger" }
const _hoisted_1070 = ["onClick"]
const _hoisted_1071 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1072 = [
  _hoisted_1071
]
const _hoisted_1073 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1074 = {
  key: 2,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1075 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-lg text-gray-500 fs-8" }, null, -1))
const _hoisted_1076 = [
  _hoisted_1075
]
const _hoisted_1077 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1078 = {
  key: 3,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1079 = { class: "" }
const _hoisted_1080 = {
  key: 0,
  class: "text-muted fs-8 ms-1"
}
const _hoisted_1081 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1082 = { class: "text-end d-flex flex-stack" }
const _hoisted_1083 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bolder fs-4" }, "Tổng cộng", -1))
const _hoisted_1084 = { class: "text-primary fw-bolder fs-4" }
const _hoisted_1085 = { class: "ps-4" }
const _hoisted_1086 = { class: "text-danger text-nowrap" }
const _hoisted_1087 = { key: 0 }
const _hoisted_1088 = {
  key: 1,
  class: "text-end d-flex flex-stack"
}
const _hoisted_1089 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bolder fs-4" }, "Tạm tính", -1))
const _hoisted_1090 = { class: "text-primary fw-bolder fs-4" }
const _hoisted_1091 = {
  key: 1,
  class: "text-end"
}
const _hoisted_1092 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope me-1" }),
  /*#__PURE__*/_createTextVNode("Gửi báo phí")
], -1))
const _hoisted_1093 = [
  _hoisted_1092
]
const _hoisted_1094 = {
  key: 1,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_1095 = {
  key: 0,
  class: "text-danger mt-3 me-3"
}
const _hoisted_1096 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu "),
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
    /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
    /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
  ])
], -1))
const _hoisted_1097 = { class: "card mb-5 mb-xl-5" }
const _hoisted_1098 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_1099 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_1100 = { class: "d-flex align-items-center gap-2" }
const _hoisted_1101 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_1102 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_1103 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_1104 = { key: 0 }
const _hoisted_1105 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_1106 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_1107 = {
  id: "kt_account_connected_accounts",
  class: "collapse show"
}
const _hoisted_1108 = { class: "card-body border-top px-9" }
const _hoisted_1109 = { class: "row" }
const _hoisted_1110 = { class: "col-12 order-2" }
const _hoisted_1111 = { class: "mb-3" }
const _hoisted_1112 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_1113 = ["value", "disabled"]
const _hoisted_1114 = { class: "w-100 form-check-label d-flex flex-column align-items-start" }
const _hoisted_1115 = { class: "fw-bolder fs-6 mb-0" }
const _hoisted_1116 = ["innerHTML"]
const _hoisted_1117 = { class: "col-12 order-1 mb-4" }
const _hoisted_1118 = {
  key: 0,
  class: "w-100 notice rounded border-gray-300 border border-dashed umt-bill p-6"
}
const _hoisted_1119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-4 pb-3 border-bottom border-gray-300 border-dashed" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 text-gray-900" }, "Phiếu học phí (tạm tính)")
], -1))
const _hoisted_1120 = { class: "d-flex flex-stack fs-6 mb-2 fw-bolder" }
const _hoisted_1121 = { class: "ps-4" }
const _hoisted_1122 = {
  key: 0,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1123 = { class: "text-danger" }
const _hoisted_1124 = { class: "" }
const _hoisted_1125 = { class: "text-danger" }
const _hoisted_1126 = {
  key: 3,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1127 = { key: 0 }
const _hoisted_1128 = { class: "text-danger" }
const _hoisted_1129 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1130 = { class: "text-danger text-nowrap" }
const _hoisted_1131 = {
  key: 5,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1132 = { class: "text-danger" }
const _hoisted_1133 = {
  key: 6,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1134 = { class: "text-danger" }
const _hoisted_1135 = {
  key: 7,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1136 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1137 = { class: "text-danger" }
const _hoisted_1138 = {
  key: 1,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1139 = { class: "text-danger" }
const _hoisted_1140 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1141 = {
  key: 2,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1142 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1143 = {
  key: 3,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1144 = { class: "" }
const _hoisted_1145 = {
  key: 0,
  class: "text-muted fs-8 ms-1"
}
const _hoisted_1146 = {
  key: 0,
  class: "text-danger text-nowrap"
}
const _hoisted_1147 = {
  key: 0,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1148 = {
  key: 1,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1149 = { class: "d-flex flex-stack fs-6 mb-2" }
const _hoisted_1150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_1151 = {
  key: 0,
  class: "d-flex flex-stack fs-6 mb-2"
}
const _hoisted_1152 = { class: "" }
const _hoisted_1153 = { class: "text-end d-flex flex-stack" }
const _hoisted_1154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bolder fs-4" }, "Tổng cộng", -1))
const _hoisted_1155 = { class: "text-primary fw-bolder fs-4" }
const _hoisted_1156 = { class: "ps-4" }
const _hoisted_1157 = { class: "text-danger text-nowrap" }
const _hoisted_1158 = { key: 0 }
const _hoisted_1159 = {
  key: 1,
  class: "text-end d-flex flex-stack"
}
const _hoisted_1160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bolder fs-4" }, "Tạm tính", -1))
const _hoisted_1161 = { class: "text-primary fw-bolder fs-4" }
const _hoisted_1162 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_1163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu ", -1))
const _hoisted_1164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_1165 = [
  _hoisted_1163,
  _hoisted_1164
]
const _hoisted_1166 = {
  key: 5,
  class: "card mb-5 mb-xl-5"
}
const _hoisted_1167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_connected_sum_phee",
  "aria-expanded": "true",
  "aria-controls": "kt_account_connected_sum_phee"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Hồ sơ minh chứng")
  ])
], -1))
const _hoisted_1168 = {
  id: "kt_account_connected_sum_phee",
  class: "collapse show"
}
const _hoisted_1169 = { class: "card-body border-top p-9" }
const _hoisted_1170 = { class: "form-group" }
const _hoisted_1171 = {
  id: "id_dropzone",
  class: "dropzone"
}
const _hoisted_1172 = { class: "svg-icon svg-icon-2 me-1 c-svg-icon-blue" }
const _hoisted_1173 = { class: "pt-5 d-flex gap-5 flex-wrap" }
const _hoisted_1174 = { class: "" }
const _hoisted_1175 = {
  key: 0,
  class: "wrap-img-file"
}
const _hoisted_1176 = { class: "symbol mb-5" }
const _hoisted_1177 = ["src"]
const _hoisted_1178 = { class: "progress" }
const _hoisted_1179 = ["id"]
const _hoisted_1180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-text" }, null, -1))
const _hoisted_1181 = [
  _hoisted_1180
]
const _hoisted_1182 = {
  key: 1,
  class: "wrap-img-file position-relative w-100 h-100 d-block"
}
const _hoisted_1183 = ["src"]
const _hoisted_1184 = {
  key: 1,
  class: "symbol mb-5"
}
const _hoisted_1185 = ["src"]
const _hoisted_1186 = {
  key: 2,
  class: "ribbon-custom ribbon ribbon-start ribbon-clip"
}
const _hoisted_1187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ribbon-label" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng phân loại file "),
  /*#__PURE__*/_createElementVNode("span", { class: "ribbon-inner bg-danger" })
], -1))
const _hoisted_1188 = [
  _hoisted_1187
]
const _hoisted_1189 = { class: "abs-close-img flex-column" }
const _hoisted_1190 = ["onClick"]
const _hoisted_1191 = { class: "svg-icon svg-icon-danger svg-icon-2" }
const _hoisted_1192 = { class: "abs-view-img flex-column" }
const _hoisted_1193 = ["href"]
const _hoisted_1194 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":"0.8"}
}
const _hoisted_1195 = { class: "card mb-5 mb-xl-5" }
const _hoisted_1196 = { class: "card-header border-0 cursor-pointer" }
const _hoisted_1197 = { class: "card-title m-0 d-flex flex-stack w-100" }
const _hoisted_1198 = { class: "fw-bolder fs-6 text-gray-800 text-uppercase m-0 d-flex align-items-center" }
const _hoisted_1199 = {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}
const _hoisted_1200 = {
  key: 0,
  class: "fw-400 fs-6"
}
const _hoisted_1201 = { key: 0 }
const _hoisted_1202 = { class: "btn btn-sm btn-light btn-active-light-primary" }
const _hoisted_1203 = { class: "svg-icon svg-icon-primary svg-icon-2 me-2" }
const _hoisted_1204 = {
  id: "kt_account_connected_accounts",
  class: "collapse show"
}
const _hoisted_1205 = { class: "card-body border-top px-9" }
const _hoisted_1206 = { class: "row" }
const _hoisted_1207 = { class: "mb-3" }
const _hoisted_1208 = { class: "d-flex gap-5" }
const _hoisted_1209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder fs-6 mb-0" }, " Đăng ký hỗ trợ tài chính ", -1))
const _hoisted_1210 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_1211 = ["disabled"]
const _hoisted_1212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 mb-0" }, "Có")
], -1))
const _hoisted_1213 = { class: "mb-3 form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_1214 = ["disabled"]
const _hoisted_1215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6 mb-0" }, "Không")
], -1))
const _hoisted_1216 = { key: 0 }
const _hoisted_1217 = { class: "fv-row ps-10" }
const _hoisted_1218 = { class: "row" }
const _hoisted_1219 = { class: "col-12" }
const _hoisted_1220 = ["disabled", "value"]
const _hoisted_1221 = { class: "fs-6 mb-0" }
const _hoisted_1222 = {
  key: 0,
  class: "customer-text-bank alert alert-danger d-flex align-items-center p-1 mb-0"
}
const _hoisted_1223 = { class: "svg-icon svg-icon-2 svg-icon-danger me-1" }
const _hoisted_1224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-danger fs-8 m-0" }, " Ngân hàng chưa hỗ trợ tài chính tại địa phương ")
], -1))
const _hoisted_1225 = {
  key: 0,
  class: "card-footer d-flex justify-content-end py-6 px-9"
}
const _hoisted_1226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu ", -1))
const _hoisted_1227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_1228 = [
  _hoisted_1226,
  _hoisted_1227
]
const _hoisted_1229 = { class: "card mb-5 mb-xl-10" }
const _hoisted_1230 = {
  id: "kt_account_policy",
  class: "collapse show"
}
const _hoisted_1231 = {
  id: "kt_account_eng_form",
  class: "form"
}
const _hoisted_1232 = { class: "card-body border-top px-9" }
const _hoisted_1233 = { class: "row" }
const _hoisted_1234 = /*#__PURE__*/_createStaticVNode("<span class=\"symbol symbol-40px me-3 flex-shrink-0\" data-v-1f8ccf2d><span class=\"symbol-label bg-light-success\" data-v-1f8ccf2d><i class=\"bi bi-check-circle-fill text-success fs-3\" data-v-1f8ccf2d></i></span></span><div class=\"text-start\" data-v-1f8ccf2d><div class=\"fw-bold fs-6 text-gray-900\" data-v-1f8ccf2d>Đã hoàn tất nhập học</div><div class=\"text-muted fs-7\" data-v-1f8ccf2d>Ứng viên đã được xác nhận. Có thể gửi lại email báo phí nếu cần.</div></div>", 2)
const _hoisted_1236 = /*#__PURE__*/_createStaticVNode("<span class=\"symbol symbol-40px me-3 flex-shrink-0\" data-v-1f8ccf2d><span class=\"symbol-label bg-light-warning\" data-v-1f8ccf2d><i class=\"bi bi-hourglass-split text-warning fs-3\" data-v-1f8ccf2d></i></span></span><div class=\"text-start\" data-v-1f8ccf2d><div class=\"fw-bold fs-6 text-gray-900\" data-v-1f8ccf2d>Chờ xác nhận hoàn tất</div><div class=\"text-muted fs-7\" data-v-1f8ccf2d>Kiểm tra thông tin rồi bấm Xác nhận hoàn tất để chốt hồ sơ.</div></div>", 2)
const _hoisted_1238 = /*#__PURE__*/_createStaticVNode("<span class=\"symbol symbol-40px me-3 flex-shrink-0\" data-v-1f8ccf2d><span class=\"symbol-label bg-light-danger\" data-v-1f8ccf2d><i class=\"bi bi-slash-circle text-danger fs-3\" data-v-1f8ccf2d></i></span></span><div class=\"text-start\" data-v-1f8ccf2d><div class=\"fw-bold fs-6 text-gray-900\" data-v-1f8ccf2d>Phiếu đã hủy</div><div class=\"text-muted fs-7\" data-v-1f8ccf2d>Ứng viên đã chuyển sang hồ sơ nhập học khác — phiếu này chỉ để xem/truy vết.</div></div>", 2)
const _hoisted_1240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-40px me-3 flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-light-primary" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square text-primary fs-3" })
  ])
], -1))
const _hoisted_1241 = { class: "text-start" }
const _hoisted_1242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-900" }, "Hồ sơ đang xử lý", -1))
const _hoisted_1243 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_1244 = {
  key: 1,
  class: "text-muted fs-7"
}
const _hoisted_1245 = ["title"]
const _hoisted_1246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-range me-1" }, null, -1))
const _hoisted_1247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1))
const _hoisted_1248 = ["disabled", "title"]
const _hoisted_1249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1))
const _hoisted_1250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope me-1" }, null, -1))
const _hoisted_1251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Gửi email báo phí", -1))
const _hoisted_1252 = [
  _hoisted_1250,
  _hoisted_1251
]
const _hoisted_1253 = ["disabled", "title"]
const _hoisted_1254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-circle me-1" }),
  /*#__PURE__*/_createTextVNode("Xác nhận hoàn tất")
], -1))
const _hoisted_1255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Vui lòng chờ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_1256 = [
  _hoisted_1254,
  _hoisted_1255
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_studiedEnglish = _resolveComponent("studiedEnglish")!
  const _component_beingEmployed = _resolveComponent("beingEmployed")!
  const _component_workOnProject = _resolveComponent("workOnProject")!
  const _component_other = _resolveComponent("other")!
  const _component_Form = _resolveComponent("Form")!
  const _component_EnglishExemptionRefTable = _resolveComponent("EnglishExemptionRefTable")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_policy = _resolveComponent("policy")!
  const _component_tableSize = _resolveComponent("tableSize")!
  const _component_guidePicture = _resolveComponent("guidePicture")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isFinalApplicant && _ctx.isSuperAdmin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["notice rounded border border-dashed d-flex align-items-center flex-wrap gap-3 p-4 mb-5", _ctx.finalEditMode ? 'bg-light-danger border-danger' : 'bg-light-warning border-warning'])
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["bi fs-2", _ctx.finalEditMode ? 'bi-unlock-fill text-danger' : 'bi-lock-fill text-warning'])
          }, null, 2),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.finalEditMode)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_2,
                  _createTextVNode(" — lý do: "),
                  _createElementVNode("i", null, "\"" + _toDisplayString(_ctx.finalEditReason) + "\"", 1),
                  _createTextVNode(". Mỗi lần Lưu đều ghi vào lịch sử hồ sơ và đẩy lại SIS. ")
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_3,
                  _createTextVNode(" — các mục đang khóa. Bật chỉnh sửa để sửa thông tin (phải nhập lý do). ")
                ], 64))
          ]),
          (!_ctx.finalEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-sm btn-warning text-nowrap",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.enableFinalEdit()))
              }, [
                _hoisted_4,
                _createTextVNode("Bật chỉnh sửa ")
              ]))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-sm btn-light text-nowrap",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.disableFinalEdit()))
              }, [
                _hoisted_5,
                _createTextVNode("Tắt chỉnh sửa ")
              ]))
        ], 2))
      : _createCommentVNode("", true),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives((_openBlock(), _createElementBlock("span", {
                class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3 min-w-button-edit",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.isSubmitQr = true), ["prevent"]))
              }, [
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                  ]),
                  _createTextVNode(" Chỉnh sửa ")
                ])
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", {
              id: "kt_account_deactivate_form",
              class: "form",
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitQrCode()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  class: _normalizeClass(["notice bg-light-warning rounded border-warning border border-dashed p-6", _ctx.isMobile ? '' : 'd-flex'])
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["svg-icon svg-icon-5tx svg-icon-black me-4", _ctx.isMobile ? 'float-left' : ''])
                  }, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/ecommerce/ecm010.svg" })
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["", _ctx.isMobile ? '' : 'd-flex flex-stack flex-grow-1'])
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h4", {
                        class: _normalizeClass(["text-gray-800 fw-bolder gap-10", _ctx.isMobile ? 'mobile-css-qrcode' : 'd-flex flex-stack'])
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["", _ctx.isMobile ? '' : 'd-flex gap-5 flex-stack'])
                        }, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "certificateBarcode",
                              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                              modelValue: _ctx.certificateBarcode,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.certificateBarcode) = $event)),
                              placeholder: "Nhập mã số",
                              disabled: !_ctx.isSubmitQr
                            }, null, 8, ["modelValue", "disabled"]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_ErrorMessage, { name: "certificateBarcode" })
                              ])
                            ])
                          ]),
                          (_ctx.isSubmitQr)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(_ctx.isMobile ? 'ps-25 mb-3' : '')
                              }, [
                                _createElementVNode("button", {
                                  type: "submit",
                                  id: "kt_account_profile_details_qrcode",
                                  class: "btn btn-primary me-2",
                                  disabled: _ctx.certificateBarcode == ''
                                }, _hoisted_22, 8, _hoisted_19),
                                _createElementVNode("span", {
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSubmitQr = false)),
                                  class: "btn btn-white btn-active-light-primary"
                                }, " Hủy bỏ ")
                              ], 2))
                            : _createCommentVNode("", true)
                        ], 2),
                        _hoisted_23
                      ], 2),
                      _hoisted_24
                    ])
                  ], 2)
                ], 2)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("h3", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.sectionNo.personal), 1),
              _createTextVNode("Thông tin cá nhân")
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isPersonalFilled ? 'badge-light-success' : 'badge-light-warning'])
            }, _toDisplayString(_ctx.isPersonalFilled ? '✓ Đã điền' : 'Chưa điền'), 3)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [
                (!_ctx.editProfileDetails)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {
              _ctx.openEditProfileDrawer();
            }, ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_32, [
                        _createElementVNode("span", _hoisted_33, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        id: "kt_account_profile_details",
        class: _normalizeClass([{
        'notice bg-light-danger rounded border-danger border border-dashed error-form':
          _ctx.isErrorFormProfileDetails,
      }, "collapse show"])
      }, [
        _createElementVNode("div", _hoisted_34, [
          (_ctx.missingImportant.length)
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 0,
                type: "warning",
                closable: false,
                "show-icon": "",
                class: "mb-4"
              }, {
                title: _withCtx(() => [
                  _hoisted_35,
                  _createTextVNode(" " + _toDisplayString(_ctx.missingImportant.join(', ')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formData.familyName) + " " + _toDisplayString(_ctx.formData.middleName) + " " + _toDisplayString(_ctx.formData.givenName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.formData.dateOfBirth ? _ctx.moment(_ctx.formData.dateOfBirth) : '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formData.placeOfBirth || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formData.gender == "male"
                    ? "Nam"
                    : _ctx.formData.gender == "female"
                    ? "Nữ"
                    : _ctx.formData.gender
                    ? "Khác"
                    : "—"), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.formData.nationality || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formData.ethnic || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formData.religion || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.formData.idNumber || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.formData.issuedDate ? _ctx.moment(_ctx.formData.issuedDate) : '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.formData.issuedBy || '—'), 1)
              ])
            ]),
            (_ctx.formData.enrolledUmt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _createElementVNode("i", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.formData.enrolledUmt || '—'), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_el_drawer, {
          onClose: _ctx.blurActiveEl,
          modelValue: _ctx.editProfileDetails,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editProfileDetails) = $event)),
          direction: "rtl",
          size: "600px",
          "with-header": false,
          "append-to-body": "",
          "before-close": (done)=>{ _ctx.initFormData(); done() }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _createElementVNode("span", {
                  class: "btn btn-sm btn-icon btn-active-light-primary",
                  title: "Đóng",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetDataInfo()))
                }, [
                  _createElementVNode("span", _hoisted_84, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              (_ctx.missingImportant.length)
                ? (_openBlock(), _createBlock(_component_el_alert, {
                    key: 0,
                    type: "warning",
                    closable: false,
                    "show-icon": "",
                    class: "mb-4 mx-3"
                  }, {
                    title: _withCtx(() => [
                      _hoisted_85,
                      _createTextVNode(" " + _toDisplayString(_ctx.missingImportant.join(', ')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form, {
                model: _ctx.formData,
                class: "form",
                id: "kt_account_profile_details_form",
                onSubmit: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.saveChanges1()), ["prevent"])),
                rules: _ctx.profileDetailsValidator,
                ref: "submitButton1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createVNode(_component_el_input, {
                          type: "text",
                          class: "w-100 input-custom text-transform-capitalize",
                          placeholder: "Nhập họ và tên đầy đủ",
                          modelValue: _ctx.fullName,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fullName) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        _hoisted_91,
                        _createVNode(_component_el_form_item, { prop: "dateOfBirth" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.formData.dateOfBirth,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.dateOfBirth) = $event)),
                              name: "dateOfBirth",
                              placeholder: "Ngày/tháng/năm",
                              format: "DD/MM/YYYY",
                              value: _ctx.formData.dateOfBirth,
                              class: "w-100"
                            }, null, 8, ["modelValue", "value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createVNode(_component_el_form_item, { prop: "placeOfBirth" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              "popper-class": "umt-form-dd",
                              filterable: "",
                              placeholder: "Nơi sinh",
                              modelValue: _ctx.formData.placeOfBirth,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.placeOfBirth) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince.map((i) => {
                        return { value: i.name, label: i.name };
                      }), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_94, [
                        _hoisted_95,
                        _createVNode(_component_el_form_item, { prop: "gender" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              "popper-class": "umt-form-dd",
                              placeholder: "Giới tính",
                              modelValue: _ctx.formData.gender,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.gender) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                      { value: 'male', label: 'Nam' },
                      { value: 'female', label: 'Nữ' },
                      { value: 'other', label: 'Khác' },
                    ], (item) => {
                                  return _createVNode(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"])
                                }), 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _hoisted_97,
                        _createVNode(_component_el_form_item, { prop: "religion" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              "popper-class": "umt-form-dd",
                              filterable: "",
                              placeholder: "Tôn giáo",
                              modelValue: _ctx.formData.religion,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.religion) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrReligion, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createVNode(_component_el_form_item, { prop: "ethnic" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              "popper-class": "umt-form-dd",
                              filterable: "",
                              placeholder: "Dân tộc",
                              modelValue: _ctx.formData.ethnic,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.ethnic) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrEthnic, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createVNode(_component_el_form_item, { prop: "nationality" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              "popper-class": "umt-form-dd",
                              filterable: "",
                              placeholder: "Quốc tịch",
                              modelValue: _ctx.formData.nationality,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.nationality) = $event))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrNational, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _createVNode(_component_el_form_item, { prop: "idNumber" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              class: "w-100 input-custom",
                              placeholder: "CMND/CCCD",
                              modelValue: _ctx.formData.idNumber,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.idNumber) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _hoisted_105,
                        _createVNode(_component_el_form_item, { prop: "issuedDate" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.formData.issuedDate,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.issuedDate) = $event)),
                              name: "issuedDate",
                              placeholder: "Ngày/tháng/năm",
                              format: "DD/MM/YYYY",
                              class: "w-100"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        _hoisted_107,
                        _createVNode(_component_el_form_item, { prop: "issuedBy" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-select-solid w-100",
                              "popper-class": "umt-form-dd",
                              placeholder: "Nơi cấp",
                              modelValue: _ctx.formData.issuedBy,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.issuedBy) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Bộ công an",
                                  value: "Bộ công an"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Bộ công an")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội",
                                  value: "Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Cục trưởng Cục cảnh sát quản lý hành chính về trật tự xã hội")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid w-100",
                          "popper-class": "umt-form-dd",
                          placeholder: "Loại Đào tạo",
                          disabled: _ctx.dataInitial?.status == 'confirmed',
                          modelValue: _ctx.formData.programtype,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.programtype) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsPrograms, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_110, [
                        _createElementVNode("label", _hoisted_111, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input m-0 float-none",
                            name: "enrolledUmt",
                            value: true,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.isUmter) = $event)),
                            id: "enrolledUmt",
                            type: "checkbox"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.isUmter]
                          ]),
                          _hoisted_112
                        ]),
                        (_ctx.isUmter)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              prop: "enrolledUmt"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  class: "w-100 input-custom",
                                  placeholder: "MSSV",
                                  modelValue: _ctx.formData.enrolledUmt,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.enrolledUmt) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("span", {
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.resetDataInfo && _ctx.resetDataInfo(...args))),
                      class: "btn btn-white btn-active-light-primary me-2"
                    }, " Hủy bỏ "),
                    _hoisted_114
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "modelValue", "before-close"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_115, [
      _createElementVNode("div", _hoisted_116, [
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("h3", _hoisted_119, [
              _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.sectionNo.party), 1),
              _createTextVNode("Thông tin Đoàn, Đảng")
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isPartyFilled ? 'badge-light-success' : 'badge-light text-muted'])
            }, _toDisplayString(_ctx.isPartyFilled ? '✓ Đã điền' : 'Không bắt buộc'), 3)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_121, [
                (!_ctx.editPartyInfo)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.editPartyInfo = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_122, [
                        _createElementVNode("span", _hoisted_123, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_124, [
        _createElementVNode("div", _hoisted_125, [
          _createElementVNode("div", _hoisted_126, [
            _createElementVNode("div", _hoisted_127, [
              _hoisted_128,
              _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.moreinfo.dateOfParty ? _ctx.moment(_ctx.moreinfo.dateOfParty) : '—'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("div", _hoisted_131, [
              _hoisted_132,
              _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.moreinfo.placeOfParty || '—'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_134, [
            _createElementVNode("div", _hoisted_135, [
              _hoisted_136,
              _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.moreinfo.dateOfGroup ? _ctx.moment(_ctx.moreinfo.dateOfGroup) : '—'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_138, [
            _createElementVNode("div", _hoisted_139, [
              _hoisted_140,
              _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.moreinfo.placeOfGroup || '—'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _hoisted_144,
              _createElementVNode("div", _hoisted_145, [
                _createElementVNode("input", {
                  class: "form-check-input m-0 float-none",
                  name: "dvct",
                  value: true,
                  checked: _ctx.moreinfo.isReserveParty,
                  type: "checkbox"
                }, null, 8, _hoisted_146)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("div", _hoisted_148, [
              _hoisted_149,
              _createElementVNode("div", _hoisted_150, [
                _createElementVNode("input", {
                  class: "form-check-input m-0 float-none",
                  name: "dvct",
                  value: true,
                  checked: _ctx.moreinfo.isParty,
                  type: "checkbox"
                }, null, 8, _hoisted_151)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_el_drawer, {
        onClose: _ctx.blurActiveEl,
        modelValue: _ctx.editPartyInfo,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.editPartyInfo) = $event)),
        direction: "rtl",
        size: "440px",
        "with-header": false,
        "append-to-body": "",
        "before-close": (done)=>{ _ctx.initMoreinfo(); done() }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_152, [
            _createElementVNode("div", _hoisted_153, [
              _hoisted_154,
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary",
                title: "Đóng",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.resetPartyInfo()))
              }, [
                _createElementVNode("span", _hoisted_155, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_156, [
              _createElementVNode("div", _hoisted_157, [
                _createElementVNode("div", _hoisted_158, [
                  _hoisted_159,
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.moreinfo.dateOfParty,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.moreinfo.dateOfParty) = $event)),
                    name: "issuedDate",
                    placeholder: "Ngày/tháng/năm",
                    format: "DD/MM/YYYY",
                    class: "w-100"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_160, [
                  _hoisted_161,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "placeOfParty",
                    class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                    placeholder: "Nơi kết nạp",
                    modelValue: _ctx.moreinfo.placeOfParty,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.moreinfo.placeOfParty) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_162, [
                  _hoisted_163,
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.moreinfo.dateOfGroup,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.moreinfo.dateOfGroup) = $event)),
                    name: "issuedDate",
                    placeholder: "Ngày/tháng/năm",
                    format: "DD/MM/YYYY",
                    class: "w-100"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_164, [
                  _hoisted_165,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "placeOfGroup",
                    class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                    placeholder: "Nơi kết nạp",
                    modelValue: _ctx.moreinfo.placeOfGroup,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.moreinfo.placeOfGroup) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_166, [
                  _createElementVNode("label", _hoisted_167, [
                    _hoisted_168,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input m-0 float-none",
                      name: "dvdb",
                      value: true,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.moreinfo.isReserveParty) = $event)),
                      id: "dvdb",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.moreinfo.isReserveParty]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("label", _hoisted_170, [
                    _hoisted_171,
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input m-0 float-none",
                      name: "dvct",
                      value: true,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.moreinfo.isParty) = $event)),
                      id: "dvct",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.moreinfo.isParty]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_172, [
              _createElementVNode("span", {
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.resetPartyInfo())),
                class: "btn btn-white btn-active-light-primary me-2"
              }, "Hủy bỏ"),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.savePartyInfo && _ctx.savePartyInfo(...args)))
              }, "Lưu thay đổi")
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "modelValue", "before-close"])
    ]),
    _createElementVNode("div", _hoisted_173, [
      _createElementVNode("div", _hoisted_174, [
        _createElementVNode("div", _hoisted_175, [
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("h3", _hoisted_177, [
              _createElementVNode("span", _hoisted_178, _toDisplayString(_ctx.sectionNo.contact), 1),
              _createTextVNode("Thông tin liên lạc")
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isContactFilled ? 'badge-light-success' : 'badge-light-warning'])
            }, _toDisplayString(_ctx.isContactFilled ? '✓ Đã điền' : 'Chưa điền'), 3)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_179, [
                (!_ctx.editPersonalContacts)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[35] || (_cache[35] = _withModifiers(($event: any) => {
              _ctx.editPersonalContacts = true;
              _ctx.isErrorFormPersonalContacts = false;
            }, ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_180, [
                        _createElementVNode("span", _hoisted_181, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        id: "kt_account_signin_method",
        class: _normalizeClass([{
        'notice bg-light-danger rounded border-danger border border-dashed error-form':
          _ctx.isErrorFormPersonalContacts,
      }, "collapse show"])
      }, [
        _createElementVNode("div", _hoisted_182, [
          _createElementVNode("div", _hoisted_183, [
            (_ctx.missingContact.length)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                  class: "mb-4"
                }, {
                  title: _withCtx(() => [
                    _hoisted_184,
                    _createTextVNode(" " + _toDisplayString(_ctx.missingContact.join(', ')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_185, [
              _createElementVNode("div", _hoisted_186, [
                _createElementVNode("div", _hoisted_187, [
                  _hoisted_188,
                  _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.personalContacts.contactMobile || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_190, [
                _createElementVNode("div", _hoisted_191, [
                  _hoisted_192,
                  _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.personalContacts.contactEmail || '—'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_194, [
              _hoisted_195,
              _createElementVNode("div", _hoisted_196, [
                _createElementVNode("div", _hoisted_197, [
                  _createElementVNode("div", _hoisted_198, [
                    _hoisted_199,
                    _createElementVNode("div", _hoisted_200, _toDisplayString(_ctx.personalContacts.permanentAddress || '—'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_201, [
                  _createElementVNode("div", _hoisted_202, [
                    _hoisted_203,
                    _createElementVNode("div", _hoisted_204, _toDisplayString(_ctx.personalContacts.permanentWard || '—'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_205, [
                  _createElementVNode("div", _hoisted_206, [
                    _hoisted_207,
                    _createElementVNode("div", _hoisted_208, _toDisplayString(_ctx.personalContacts.permanentProvince || '—'), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_209, [
              _hoisted_210,
              _createElementVNode("div", _hoisted_211, [
                _createElementVNode("div", _hoisted_212, [
                  _createElementVNode("div", _hoisted_213, [
                    _hoisted_214,
                    _createElementVNode("div", _hoisted_215, _toDisplayString(_ctx.personalContacts.postalAddress || '—'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_216, [
                  _createElementVNode("div", _hoisted_217, [
                    _hoisted_218,
                    _createElementVNode("div", _hoisted_219, _toDisplayString(_ctx.personalContacts.postalWard || '—'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_220, [
                  _createElementVNode("div", _hoisted_221, [
                    _hoisted_222,
                    _createElementVNode("div", _hoisted_223, _toDisplayString(_ctx.personalContacts.postalProvince || '—'), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_224, [
              _createVNode(_component_el_drawer, {
                onClose: _ctx.blurActiveEl,
                modelValue: _ctx.editPersonalContacts,
                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.editPersonalContacts) = $event)),
                direction: "rtl",
                size: "600px",
                "with-header": false,
                "append-to-body": "",
                "before-close": (done)=>{ _ctx.initDataPersonalContacts(); done() }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_225, [
                    _createElementVNode("div", _hoisted_226, [
                      _hoisted_227,
                      _createElementVNode("span", {
                        class: "btn btn-sm btn-icon btn-active-light-primary",
                        title: "Đóng",
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.resetPersonalContacts()))
                      }, [
                        _createElementVNode("span", _hoisted_228, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                        ])
                      ])
                    ]),
                    (_ctx.missingContact.length)
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          type: "warning",
                          closable: false,
                          "show-icon": "",
                          class: "mb-4 mx-3"
                        }, {
                          title: _withCtx(() => [
                            _hoisted_229,
                            _createTextVNode(" " + _toDisplayString(_ctx.missingContact.join(', ')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form, {
                      model: _ctx.personalContacts,
                      class: "form",
                      id: "kt_signin_change_email",
                      onSubmit: _cache[47] || (_cache[47] = _withModifiers(($event: any) => (_ctx.saveChanges2()), ["prevent"])),
                      rules: _ctx.personalContactsValidator,
                      ref: "submitButton2"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_230, [
                          (_ctx.editPersonalContacts)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_231, [
                                  _hoisted_232,
                                  _createElementVNode("div", _hoisted_233, [
                                    _createElementVNode("div", _hoisted_234, [
                                      _hoisted_235,
                                      _createVNode(_component_el_form_item, { prop: "contactMobile" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            type: "text",
                                            class: "w-100 input-custom",
                                            placeholder: "Số di động",
                                            modelValue: _ctx.personalContacts.contactMobile,
                                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.personalContacts.contactMobile) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_236, [
                                      _hoisted_237,
                                      _createVNode(_component_el_form_item, { prop: "contactEmail" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            type: "text",
                                            class: "w-100 input-custom",
                                            placeholder: "Email",
                                            modelValue: _ctx.personalContacts.contactEmail,
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.personalContacts.contactEmail) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_238, [
                                  _hoisted_239,
                                  _createElementVNode("div", _hoisted_240, [
                                    _createElementVNode("div", _hoisted_241, [
                                      _hoisted_242,
                                      _createVNode(_component_el_form_item, { prop: "newPermanentProvinceCode" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "form-select-solid w-100",
                                            "popper-class": "umt-form-dd",
                                            filterable: "",
                                            placeholder: "Tỉnh/Thành phố",
                                            onChange: _ctx.permanentProvinceChange,
                                            modelValue: _ctx.personalContacts.newPermanentProvinceCode,
                                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.personalContacts.newPermanentProvinceCode) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newProvinceOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["onChange", "modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_243, [
                                      _hoisted_244,
                                      _createVNode(_component_el_form_item, { prop: "newPermanentWardCode" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "form-select-solid w-100",
                                            "popper-class": "umt-form-dd",
                                            filterable: "",
                                            placeholder: "Phường/xã",
                                            modelValue: _ctx.personalContacts.newPermanentWardCode,
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.personalContacts.newPermanentWardCode) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataWard, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.id,
                                                  label: item.name,
                                                  value: item.id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_245, [
                                      _hoisted_246,
                                      _createVNode(_component_el_form_item, { prop: "permanentAddress" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            type: "text",
                                            class: "w-100 input-custom",
                                            placeholder: "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)",
                                            modelValue: _ctx.personalContacts.permanentAddress,
                                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.personalContacts.permanentAddress) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_247, [
                                  _createElementVNode("div", _hoisted_248, [
                                    _hoisted_249,
                                    _createElementVNode("span", _hoisted_250, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        id: "checkPostalSameContact",
                                        onChange: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.autofillPostalFromPermanent && _ctx.autofillPostalFromPermanent(...args)))
                                      }, null, 32),
                                      _hoisted_251
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_252, [
                                    _createElementVNode("div", _hoisted_253, [
                                      _hoisted_254,
                                      _createVNode(_component_el_form_item, { prop: "newPostalProvinceCode" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "form-select-solid w-100",
                                            "popper-class": "umt-form-dd",
                                            filterable: "",
                                            placeholder: "Tỉnh/Thành phố",
                                            onChange: _ctx.postalProvinceChange,
                                            modelValue: _ctx.personalContacts.newPostalProvinceCode,
                                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.personalContacts.newPostalProvinceCode) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newProvinceOptions, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.value,
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["onChange", "modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_255, [
                                      _hoisted_256,
                                      _createVNode(_component_el_form_item, { prop: "newPostalWardCode" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_select, {
                                            class: "form-select-solid w-100",
                                            "popper-class": "umt-form-dd",
                                            filterable: "",
                                            placeholder: "Phường/xã",
                                            modelValue: _ctx.personalContacts.newPostalWardCode,
                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.personalContacts.newPostalWardCode) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPostalWard, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.id,
                                                  label: item.name,
                                                  value: item.id
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_257, [
                                      _hoisted_258,
                                      _createVNode(_component_el_form_item, { prop: "postalAddress" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_input, {
                                            type: "text",
                                            class: "w-100 input-custom",
                                            placeholder: "Địa chỉ sau sáp nhập (Số nhà, tên đường, khu phố)",
                                            modelValue: _ctx.personalContacts.postalAddress,
                                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.personalContacts.postalAddress) = $event))
                                          }, null, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.editPersonalContacts)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                                _createElementVNode("span", {
                                  onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.resetPersonalContacts())),
                                  class: "btn btn-white btn-active-light-primary me-2"
                                }, " Hủy bỏ "),
                                _hoisted_260
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ])
                ]),
                _: 1
              }, 8, ["onClose", "modelValue", "before-close"])
            ])
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_261, [
      _createElementVNode("div", _hoisted_262, [
        _createElementVNode("div", _hoisted_263, [
          _createElementVNode("div", _hoisted_264, [
            _createElementVNode("h3", _hoisted_265, [
              _createElementVNode("span", _hoisted_266, _toDisplayString(_ctx.sectionNo.relatives), 1),
              _createTextVNode("Thông tin người thân")
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isRelativesFilled ? 'badge-light-success' : 'badge-light-warning'])
            }, _toDisplayString(_ctx.isRelativesFilled ? '✓ Đã điền' : (_ctx.relativesHasData ? 'Còn thiếu' : 'Chưa điền')), 3),
            (!_ctx.isRelativesFilled && _ctx.relativesMissing.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_267, " Thiếu: " + _toDisplayString(_ctx.relativesMissing.join(' · ')), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_268, [
                (!_ctx.editRelatives)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[49] || (_cache[49] = _withModifiers(($event: any) => (_ctx.editRelatives = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_269, [
                        _createElementVNode("span", _hoisted_270, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_271, [
        _createElementVNode("div", _hoisted_272, [
          _createElementVNode("div", _hoisted_273, [
            _createElementVNode("div", _hoisted_274, [
              _hoisted_275,
              _createElementVNode("div", _hoisted_276, [
                _createElementVNode("div", _hoisted_277, [
                  _hoisted_278,
                  _createElementVNode("div", _hoisted_279, _toDisplayString(_ctx.personalContacts.father.fullName || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_280, [
                _createElementVNode("div", _hoisted_281, [
                  _hoisted_282,
                  _createElementVNode("div", _hoisted_283, _toDisplayString(_ctx.personalContacts.father.dateOfBirth ? _ctx.moment(_ctx.personalContacts.father.dateOfBirth) : '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_284, [
                _createElementVNode("div", _hoisted_285, [
                  _hoisted_286,
                  _createElementVNode("div", _hoisted_287, _toDisplayString(_ctx.personalContacts.father.occupation || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_288, [
                _createElementVNode("div", _hoisted_289, [
                  _hoisted_290,
                  _createElementVNode("div", _hoisted_291, _toDisplayString(_ctx.personalContacts.father.mobile || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_292, [
                _createElementVNode("div", _hoisted_293, [
                  _hoisted_294,
                  _createElementVNode("div", _hoisted_295, _toDisplayString(_ctx.personalContacts.father.email || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_296, [
                _createElementVNode("div", _hoisted_297, [
                  _hoisted_298,
                  _createElementVNode("div", _hoisted_299, _toDisplayString(_ctx.personalContacts.father.currentAddress || '—'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_300, [
              _hoisted_301,
              _createElementVNode("div", _hoisted_302, [
                _createElementVNode("div", _hoisted_303, [
                  _hoisted_304,
                  _createElementVNode("div", _hoisted_305, _toDisplayString(_ctx.personalContacts.mother.fullName || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_306, [
                _createElementVNode("div", _hoisted_307, [
                  _hoisted_308,
                  _createElementVNode("div", _hoisted_309, _toDisplayString(_ctx.personalContacts.mother.dateOfBirth ? _ctx.moment(_ctx.personalContacts.mother.dateOfBirth) : '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_310, [
                _createElementVNode("div", _hoisted_311, [
                  _hoisted_312,
                  _createElementVNode("div", _hoisted_313, _toDisplayString(_ctx.personalContacts.mother.occupation || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_314, [
                _createElementVNode("div", _hoisted_315, [
                  _hoisted_316,
                  _createElementVNode("div", _hoisted_317, _toDisplayString(_ctx.personalContacts.mother.mobile || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_318, [
                _createElementVNode("div", _hoisted_319, [
                  _hoisted_320,
                  _createElementVNode("div", _hoisted_321, _toDisplayString(_ctx.personalContacts.mother.email || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_322, [
                _createElementVNode("div", _hoisted_323, [
                  _hoisted_324,
                  _createElementVNode("div", _hoisted_325, _toDisplayString(_ctx.personalContacts.mother.currentAddress || '—'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_326, [
              _hoisted_327,
              _createElementVNode("div", _hoisted_328, [
                _createElementVNode("div", _hoisted_329, [
                  _hoisted_330,
                  _createElementVNode("div", _hoisted_331, _toDisplayString(_ctx.personalContacts.guardian.fullName || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_332, [
                _createElementVNode("div", _hoisted_333, [
                  _hoisted_334,
                  _createElementVNode("div", _hoisted_335, _toDisplayString(_ctx.personalContacts.guardian.dateOfBirth ? _ctx.moment(_ctx.personalContacts.guardian.dateOfBirth) : '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_336, [
                _createElementVNode("div", _hoisted_337, [
                  _hoisted_338,
                  _createElementVNode("div", _hoisted_339, _toDisplayString(_ctx.personalContacts.guardian.occupation || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_340, [
                _createElementVNode("div", _hoisted_341, [
                  _hoisted_342,
                  _createElementVNode("div", _hoisted_343, _toDisplayString(_ctx.personalContacts.guardian.mobile || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_344, [
                _createElementVNode("div", _hoisted_345, [
                  _hoisted_346,
                  _createElementVNode("div", _hoisted_347, _toDisplayString(_ctx.personalContacts.guardian.email || '—'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_348, [
                _createElementVNode("div", _hoisted_349, [
                  _hoisted_350,
                  _createElementVNode("div", _hoisted_351, _toDisplayString(_ctx.personalContacts.guardian.currentAddress || '—'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_352, [
              _hoisted_353,
              _createElementVNode("div", _hoisted_354, [
                _createElementVNode("div", _hoisted_355, [
                  _hoisted_356,
                  _createElementVNode("div", _hoisted_357, _toDisplayString([
                      _ctx.personalContacts.father.agreeToReleaseOfStudyProgress ? 'Cha' : '',
                      _ctx.personalContacts.mother.agreeToReleaseOfStudyProgress ? 'Mẹ' : '',
                      _ctx.personalContacts.guardian.agreeToReleaseOfStudyProgress ? 'Người khác' : '',
                    ].filter(Boolean).join(', ') || (_ctx.noneNotifiOfReg ? 'Không đồng ý' : '—')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_358, [
                _createElementVNode("div", _hoisted_359, [
                  _hoisted_360,
                  _createElementVNode("div", _hoisted_361, _toDisplayString([
                      _ctx.personalContacts.father.agreeToContactInEmergency ? 'Cha' : '',
                      _ctx.personalContacts.mother.agreeToContactInEmergency ? 'Mẹ' : '',
                      _ctx.personalContacts.guardian.agreeToContactInEmergency ? 'Người khác' : '',
                    ].filter(Boolean).join(', ') || '—'), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_362, [
              _createVNode(_component_el_drawer, {
                onClose: _ctx.blurActiveEl,
                modelValue: _ctx.editRelatives,
                "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.editRelatives) = $event)),
                direction: "rtl",
                size: _ctx.isMobile ? '100%' : '540px',
                "with-header": false,
                "append-to-body": "",
                "before-close": (done)=>{ _ctx.initDataPersonalContacts(); done() }
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_363, [
                    _createElementVNode("div", _hoisted_364, [
                      _hoisted_365,
                      _createElementVNode("span", {
                        class: "btn btn-sm btn-icon btn-active-light-primary",
                        title: "Đóng",
                        onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.resetRelatives()))
                      }, [
                        _createElementVNode("span", _hoisted_366, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form, {
                      model: _ctx.personalContacts,
                      class: "form",
                      id: "kt_relatives_change",
                      onSubmit: _cache[84] || (_cache[84] = _withModifiers(($event: any) => (_ctx.saveRelatives()), ["prevent"])),
                      rules: _ctx.personalContactsValidator,
                      ref: "submitButtonRelatives"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_367, [
                          (_ctx.editRelatives)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["fw-bold fs-6 text-primary mb-3 mt-4 umt-subhead", 
                      _ctx.personalContacts.father.agreeToReleaseOfStudyProgress ||
                      _ctx.personalContacts.father.agreeToContactInEmergency
                        ? 'required'
                        : ''
                    ])
                                }, " Thông tin Cha ", 2),
                                _createElementVNode("div", _hoisted_368, [
                                  _createElementVNode("div", _hoisted_369, [
                                    _hoisted_370,
                                    _createVNode(_component_el_form_item, {
                                      prop: "father.fullName",
                                      rules: _ctx.rulesFather()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Họ và tên",
                                          modelValue: _ctx.personalContacts.father.fullName,
                                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.personalContacts.father.fullName) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_371, [
                                    _hoisted_372,
                                    _createVNode(_component_el_form_item, {
                                      prop: "father.dateOfBirth",
                                      rules: { required: false }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.personalContacts.father.dateOfBirth,
                                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.personalContacts.father.dateOfBirth) = $event)),
                                          name: "fdateOfBirth",
                                          placeholder: "Ngày/tháng/năm",
                                          format: "DD/MM/YYYY",
                                          class: "w-100"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_373, [
                                    _hoisted_374,
                                    _createVNode(_component_el_form_item, {
                                      prop: "father.occupation",
                                      rules: { required: false }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Nghề nghiệp",
                                          modelValue: _ctx.personalContacts.father.occupation,
                                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.personalContacts.father.occupation) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_375, [
                                    _hoisted_376,
                                    _createVNode(_component_el_form_item, {
                                      prop: "father.mobile",
                                      rules: _ctx.rulesFather()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Di động",
                                          modelValue: _ctx.personalContacts.father.mobile,
                                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.personalContacts.father.mobile) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_377, [
                                    _hoisted_378,
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Email",
                                          modelValue: _ctx.personalContacts.father.email,
                                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.personalContacts.father.email) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_379, [
                                    _hoisted_380,
                                    _createVNode(_component_el_form_item, {
                                      prop: "father.currentAddress",
                                      rules: _ctx.rulesFather()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Nơi ở hiện tại (Địa chỉ sau sáp nhập)",
                                          modelValue: _ctx.personalContacts.father.currentAddress,
                                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.personalContacts.father.currentAddress) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["fw-bold fs-6 text-primary mb-3 mt-4 umt-subhead", 
                      _ctx.personalContacts.mother.agreeToReleaseOfStudyProgress ||
                      _ctx.personalContacts.mother.agreeToContactInEmergency
                        ? 'required'
                        : ''
                    ])
                                }, " Thông tin Mẹ ", 2),
                                _createElementVNode("div", _hoisted_381, [
                                  _createElementVNode("div", _hoisted_382, [
                                    _hoisted_383,
                                    _createVNode(_component_el_form_item, {
                                      prop: "mother.fullName",
                                      rules: _ctx.rulesMother()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Họ và tên",
                                          modelValue: _ctx.personalContacts.mother.fullName,
                                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.personalContacts.mother.fullName) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_384, [
                                    _hoisted_385,
                                    _createVNode(_component_el_form_item, {
                                      prop: "mother.dateOfBirth",
                                      rules: { required: false }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.personalContacts.mother.dateOfBirth,
                                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.personalContacts.mother.dateOfBirth) = $event)),
                                          name: "mdateOfBirth",
                                          placeholder: "Ngày/tháng/năm",
                                          format: "DD/MM/YYYY",
                                          class: "w-100"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_386, [
                                    _hoisted_387,
                                    _createVNode(_component_el_form_item, {
                                      prop: "mother.occupation",
                                      rules: { required: false }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Nghề nghiệp",
                                          modelValue: _ctx.personalContacts.mother.occupation,
                                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.personalContacts.mother.occupation) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_388, [
                                    _hoisted_389,
                                    _createVNode(_component_el_form_item, {
                                      prop: "mother.mobile",
                                      rules: _ctx.rulesMother()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Di động",
                                          modelValue: _ctx.personalContacts.mother.mobile,
                                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.personalContacts.mother.mobile) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_390, [
                                    _hoisted_391,
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Email",
                                          modelValue: _ctx.personalContacts.mother.email,
                                          "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.personalContacts.mother.email) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_392, [
                                    _createElementVNode("div", _hoisted_393, [
                                      _hoisted_394,
                                      _createElementVNode("span", _hoisted_395, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          id: "checkMotherSameFatherAddress",
                                          onChange: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.autofillMotherAddressFromFather && _ctx.autofillMotherAddressFromFather(...args)))
                                        }, null, 32),
                                        _hoisted_396
                                      ])
                                    ]),
                                    _createVNode(_component_el_form_item, {
                                      prop: "mother.currentAddress",
                                      rules: _ctx.rulesMother()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Nơi ở hiện tại (Địa chỉ sau sáp nhập)",
                                          modelValue: _ctx.personalContacts.mother.currentAddress,
                                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.personalContacts.mother.currentAddress) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ])
                                ]),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["fw-bold fs-6 text-primary mb-3 mt-4 umt-subhead", 
                      _ctx.personalContacts.guardian
                        .agreeToReleaseOfStudyProgress ||
                      _ctx.personalContacts.guardian.agreeToContactInEmergency
                        ? 'required'
                        : ''
                    ])
                                }, " Thông tin Người khác ", 2),
                                _createElementVNode("div", _hoisted_397, [
                                  _createElementVNode("div", _hoisted_398, [
                                    _hoisted_399,
                                    _createVNode(_component_el_form_item, {
                                      prop: "guardian.fullName",
                                      rules: _ctx.rulesGuardian()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Họ và tên",
                                          modelValue: _ctx.personalContacts.guardian.fullName,
                                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.personalContacts.guardian.fullName) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_400, [
                                    _hoisted_401,
                                    _createVNode(_component_el_form_item, {
                                      prop: "guardian.dateOfBirth",
                                      rules: { required: false }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.personalContacts.guardian.dateOfBirth,
                                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.personalContacts.guardian.dateOfBirth) = $event)),
                                          name: "gdateOfBirth",
                                          placeholder: "Ngày/tháng/năm",
                                          format: "DD/MM/YYYY",
                                          class: "w-100"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_402, [
                                    _hoisted_403,
                                    _createVNode(_component_el_form_item, {
                                      prop: "guardian.occupation",
                                      rules: { required: false }
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Nghề nghiệp",
                                          modelValue: _ctx.personalContacts.guardian.occupation,
                                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.personalContacts.guardian.occupation) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_404, [
                                    _hoisted_405,
                                    _createVNode(_component_el_form_item, {
                                      prop: "guardian.mobile",
                                      rules: _ctx.rulesGuardian()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Di động",
                                          modelValue: _ctx.personalContacts.guardian.mobile,
                                          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.personalContacts.guardian.mobile) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", _hoisted_406, [
                                    _hoisted_407,
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Email",
                                          modelValue: _ctx.personalContacts.guardian.email,
                                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.personalContacts.guardian.email) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_408, [
                                    _hoisted_409,
                                    _createVNode(_component_el_form_item, {
                                      prop: "guardian.currentAddress",
                                      rules: _ctx.rulesGuardian()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Nơi ở hiện tại (Địa chỉ sau sáp nhập)",
                                          modelValue: _ctx.personalContacts.guardian.currentAddress,
                                          "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.personalContacts.guardian.currentAddress) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_410, [
                            _hoisted_411,
                            _createElementVNode("div", _hoisted_412, [
                              _createElementVNode("div", _hoisted_413, [
                                _hoisted_414,
                                _createElementVNode("div", {
                                  class: _normalizeClass(["d-flex flex-wrap gap-5 umt-consent-checks", { disabled: !_ctx.editRelatives }])
                                }, [
                                  _createElementVNode("label", _hoisted_415, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "agreeToReleaseOfStudyProgress",
                                      "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((
                          _ctx.personalContacts.father.agreeToReleaseOfStudyProgress
                        ) = $event)),
                                      onChange: _cache[71] || (_cache[71] = ($event: any) => (_ctx.changeNoneReleaseOfStudy($event))),
                                      value: true
                                    }, null, 544), [
                                      [_vModelCheckbox, 
                          _ctx.personalContacts.father.agreeToReleaseOfStudyProgress
                        ]
                                    ]),
                                    _hoisted_416
                                  ]),
                                  _createElementVNode("label", _hoisted_417, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "agreeToReleaseOfStudyProgress",
                                      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((
                          _ctx.personalContacts.mother.agreeToReleaseOfStudyProgress
                        ) = $event)),
                                      onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.changeNoneReleaseOfStudy($event))),
                                      value: true
                                    }, null, 544), [
                                      [_vModelCheckbox, 
                          _ctx.personalContacts.mother.agreeToReleaseOfStudyProgress
                        ]
                                    ]),
                                    _hoisted_418
                                  ]),
                                  _createElementVNode("label", _hoisted_419, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "agreeToReleaseOfStudyProgress",
                                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((
                          _ctx.personalContacts.guardian
                            .agreeToReleaseOfStudyProgress
                        ) = $event)),
                                      onChange: _cache[75] || (_cache[75] = ($event: any) => (_ctx.changeNoneReleaseOfStudy($event))),
                                      value: true
                                    }, null, 544), [
                                      [_vModelCheckbox, 
                          _ctx.personalContacts.guardian
                            .agreeToReleaseOfStudyProgress
                        ]
                                    ]),
                                    _hoisted_420
                                  ]),
                                  _createElementVNode("label", _hoisted_421, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "agreeToReleaseOfStudyProgress",
                                      onChange: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.changeAgreeToReleaseOfStudyProgress && _ctx.changeAgreeToReleaseOfStudyProgress(...args))),
                                      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.noneNotifiOfReg) = $event)),
                                      value: true
                                    }, null, 544), [
                                      [_vModelCheckbox, _ctx.noneNotifiOfReg]
                                    ]),
                                    _hoisted_422
                                  ])
                                ], 2),
                                _createVNode(_component_el_form_item, {
                                  class: "mb-0",
                                  prop: "checkAgreeToReleaseOfStudyProgress",
                                  rules: !_ctx.checkAgreeToReleaseOfStudyProgress ? _ctx.rulesDefault: {}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      class: "w-100 input-custom d-none",
                                      placeholder: "",
                                      modelValue: _ctx.checkAgreeToReleaseOfStudyProgress,
                                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.checkAgreeToReleaseOfStudyProgress) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["rules"])
                              ]),
                              _createElementVNode("div", _hoisted_423, [
                                _hoisted_424,
                                _createElementVNode("div", {
                                  class: _normalizeClass(["d-flex flex-wrap gap-5 umt-consent-checks", { disabled: !_ctx.editRelatives }])
                                }, [
                                  _createElementVNode("label", _hoisted_425, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "agreeToContactInEmergency",
                                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((
                          _ctx.personalContacts.father.agreeToContactInEmergency
                        ) = $event)),
                                      value: true
                                    }, null, 512), [
                                      [_vModelCheckbox, 
                          _ctx.personalContacts.father.agreeToContactInEmergency
                        ]
                                    ]),
                                    _hoisted_426
                                  ]),
                                  _createElementVNode("label", _hoisted_427, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "agreeToContactInEmergency",
                                      "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((
                          _ctx.personalContacts.mother.agreeToContactInEmergency
                        ) = $event)),
                                      value: true
                                    }, null, 512), [
                                      [_vModelCheckbox, 
                          _ctx.personalContacts.mother.agreeToContactInEmergency
                        ]
                                    ]),
                                    _hoisted_428
                                  ]),
                                  _createElementVNode("label", _hoisted_429, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      name: "email-preferences1",
                                      "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((
                          _ctx.personalContacts.guardian.agreeToContactInEmergency
                        ) = $event)),
                                      value: true
                                    }, null, 512), [
                                      [_vModelCheckbox, 
                          _ctx.personalContacts.guardian.agreeToContactInEmergency
                        ]
                                    ]),
                                    _hoisted_430
                                  ])
                                ], 2),
                                _createVNode(_component_el_form_item, {
                                  class: "mb-0",
                                  prop: "checkAgreeToContactInEmergency",
                                  rules: !_ctx.checkAgreeToContactInEmergency ? _ctx.rulesDefault: {}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      class: "w-100 input-custom d-none",
                                      placeholder: "",
                                      modelValue: _ctx.checkAgreeToContactInEmergency,
                                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.checkAgreeToContactInEmergency) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["rules"])
                              ])
                            ])
                          ]),
                          (_ctx.editRelatives)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_431, [
                                _createElementVNode("span", {
                                  onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.resetRelatives())),
                                  class: "btn btn-white btn-active-light-primary me-2"
                                }, " Hủy bỏ "),
                                _hoisted_432
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ])
                ]),
                _: 1
              }, 8, ["onClose", "modelValue", "size", "before-close"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_433, [
      _createElementVNode("div", _hoisted_434, [
        _createElementVNode("div", _hoisted_435, [
          _createElementVNode("div", _hoisted_436, [
            _createElementVNode("h3", _hoisted_437, [
              _createElementVNode("span", _hoisted_438, _toDisplayString(_ctx.sectionNo.learning), 1),
              _createTextVNode("Thông tin quá trình học tập")
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isLearningFilled ? 'badge-light-success' : 'badge-light-warning'])
            }, _toDisplayString(_ctx.isLearningFilled ? '✓ Đã điền' : 'Chưa điền'), 3)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_439, [
                (!_ctx.editLearningProcess)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[86] || (_cache[86] = _withModifiers(($event: any) => (_ctx.editLearningProcess = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_440, [
                        _createElementVNode("span", _hoisted_441, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        id: "kt_account_connected_accounts",
        class: _normalizeClass([{
        'notice bg-light-danger rounded border-danger border border-dashed error-form':
          _ctx.isErrorFormLearningProcess,
      }, "collapse show"])
      }, [
        _createElementVNode("div", _hoisted_442, [
          _createElementVNode("div", _hoisted_443, [
            _createElementVNode("div", _hoisted_444, [
              _createElementVNode("div", _hoisted_445, [
                _hoisted_446,
                _createElementVNode("div", _hoisted_447, _toDisplayString([_ctx.learningProcess.highschoolName, _ctx.learningProcess.highschoolDistrict, _ctx.learningProcess.highschoolProvince].filter(Boolean).join(', ') || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_448, [
              _createElementVNode("div", _hoisted_449, [
                _hoisted_450,
                _createElementVNode("div", _hoisted_451, _toDisplayString(_ctx.learningProcess.yearOfGraduation || '—'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_452, [
              _createElementVNode("div", _hoisted_453, [
                _hoisted_454,
                _createElementVNode("div", _hoisted_455, _toDisplayString(_ctx.learningProcess.certificateNumber || '—'), 1)
              ])
            ])
          ]),
          (_ctx.isArticulation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_456, [
                _createElementVNode("div", _hoisted_457, [
                  _hoisted_458,
                  _hoisted_459,
                  (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "btn btn-sm btn-light btn-active-light-primary ms-auto",
                        onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.openEditArpro()))
                      }, [
                        _createElementVNode("span", _hoisted_460, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode("Chỉnh sửa ")
                      ])), [
                        [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
                      ])
                    : _createCommentVNode("", true)
                ]),
                (_ctx.arproMismatch.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_461, [
                      _hoisted_462,
                      _createElementVNode("span", _hoisted_463, "Lệch với hồ sơ xét tuyển LT (" + _toDisplayString(_ctx.arproMismatch.join(', ')) + ").", 1),
                      (!_ctx.isLockedInfo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_464, [
                            _createElementVNode("a", {
                              href: "#",
                              class: _normalizeClass(["fs-8 fw-semibold text-primary", { 'pe-none opacity-50': _ctx.arproSaving }]),
                              onClick: _cache[88] || (_cache[88] = _withModifiers(($event: any) => (_ctx.overwriteArproFromSource()), ["prevent"]))
                            }, "← Lấy từ hồ sơ LT", 2),
                            _createElementVNode("a", {
                              href: "#",
                              class: _normalizeClass(["fs-8 fw-semibold text-primary", { 'pe-none opacity-50': _ctx.arproSaving }]),
                              onClick: _cache[89] || (_cache[89] = _withModifiers(($event: any) => (_ctx.pushArproToSource()), ["prevent"]))
                            }, "Ghi sang hồ sơ LT →", 2)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.arproHasData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_465, [
                      _createElementVNode("div", _hoisted_466, [
                        _createElementVNode("div", _hoisted_467, [
                          _hoisted_468,
                          _createElementVNode("div", _hoisted_469, _toDisplayString(_ctx.arproEnrollment.graduationschool || '—'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_470, [
                        _createElementVNode("div", _hoisted_471, [
                          _hoisted_472,
                          _createElementVNode("div", _hoisted_473, _toDisplayString(_ctx.arproSysLabel(_ctx.arproEnrollment.graduationsys)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_474, [
                        _createElementVNode("div", _hoisted_475, [
                          _hoisted_476,
                          _createElementVNode("div", _hoisted_477, _toDisplayString(_ctx.arproFormLabel(_ctx.arproEnrollment.trainingform)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_478, [
                        _createElementVNode("div", _hoisted_479, [
                          _hoisted_480,
                          _createElementVNode("div", _hoisted_481, [
                            _createTextVNode(_toDisplayString(_ctx.arproEnrollment.gpa || '—'), 1),
                            (_ctx.arproEnrollment.gpafor)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_482, _toDisplayString(_ctx.arproScaleLabel(_ctx.arproEnrollment.gpafor)), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_483, [
                        _createElementVNode("div", _hoisted_484, [
                          _hoisted_485,
                          _createElementVNode("div", _hoisted_486, _toDisplayString(_ctx.arproEnrollment.graduationnumber || '—'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_487, [
                        _createElementVNode("div", _hoisted_488, [
                          _hoisted_489,
                          _createElementVNode("div", _hoisted_490, _toDisplayString(_ctx.arproEnrollment.graduationentrynumber || '—'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_491, [
                        _createElementVNode("div", _hoisted_492, [
                          _hoisted_493,
                          _createElementVNode("div", _hoisted_494, _toDisplayString(_ctx.arproEnrollment.graduationyear || '—'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_495, [
                        _createElementVNode("div", _hoisted_496, [
                          _hoisted_497,
                          _createElementVNode("div", _hoisted_498, _toDisplayString(_ctx.arproEnrollment.graduationday || '—'), 1)
                        ])
                      ]),
                      (_ctx.arproEnrollment.isintermediate && _ctx.arproEnrollment.intermediate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_499, [
                            _createElementVNode("div", _hoisted_500, [
                              _hoisted_501,
                              _createElementVNode("div", _hoisted_502, [
                                _createTextVNode(_toDisplayString(_ctx.arproEnrollment.intermediate.graduationschool || 'Có bằng Trung cấp'), 1),
                                (_ctx.arproEnrollment.intermediate.graduationyear)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_503, " · Năm " + _toDisplayString(_ctx.arproEnrollment.intermediate.graduationyear), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_504, [
                      _createTextVNode("Chưa có dữ liệu bằng Trung cấp/Cao đẳng. Bấm "),
                      _hoisted_505,
                      _createTextVNode(" để nhập.")
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createVNode(_component_el_drawer, {
        onClose: _ctx.blurActiveEl,
        modelValue: _ctx.editArpro,
        "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.editArpro) = $event)),
        direction: "rtl",
        size: "460px",
        "with-header": false,
        "append-to-body": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_506, [
            _createElementVNode("div", _hoisted_507, [
              _hoisted_508,
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary",
                title: "Đóng",
                onClick: _cache[90] || (_cache[90] = ($event: any) => (_ctx.editArpro = false))
              }, [
                _createElementVNode("span", _hoisted_509, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_510, [
              _hoisted_511,
              _createElementVNode("div", _hoisted_512, [
                _hoisted_513,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.arproEdit.graduationschool,
                  "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.arproEdit.graduationschool) = $event)),
                  placeholder: "Trường tốt nghiệp",
                  class: "input-custom"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_514, [
                _createElementVNode("div", _hoisted_515, [
                  _hoisted_516,
                  _createVNode(_component_el_select, {
                    "popper-class": "umt-form-dd",
                    modelValue: _ctx.arproEdit.graduationsys,
                    "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.arproEdit.graduationsys) = $event)),
                    placeholder: "Hệ",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Trung cấp",
                        value: "trungcap"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Cao đẳng",
                        value: "caodang"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_517, [
                  _hoisted_518,
                  _createVNode(_component_el_select, {
                    "popper-class": "umt-form-dd",
                    modelValue: _ctx.arproEdit.trainingform,
                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.arproEdit.trainingform) = $event)),
                    placeholder: "Hình thức",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Chính quy",
                        value: "chinhquy"
                      }),
                      _createVNode(_component_el_option, {
                        label: "Nghề",
                        value: "nghe"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_519, [
                _createElementVNode("div", _hoisted_520, [
                  _hoisted_521,
                  _createVNode(_component_el_radio_group, {
                    modelValue: _ctx.arproEdit.gpafor,
                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.arproEdit.gpafor) = $event)),
                    class: "d-block mt-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        label: "gpa4",
                        class: "me-8"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Thang 4")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: "gpa10" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Thang 10")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_522, [
                  _hoisted_523,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.arproEdit.gpa,
                    "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.arproEdit.gpa) = $event)),
                    placeholder: _ctx.arproEdit.gpafor === 'gpa4' ? 'Điểm (0 - 4)' : _ctx.arproEdit.gpafor === 'gpa10' ? 'Điểm (0 - 10)' : 'Điểm',
                    class: "input-custom"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]),
              _createElementVNode("div", _hoisted_524, [
                _createElementVNode("div", _hoisted_525, [
                  _hoisted_526,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.arproEdit.graduationnumber,
                    "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.arproEdit.graduationnumber) = $event)),
                    placeholder: "Số hiệu bằng",
                    class: "input-custom"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_527, [
                  _hoisted_528,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.arproEdit.graduationentrynumber,
                    "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.arproEdit.graduationentrynumber) = $event)),
                    placeholder: "Số vào sổ",
                    class: "input-custom"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_529, [
                _createElementVNode("div", _hoisted_530, [
                  _hoisted_531,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.arproEdit.graduationyear,
                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.arproEdit.graduationyear) = $event)),
                    placeholder: "Năm tốt nghiệp",
                    class: "input-custom"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_532, [
                  _hoisted_533,
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.arproEdit.graduationday,
                    "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.arproEdit.graduationday) = $event)),
                    type: "date",
                    format: "DD/MM/YYYY",
                    "value-format": "YYYY-MM-DD",
                    placeholder: "Ngày cấp",
                    class: "w-100"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_534, [
                _createElementVNode("label", _hoisted_535, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.arproEdit.isintermediate) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.arproEdit.isintermediate]
                  ]),
                  _hoisted_536
                ])
              ]),
              (_ctx.arproEdit.isintermediate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_537, [
                    _createElementVNode("div", _hoisted_538, [
                      _createElementVNode("div", _hoisted_539, [
                        _hoisted_540,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.arproEdit.intermediate.graduationschool,
                          "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.arproEdit.intermediate.graduationschool) = $event)),
                          placeholder: "Trường tốt nghiệp Trung cấp",
                          class: "input-custom"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_541, [
                        _hoisted_542,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          modelValue: _ctx.arproEdit.intermediate.trainingform,
                          "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.arproEdit.intermediate.trainingform) = $event)),
                          placeholder: "Hình thức",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Chính quy",
                              value: "chinhquy"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Nghề",
                              value: "nghe"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_543, [
                        _hoisted_544,
                        _createVNode(_component_el_select, {
                          "popper-class": "umt-form-dd",
                          modelValue: _ctx.arproEdit.intermediate.graduationsys,
                          "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.arproEdit.intermediate.graduationsys) = $event)),
                          placeholder: "Hệ",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "Trung cấp",
                              value: "trungcap"
                            }),
                            _createVNode(_component_el_option, {
                              label: "Cao đẳng",
                              value: "caodang"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_545, [
                        _hoisted_546,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.arproEdit.intermediate.graduationnumber,
                          "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event: any) => ((_ctx.arproEdit.intermediate.graduationnumber) = $event)),
                          placeholder: "Số hiệu bằng",
                          class: "input-custom"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_547, [
                        _hoisted_548,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.arproEdit.intermediate.graduationentrynumber,
                          "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event: any) => ((_ctx.arproEdit.intermediate.graduationentrynumber) = $event)),
                          placeholder: "Số vào sổ",
                          class: "input-custom"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_549, [
                        _hoisted_550,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.arproEdit.intermediate.graduationyear,
                          "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((_ctx.arproEdit.intermediate.graduationyear) = $event)),
                          placeholder: "Năm tốt nghiệp",
                          class: "input-custom"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_551, [
                        _hoisted_552,
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.arproEdit.intermediate.graduationday,
                          "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.arproEdit.intermediate.graduationday) = $event)),
                          type: "date",
                          format: "DD/MM/YYYY",
                          "value-format": "YYYY-MM-DD",
                          placeholder: "Ngày cấp",
                          class: "w-100"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_553, [
              _createElementVNode("span", {
                class: "btn btn-light btn-active-light-primary me-3",
                onClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.editArpro = false))
              }, "Hủy bỏ"),
              _createElementVNode("button", {
                class: "btn btn-primary",
                disabled: _ctx.arproSaving,
                onClick: _cache[109] || (_cache[109] = ($event: any) => (_ctx.saveArpro()))
              }, [
                (!_ctx.arproSaving)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_555, "Lưu thay đổi"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_556, "Đang lưu..."))
              ], 8, _hoisted_554)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "modelValue"]),
      _createVNode(_component_el_drawer, {
        onClose: _ctx.blurActiveEl,
        modelValue: _ctx.editLearningProcess,
        "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event: any) => ((_ctx.editLearningProcess) = $event)),
        direction: "rtl",
        size: "460px",
        "with-header": false,
        "append-to-body": "",
        "before-close": (done)=>{ _ctx.initLearningProcess(); done() }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_557, [
            _createElementVNode("div", _hoisted_558, [
              _hoisted_559,
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary",
                title: "Đóng",
                onClick: _cache[111] || (_cache[111] = ($event: any) => (_ctx.resetLearningProcess()))
              }, [
                _createElementVNode("span", _hoisted_560, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_561, [
              _createVNode(_component_el_form, {
                model: _ctx.learningProcess,
                class: "form",
                id: "kt_account_connected_accounts_form",
                onSubmit: _cache[117] || (_cache[117] = _withModifiers(($event: any) => (_ctx.saveChanges3()), ["prevent"])),
                rules: _ctx.learningProcessValidator,
                ref: "submitButton3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_562, [
                    _createElementVNode("div", _hoisted_563, [
                      _hoisted_564,
                      _createVNode(_component_el_form_item, { prop: "highschoolProvinceId" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid w-100",
                            "popper-class": "umt-form-dd",
                            filterable: "",
                            placeholder: "Tỉnh/Thành phố",
                            onChange: _ctx.highschoolProvinceChange,
                            modelValue: _ctx.learningProcess.highschoolProvinceId,
                            "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.learningProcess.highschoolProvinceId) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvinceForSchool, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.hsProvinceCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_565, "Mã tỉnh: " + _toDisplayString(_ctx.hsProvinceCode), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_566, [
                      _hoisted_567,
                      _createVNode(_component_el_form_item, { prop: "highschoolId" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid w-100",
                            "popper-class": "umt-form-dd",
                            filterable: "",
                            placeholder: "Trường",
                            onChange: _ctx.highschoolSchoolChange,
                            modelValue: _ctx.learningProcess.highschoolId,
                            "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.learningProcess.highschoolId) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSchoolName, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.districtName ? item.name + ' - ' + item.districtName : item.name,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["onChange", "modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.hsSchoolCode)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_568, "Mã trường: " + _toDisplayString(_ctx.hsSchoolCode), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_569, [
                      _hoisted_570,
                      _createVNode(_component_el_form_item, { prop: "yearOfGraduation" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            class: "w-100 input-custom",
                            placeholder: "Năm tốt nghiệp",
                            modelValue: _ctx.learningProcess.yearOfGraduation,
                            "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.learningProcess.yearOfGraduation) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_571, [
                      _hoisted_572,
                      _createVNode(_component_el_form_item, { prop: "certificateNumber" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "text",
                            class: "w-100 input-custom",
                            placeholder: "Số hiệu bằng",
                            modelValue: _ctx.learningProcess.certificateNumber,
                            "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.learningProcess.certificateNumber) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_573, [
                    _createElementVNode("span", {
                      onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.resetLearningProcess())),
                      class: "btn btn-white btn-active-light-primary me-2"
                    }, " Hủy bỏ "),
                    _hoisted_574
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "modelValue", "before-close"]),
      (!_ctx.isArticulation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_575, [
            _createElementVNode("div", _hoisted_576, [
              _createElementVNode("div", _hoisted_577, [
                _hoisted_578,
                (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "text-primary cursor-pointer d-flex flex-center",
                      onClick: _cache[119] || (_cache[119] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addRowSchool && _ctx.addRowSchool(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_579, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr013.svg" })
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["fs-6", _ctx.isMobile ? 'min-w-60px' : ''])
                      }, "Thêm mới", 2)
                    ])), [
                      [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isArticulation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_580, [
            _createVNode(_component_el_form, {
              model: _ctx.collegesUniversities,
              class: "form",
              onSubmit: _cache[126] || (_cache[126] = _withModifiers(($event: any) => (_ctx.submitForSchool()), ["prevent"])),
              rules: _ctx.forSchoolValidator,
              ref: "forSchool"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_581, [
                  _createElementVNode("div", _hoisted_582, [
                    _createElementVNode("div", _hoisted_583, [
                      (_ctx.tableData.length != 0)
                        ? (_openBlock(), _createBlock(_component_Datatable, {
                            key: 0,
                            "table-data": _ctx.tableData,
                            total: _ctx.tableData.length,
                            currentPage: _ctx.pagination.currentPage,
                            "table-header": _ctx.tableHeader,
                            "rows-per-page": _ctx.pagination.limit,
                            "enable-items-per-page-dropdown": false,
                            classTable: "custom-table-th table-bordered table-hover border border-left-0 border-solid"
                          }, {
                            "cell-programName": _withCtx(({ row: customer }) => [
                              _createElementVNode("div", _hoisted_584, _toDisplayString(customer.programName), 1)
                            ]),
                            "cell-programLevel": _withCtx(({ row: customer }) => [
                              _createElementVNode("div", _hoisted_585, _toDisplayString(customer.programLevel), 1)
                            ]),
                            "cell-studyLocation": _withCtx(({ row: customer }) => [
                              _createElementVNode("div", _hoisted_586, _toDisplayString(customer.studyLocation), 1)
                            ]),
                            "cell-status": _withCtx(({ row: customer }) => [
                              _createElementVNode("div", _hoisted_587, _toDisplayString(customer.status), 1)
                            ]),
                            "cell-time": _withCtx(({ row: customer }) => [
                              _createElementVNode("div", _hoisted_588, _toDisplayString(customer.from) + " - " + _toDisplayString(customer.to), 1)
                            ]),
                            "cell-actions": _withCtx(({ row: customer }) => [
                              _createElementVNode("div", _hoisted_589, [
                                (!_ctx.isLockedInfo)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.editRow(customer)),
                                      class: "cursor-pointer svg-icon svg-icon-primary svg-icon-2 me-lg-3 me-md-3"
                                    }, [
                                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                                    ], 8, _hoisted_590))
                                  : _createCommentVNode("", true),
                                (!_ctx.isLockedInfo)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.deleteRow(customer)),
                                      class: "cursor-pointer svg-icon svg-icon-danger svg-icon-2"
                                    }, [
                                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr015.svg" })
                                    ], 8, _hoisted_591))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page"]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.isShowFormSchool)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_592, [
                          _createElementVNode("div", _hoisted_593, [
                            _createElementVNode("div", _hoisted_594, [
                              _createElementVNode("div", _hoisted_595, [
                                _hoisted_596,
                                _createVNode(_component_el_form_item, { prop: "programName" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      type: "text",
                                      class: "w-100 input-custom",
                                      placeholder: "Tên ngành",
                                      modelValue: _ctx.collegesUniversities.programName,
                                      "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event: any) => ((_ctx.collegesUniversities.programName) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_597, [
                                _hoisted_598,
                                _createVNode(_component_el_form_item, { prop: "programLevel" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      class: "form-select-solid w-100",
                                      "popper-class": "umt-form-dd",
                                      filterable: "",
                                      placeholder: "Cấp độ học",
                                      modelValue: _ctx.collegesUniversities.programLevel,
                                      "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event: any) => ((_ctx.collegesUniversities.programLevel) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                            { value: 'Trung cấp', label: 'Trung cấp' },
                            { value: 'Cao đẳng', label: 'Cao đẳng' },
                            { value: 'Đại học', label: 'Đại học' },
                          ], (item) => {
                                          return _createVNode(_component_el_option, {
                                            key: item.value,
                                            label: item.label,
                                            value: item.value
                                          }, null, 8, ["label", "value"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_599, [
                                _hoisted_600,
                                _createVNode(_component_el_form_item, { prop: "studyLocation" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      class: "form-select-solid w-100",
                                      "popper-class": "umt-form-dd",
                                      filterable: "",
                                      placeholder: "Địa điểm học",
                                      modelValue: _ctx.collegesUniversities.studyLocation,
                                      "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event: any) => ((_ctx.collegesUniversities.studyLocation) = $event))
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvince, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.value,
                                            label: item.name,
                                            value: item.name
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_601, [
                                _hoisted_602,
                                _createVNode(_component_el_form_item, { prop: "ranktime" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: _ctx.collegesUniversities.ranktime,
                                      "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event: any) => ((_ctx.collegesUniversities.ranktime) = $event)),
                                      placeholder: "Tháng/năm",
                                      format: "DD/MM/YYYY",
                                      type: "daterange",
                                      "start-placeholder": "Từ ngày",
                                      "end-placeholder": "Đến ngày",
                                      class: "w-100"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_603, [
                                _createElementVNode("label", _hoisted_604, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    name: "collegesUniversitiesStatus",
                                    value: "completed",
                                    "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event: any) => ((_ctx.collegesUniversities.status) = $event)),
                                    id: "collegesUniversitiesStatus",
                                    type: "checkbox"
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.collegesUniversities.status]
                                  ]),
                                  _hoisted_605
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_606, [
                              _createElementVNode("span", {
                                class: "btn btn-light me-3",
                                onClick: _cache[125] || (_cache[125] = 
//@ts-ignore
(...args) => (_ctx.cancleSchool && _ctx.cancleSchool(...args)))
                              }, "Hủy"),
                              _hoisted_607
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true)
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_608, [
          _hoisted_609,
          _createElementVNode("div", _hoisted_610, [
            _createElementVNode("form", _hoisted_611, [
              _createElementVNode("div", _hoisted_612, [
                (_ctx.dataReset.gapTimeActivities)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_613, [
                      _createElementVNode("div", _hoisted_614, [
                        _createVNode(_component_studiedEnglish, {
                          onUpdateData: _ctx.updateGaptime,
                          id: _ctx.id,
                          type: "studied_english",
                          admissionRegistration: _ctx.admissionRegistration,
                          "data-form": _ctx.dataReset.gapTimeActivities,
                          locked: _ctx.isLockedInfo,
                          "edit-reason": _ctx.finalEditMode ? _ctx.finalEditReason : ''
                        }, null, 8, ["onUpdateData", "id", "admissionRegistration", "data-form", "locked", "edit-reason"]),
                        _createVNode(_component_beingEmployed, {
                          onUpdateData: _ctx.updateGaptime,
                          id: _ctx.id,
                          type: "being_employed",
                          admissionRegistration: _ctx.admissionRegistration,
                          "data-form": _ctx.dataReset.gapTimeActivities,
                          locked: _ctx.isLockedInfo,
                          "edit-reason": _ctx.finalEditMode ? _ctx.finalEditReason : ''
                        }, null, 8, ["onUpdateData", "id", "admissionRegistration", "data-form", "locked", "edit-reason"])
                      ]),
                      _createElementVNode("div", _hoisted_615, [
                        _createVNode(_component_workOnProject, {
                          onUpdateData: _ctx.updateGaptime,
                          id: _ctx.id,
                          type: "work_on_project",
                          admissionRegistration: _ctx.admissionRegistration,
                          "data-form": _ctx.dataReset.gapTimeActivities,
                          locked: _ctx.isLockedInfo,
                          "edit-reason": _ctx.finalEditMode ? _ctx.finalEditReason : ''
                        }, null, 8, ["onUpdateData", "id", "admissionRegistration", "data-form", "locked", "edit-reason"]),
                        _createVNode(_component_other, {
                          onUpdateData: _ctx.updateGaptime,
                          id: _ctx.id,
                          type: "other",
                          admissionRegistration: _ctx.admissionRegistration,
                          "data-form": _ctx.dataReset.gapTimeActivities,
                          locked: _ctx.isLockedInfo,
                          "edit-reason": _ctx.finalEditMode ? _ctx.finalEditReason : ''
                        }, null, 8, ["onUpdateData", "id", "admissionRegistration", "data-form", "locked", "edit-reason"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_616, [
      _createElementVNode("div", _hoisted_617, [
        _createElementVNode("div", _hoisted_618, [
          _createElementVNode("h3", _hoisted_619, [
            _createElementVNode("span", _hoisted_620, _toDisplayString(_ctx.sectionNo.service), 1),
            _createTextVNode("Tư vấn hỗ trợ sinh viên")
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_621, [
                (!_ctx.isShowFormService)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[127] || (_cache[127] = _withModifiers(($event: any) => (_ctx.isShowFormService = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_622, [
                        _createElementVNode("span", _hoisted_623, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_624, [
        _createElementVNode("div", _hoisted_625, [
          _createElementVNode("div", _hoisted_626, [
            _hoisted_627,
            _createElementVNode("div", _hoisted_628, _toDisplayString((_ctx.supportServices || []).map(s => ({bus:'Xe buýt', dormitory:'Nhà trọ', student_club:'CLB sinh viên', part_time_jobs:'Việc làm thêm', other:'Khác'})[s] || s).join(', ') || '—'), 1)
          ]),
          (_ctx.supportServices?.includes('other'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_629, [
                _hoisted_630,
                _createElementVNode("div", _hoisted_631, _toDisplayString(_ctx.supportServicesOther || '—'), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_el_drawer, {
        onClose: _ctx.blurActiveEl,
        modelValue: _ctx.isShowFormService,
        "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => ((_ctx.isShowFormService) = $event)),
        direction: "rtl",
        size: "600px",
        "with-header": false,
        "append-to-body": "",
        "before-close": (done)=>{ _ctx.initSupportServices(); done() }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_632, [
            _createElementVNode("div", _hoisted_633, [
              _hoisted_634,
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary",
                title: "Đóng",
                onClick: _cache[128] || (_cache[128] = ($event: any) => {_ctx.initSupportServices(); _ctx.isShowFormService = false;})
              }, [
                _createElementVNode("span", _hoisted_635, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_636, [
              _createVNode(_component_Form, {
                id: "kt_account_connected_accounts_form",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[135] || (_cache[135] = ($event: any) => (_ctx.submitsupportServices()))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_637, [
                    _hoisted_638,
                    _createElementVNode("div", _hoisted_639, [
                      _createElementVNode("label", _hoisted_640, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3",
                          type: "checkbox",
                          name: "support-services",
                          "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event: any) => ((_ctx.supportServices) = $event)),
                          value: "bus"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.supportServices]
                        ]),
                        _hoisted_641
                      ]),
                      _createElementVNode("label", _hoisted_642, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3",
                          type: "checkbox",
                          name: "support-services",
                          "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event: any) => ((_ctx.supportServices) = $event)),
                          value: "dormitory"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.supportServices]
                        ]),
                        _hoisted_643
                      ]),
                      _createElementVNode("label", _hoisted_644, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3",
                          type: "checkbox",
                          name: "support-services",
                          "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ((_ctx.supportServices) = $event)),
                          value: "student_club"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.supportServices]
                        ]),
                        _hoisted_645
                      ]),
                      _createElementVNode("label", _hoisted_646, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3",
                          type: "checkbox",
                          name: "support-services",
                          "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event: any) => ((_ctx.supportServices) = $event)),
                          value: "part_time_jobs"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.supportServices]
                        ]),
                        _hoisted_647
                      ]),
                      _createElementVNode("div", _hoisted_648, [
                        _createElementVNode("label", _hoisted_649, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input me-3",
                            type: "checkbox",
                            name: "support-services",
                            "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event: any) => ((_ctx.supportServices) = $event)),
                            value: "other"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.supportServices]
                          ]),
                          _hoisted_650
                        ]),
                        (_ctx.supportServices?.includes('other'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_651, [
                              _withDirectives(_createElementVNode("textarea", {
                                name: "supportServicesOther",
                                class: "form-control form-control-solid mb-3 mb-lg-0 w-100",
                                placeholder: "Mô tả",
                                "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => ((_ctx.supportServicesOther) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.supportServicesOther]
                              ]),
                              _createElementVNode("div", _hoisted_652, [
                                _createElementVNode("div", _hoisted_653, [
                                  _createVNode(_component_ErrorMessage, { name: "activityName" })
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_654, [
                _createElementVNode("span", {
                  onClick: _cache[136] || (_cache[136] = ($event: any) => {
                _ctx.initSupportServices();
                _ctx.isShowFormService = false;
              }),
                  class: "btn btn-white btn-active-light-primary me-2"
                }, " Hủy bỏ "),
                _createElementVNode("button", {
                  ref: "submitButton2",
                  class: "btn btn-primary",
                  onClick: _cache[137] || (_cache[137] = ($event: any) => (_ctx.submitsupportServices()))
                }, _hoisted_657, 512)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "modelValue", "before-close"])
    ]),
    _createElementVNode("div", _hoisted_658, [
      _createElementVNode("div", _hoisted_659, [
        _createElementVNode("div", _hoisted_660, [
          _createElementVNode("div", _hoisted_661, [
            _createElementVNode("h3", _hoisted_662, [
              _createElementVNode("span", _hoisted_663, _toDisplayString(_ctx.sectionNo.english), 1),
              _createTextVNode("Đăng ký thi xếp lớp Tiếng Anh")
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isEnglishFilled ? 'badge-light-success' : 'badge-light-warning'])
            }, _toDisplayString(_ctx.isEnglishFilled ? '✓ Đã điền' : 'Chưa điền'), 3)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLockedInfo)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_664, [
                (!_ctx.isShowEnglishClass)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[139] || (_cache[139] = _withModifiers(($event: any) => (_ctx.isShowEnglishClass = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_665, [
                        _createElementVNode("span", _hoisted_666, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_667, [
        _createElementVNode("div", _hoisted_668, [
          _createElementVNode("div", _hoisted_669, [
            _hoisted_670,
            _createElementVNode("div", _hoisted_671, _toDisplayString(({none:'Không kiểm tra xếp lớp Tiếng Anh', english_thpt:'Điểm thi Tiếng Anh kỳ thi tốt nghiệp THPT', umt_test:'Kiểm tra xếp lớp Tiếng Anh do UMT tổ chức', english_certificate:'Có chứng chỉ Tiếng Anh còn hạn'})[_ctx.englishClassPlacementTest.registrationType] || '—'), 1)
          ]),
          (_ctx.englishClassPlacementTest.registrationType == 'english_thpt')
            ? (_openBlock(), _createElementBlock("div", _hoisted_672, [
                _hoisted_673,
                _createElementVNode("div", _hoisted_674, _toDisplayString(_ctx.englishClassPlacementTest.englishCertificate?.score || '—'), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.englishClassPlacementTest.registrationType == 'english_certificate')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_675, [
                  _hoisted_676,
                  _createElementVNode("div", _hoisted_677, _toDisplayString(_ctx.englishClassPlacementTest.englishCertificate?.certificateName || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_678, [
                  _hoisted_679,
                  _createElementVNode("div", _hoisted_680, _toDisplayString(_ctx.englishClassPlacementTest.englishCertificate?.score || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_681, [
                  _hoisted_682,
                  _createElementVNode("div", _hoisted_683, _toDisplayString(_ctx.englishClassPlacementTest.englishCertificate?.examDate ? _ctx.moment(_ctx.englishClassPlacementTest.englishCertificate.examDate) : '—') + " / " + _toDisplayString(_ctx.englishClassPlacementTest.englishCertificate?.expiredDate ? _ctx.moment(_ctx.englishClassPlacementTest.englishCertificate.expiredDate) : '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_684, [
                  _createElementVNode("div", _hoisted_685, [
                    _createVNode(_component_EnglishExemptionRefTable, {
                      "certificate-name": _ctx.englishClassPlacementTest.englishCertificate?.certificateName || ''
                    }, null, 8, ["certificate-name"])
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_el_drawer, {
        onClose: _ctx.blurActiveEl,
        modelValue: _ctx.isShowEnglishClass,
        "onUpdate:modelValue": _cache[160] || (_cache[160] = ($event: any) => ((_ctx.isShowEnglishClass) = $event)),
        direction: "rtl",
        size: _ctx.isMobile ? '100%' : '800px',
        "with-header": false,
        "append-to-body": "",
        "before-close": (done)=>{ _ctx.initEnglishClass(); done() }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_686, [
            _createElementVNode("div", _hoisted_687, [
              _hoisted_688,
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary",
                title: "Đóng",
                onClick: _cache[140] || (_cache[140] = ($event: any) => {_ctx.initEnglishClass(); _ctx.isShowEnglishClass = false;})
              }, [
                _createElementVNode("span", _hoisted_689, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createVNode(_component_el_form, {
              model: _ctx.englishClassPlacementTest,
              class: "form",
              id: "kt_account_eng_form",
              onSubmit: _cache[159] || (_cache[159] = _withModifiers(($event: any) => (_ctx.submitEnglishClass()), ["prevent"])),
              rules: _ctx.englishClassValidator,
              ref: "submitButtonEng"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_690, [
                  _createElementVNode("div", _hoisted_691, [
                    _createElementVNode("div", _hoisted_692, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["form-check form-check-custom form-check-solid align-items-start border rounded p-3 mb-0 cursor-pointer w-100", _ctx.englishClassPlacementTest.registrationType == 'none' ? 'border-primary bg-light-primary' : 'border-gray-300'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3 flex-shrink-0",
                          type: "radio",
                          name: "registrationType",
                          value: "none",
                          onChange: _cache[141] || (_cache[141] = e=>{
                    _ctx.changeTypeEnglish()
                  }),
                          "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event: any) => ((_ctx.englishClassPlacementTest.registrationType) = $event))
                        }, null, 544), [
                          [_vModelRadio, _ctx.englishClassPlacementTest.registrationType]
                        ]),
                        _hoisted_693
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_694, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["form-check form-check-custom form-check-solid align-items-start border rounded p-3 mb-0 cursor-pointer w-100", _ctx.englishClassPlacementTest.registrationType == 'english_thpt' ? 'border-primary bg-light-primary' : 'border-gray-300'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3 flex-shrink-0",
                          type: "radio",
                          name: "registrationType",
                          onChange: _cache[143] || (_cache[143] = e=>{
                    _ctx.changeTypeEnglish()
                  }),
                          value: "english_thpt",
                          "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => ((_ctx.englishClassPlacementTest.registrationType) = $event))
                        }, null, 544), [
                          [_vModelRadio, _ctx.englishClassPlacementTest.registrationType]
                        ]),
                        _createElementVNode("span", _hoisted_695, [
                          _createElementVNode("span", _hoisted_696, "Điểm thi Tiếng Anh kỳ thi tốt nghiệp THPT năm " + _toDisplayString(new Date().getFullYear()), 1),
                          _hoisted_697
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_698, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["form-check form-check-custom form-check-solid align-items-start border rounded p-3 mb-0 cursor-pointer w-100", _ctx.englishClassPlacementTest.registrationType == 'umt_test' ? 'border-primary bg-light-primary' : 'border-gray-300'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3 flex-shrink-0",
                          type: "radio",
                          name: "registrationType",
                          onChange: _cache[145] || (_cache[145] = e=>{
                    _ctx.changeTypeEnglish()
                  }),
                          value: "umt_test",
                          "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => ((_ctx.englishClassPlacementTest.registrationType) = $event))
                        }, null, 544), [
                          [_vModelRadio, _ctx.englishClassPlacementTest.registrationType]
                        ]),
                        _hoisted_699
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_700, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["form-check form-check-custom form-check-solid align-items-start border rounded p-3 mb-0 cursor-pointer w-100", _ctx.englishClassPlacementTest.registrationType == 'english_certificate' ? 'border-primary bg-light-primary' : 'border-gray-300'])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input me-3 flex-shrink-0",
                          type: "radio",
                          name: "registrationType",
                          onChange: _cache[147] || (_cache[147] = e=>{
                  _ctx.changeTypeEnglish()
                }),
                          value: "english_certificate",
                          "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event: any) => ((_ctx.englishClassPlacementTest.registrationType) = $event))
                        }, null, 544), [
                          [_vModelRadio, _ctx.englishClassPlacementTest.registrationType]
                        ]),
                        _hoisted_701
                      ], 2)
                    ])
                  ]),
                  (
              _ctx.englishClassPlacementTest.registrationType == 'english_thpt'
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_702, [
                        _createElementVNode("div", _hoisted_703, "Điểm thi Tiếng Anh kỳ thi tốt nghiệp THPT năm " + _toDisplayString(new Date().getFullYear()), 1),
                        _createElementVNode("div", _hoisted_704, [
                          _createElementVNode("div", _hoisted_705, [
                            _createVNode(_component_el_form_item, {
                              class: "mb-0",
                              prop: "englishCertificate.score",
                              rules: _ctx.englishClassPlacementTest.registrationType == 'english_thpt'?_ctx.rulesDefault:{}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  onChange: _cache[149] || (_cache[149] = e=>{_ctx.firstLoad = false}),
                                  type: "text",
                                  class: "w-100 input-custom",
                                  placeholder: "Nhập điểm",
                                  modelValue: _ctx.englishClassPlacementTest.englishCertificate.score,
                                  "onUpdate:modelValue": _cache[150] || (_cache[150] = ($event: any) => ((_ctx.englishClassPlacementTest.englishCertificate.score) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["rules"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.englishClassPlacementTest.registrationType == 'english_certificate'
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_706, [
                        _createElementVNode("div", _hoisted_707, [
                          _createElementVNode("div", _hoisted_708, [
                            _hoisted_709,
                            _createVNode(_component_el_form_item, {
                              class: "mb-0",
                              prop: "englishCertificate.certificateName",
                              rules: _ctx.englishClassPlacementTest.registrationType == 'english_certificate'?_ctx.rulesDefault:{}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  class: "form-select-solid w-100",
                                  "popper-class": "umt-form-dd",
                                  filterable: "",
                                  placeholder: "Tên chứng chỉ",
                                  onChange: _cache[151] || (_cache[151] = e => {
                        _ctx.firstLoad = false
                        _ctx.englishClassPlacementTest.englishCertificate.score = ''
                      }),
                                  modelValue: _ctx.englishClassPlacementTest.englishCertificate.certificateName,
                                  "onUpdate:modelValue": _cache[152] || (_cache[152] = ($event: any) => ((_ctx.englishClassPlacementTest.englishCertificate.certificateName) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSubject, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["rules"])
                          ]),
                          (!_ctx.layoutSubject)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_710, [
                                _hoisted_711,
                                _createVNode(_component_el_form_item, {
                                  class: "mb-0",
                                  prop: "englishCertificate.score",
                                  rules: _ctx.englishClassPlacementTest.registrationType == 'english_certificate'?_ctx.rulesDefault:{}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      onChange: _cache[153] || (_cache[153] = e=>{_ctx.firstLoad = false}),
                                      type: "text",
                                      class: "w-100 input-custom",
                                      placeholder: "Nhập điểm",
                                      modelValue: _ctx.englishClassPlacementTest.englishCertificate.score,
                                      "onUpdate:modelValue": _cache[154] || (_cache[154] = ($event: any) => ((_ctx.englishClassPlacementTest.englishCertificate.score) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["rules"])
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.layoutSubject, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "col-4"
                                }, [
                                  _createElementVNode("label", _hoisted_712, "Điểm " + _toDisplayString(item.type), 1),
                                  _createVNode(_component_el_form_item, {
                                    class: "mb-0",
                                    prop: "englishCertificate.score",
                                    rules: _ctx.englishClassPlacementTest.registrationType == 'english_certificate'?_ctx.rulesDefault:{}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        onChange: _cache[155] || (_cache[155] = e => {
                      _ctx.englishClassPlacementTest.englishCertificate.score = e
                      _ctx.firstLoad = false
                    }),
                                        type: "text",
                                        class: "w-100 input-custom",
                                        placeholder: "Nhập điểm",
                                        modelValue: _ctx.englishClassPlacementTest.englishCertificate[`score_${item.type}`],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.englishClassPlacementTest.englishCertificate[`score_${item.type}`]) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["rules"])
                                ]))
                              }), 128)),
                          _createElementVNode("div", _hoisted_713, [
                            _hoisted_714,
                            _createVNode(_component_el_date_picker, {
                              modelValue: 
                    _ctx.englishClassPlacementTest.englishCertificate.examDate
                  ,
                              "onUpdate:modelValue": _cache[156] || (_cache[156] = ($event: any) => ((
                    _ctx.englishClassPlacementTest.englishCertificate.examDate
                  ) = $event)),
                              name: "examDate",
                              placeholder: "Ngày thi",
                              format: "DD/MM/YYYY",
                              class: "w-100"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_715, [
                            _hoisted_716,
                            _createVNode(_component_el_date_picker, {
                              modelValue: 
                    _ctx.englishClassPlacementTest.englishCertificate
                      .expiredDate
                  ,
                              "onUpdate:modelValue": _cache[157] || (_cache[157] = ($event: any) => ((
                    _ctx.englishClassPlacementTest.englishCertificate
                      .expiredDate
                  ) = $event)),
                              name: "expiredDate",
                              placeholder: "Thời hạn",
                              format: "DD/MM/YYYY",
                              class: "w-100"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_717, [
                          _createVNode(_component_EnglishExemptionRefTable, {
                            "certificate-name": _ctx.englishClassPlacementTest.englishCertificate?.certificateName || ''
                          }, null, 8, ["certificate-name"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.isShowEnglishClass)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_718, [
                      _createElementVNode("span", {
                        onClick: _cache[158] || (_cache[158] = ($event: any) => {
              _ctx.initEnglishClass();
              _ctx.isShowEnglishClass = false;
            }),
                        class: "btn btn-white btn-active-light-primary me-2"
                      }, " Hủy bỏ "),
                      _hoisted_719
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "modelValue", "size", "before-close"])
    ]),
    (_ctx.isInsurance)
      ? (_openBlock(), _createElementBlock("div", _hoisted_720, [
          _createElementVNode("div", _hoisted_721, [
            _createElementVNode("div", _hoisted_722, [
              _createElementVNode("h3", _hoisted_723, [
                _createElementVNode("span", _hoisted_724, _toDisplayString(_ctx.sectionNo.insurance), 1),
                _createTextVNode("Đăng ký bảo hiểm")
              ]),
              (!_ctx.isChuyengiao && !_ctx.isLocked)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_725, [
                    (!_ctx.isShowInsurance && (!_ctx.dataReceipt) )
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                          onClick: _cache[161] || (_cache[161] = _withModifiers(($event: any) => (_ctx.isShowInsurance = true), ["prevent"]))
                        }, [
                          _createElementVNode("span", _hoisted_726, [
                            _createElementVNode("span", _hoisted_727, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                            ]),
                            _createTextVNode(" Chỉnh sửa ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_728, [
            _createElementVNode("div", _hoisted_729, [
              _createElementVNode("div", _hoisted_730, [
                _hoisted_731,
                _createElementVNode("div", _hoisted_732, _toDisplayString(({BHYT15:'Bảo hiểm y tế 15 tháng', BHYT12:'Bảo hiểm y tế 12 tháng', other:'Không đăng ký thẻ BHYT'})[_ctx.socialHealthcareInsuranceRegistration.type] || '—'), 1)
              ]),
              (_ctx.socialHealthcareInsuranceRegistration.type == 'BHYT15')
                ? (_openBlock(), _createElementBlock("div", _hoisted_733, [
                    _hoisted_734,
                    _createElementVNode("div", _hoisted_735, _toDisplayString(_ctx.socialHealthcareInsuranceRegistration.hospital || '—'), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.socialHealthcareInsuranceRegistration.type == 'BHYT12')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_736, [
                      _hoisted_737,
                      _createElementVNode("div", _hoisted_738, _toDisplayString(_ctx.socialHealthcareInsuranceRegistration.code || '—'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_739, [
                      _hoisted_740,
                      _createElementVNode("div", _hoisted_741, _toDisplayString(_ctx.socialHealthcareInsuranceRegistration.expiredDate ? _ctx.moment(_ctx.socialHealthcareInsuranceRegistration.expiredDate) : '—'), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.socialHealthcareInsuranceRegistration.type == 'other')
                ? (_openBlock(), _createElementBlock("div", _hoisted_742, [
                    _hoisted_743,
                    _createElementVNode("div", _hoisted_744, _toDisplayString(_ctx.socialHealthcareInsuranceRegistration.reason || '—'), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_745, [
                _hoisted_746,
                _createElementVNode("div", _hoisted_747, _toDisplayString(_ctx.accidentInsuranceRegistration ? 'Có đăng ký' : 'Không'), 1)
              ]),
              (_ctx.totalInsurance)
                ? (_openBlock(), _createElementBlock("div", _hoisted_748, [
                    _hoisted_749,
                    _createElementVNode("div", _hoisted_750, _toDisplayString(_ctx.totalInsurance.toLocaleString("vi-VN")) + " đ", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_drawer, {
            onClose: _ctx.blurActiveEl,
            modelValue: _ctx.isShowInsurance,
            "onUpdate:modelValue": _cache[176] || (_cache[176] = ($event: any) => ((_ctx.isShowInsurance) = $event)),
            direction: "rtl",
            size: "50%",
            "with-header": false,
            "append-to-body": "",
            "before-close": (done)=>{ _ctx.initInsuranceReg(); done() }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_751, [
                _createElementVNode("div", _hoisted_752, [
                  _hoisted_753,
                  _createElementVNode("span", {
                    class: "btn btn-sm btn-icon btn-active-light-primary",
                    title: "Đóng",
                    onClick: _cache[162] || (_cache[162] = ($event: any) => {_ctx.initInsuranceReg(); _ctx.isShowInsurance = false;})
                  }, [
                    _createElementVNode("span", _hoisted_754, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createVNode(_component_Form, {
                  id: "kt_account_deactivate_form",
                  class: "form",
                  onSubmit: _cache[175] || (_cache[175] = ($event: any) => (_ctx.submitInsuranceRegistration())),
                  novalidate: "novalidate",
                  "validation-schema": _ctx.insuranceRegValidator
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_755, [
                      _createElementVNode("div", _hoisted_756, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["col-lg-8 col-12", { disabled: !_ctx.isShowInsurance }])
                        }, [
                          _createElementVNode("div", _hoisted_757, [
                            _createElementVNode("div", _hoisted_758, [
                              _createElementVNode("div", _hoisted_759, [
                                _createElementVNode("label", _hoisted_760, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input me-3",
                                    type: "radio",
                                    name: "socialHealthcare",
                                    "onUpdate:modelValue": _cache[163] || (_cache[163] = ($event: any) => ((_ctx.socialHealthcareInsuranceRegistration.type) = $event)),
                                    value: "BHYT15"
                                  }, null, 512), [
                                    [_vModelRadio, _ctx.socialHealthcareInsuranceRegistration.type]
                                  ]),
                                  _createElementVNode("span", _hoisted_761, [
                                    _createElementVNode("span", _hoisted_762, "Bảo hiểm y tế 15 tháng (có giá trị sử dụng từ ngày 01/10/" + _toDisplayString(new Date().getFullYear()) + " đến 31/12/" + _toDisplayString(new Date().getFullYear() + 1) + ")", 1),
                                    _createElementVNode("i", _hoisted_763, "(Dành cho thí sinh chưa có hoặc đã có BHYT còn hạn đến ngày 30/09/" + _toDisplayString(new Date().getFullYear()) + ")", 1)
                                  ])
                                ]),
                                (
                        _ctx.socialHealthcareInsuranceRegistration.type == 'BHYT15'
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_764, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["mb-3", _ctx.isMobile ? '' : 'd-flex gap-3'])
                                      }, [
                                        _hoisted_765,
                                        _createElementVNode("div", _hoisted_766, [
                                          _createVNode(_component_Field, {
                                            type: "text",
                                            name: "activityName",
                                            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                                            placeholder: "Nhập nơi khám",
                                            modelValue: 
                              _ctx.socialHealthcareInsuranceRegistration.hospital
                            ,
                                            "onUpdate:modelValue": _cache[164] || (_cache[164] = ($event: any) => ((
                              _ctx.socialHealthcareInsuranceRegistration.hospital
                            ) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("div", _hoisted_767, [
                                            _createElementVNode("div", _hoisted_768, [
                                              _createVNode(_component_ErrorMessage, { name: "activityName" })
                                            ])
                                          ])
                                        ])
                                      ], 2)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("label", _hoisted_769, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input me-3",
                                    type: "radio",
                                    name: "socialHealthcare",
                                    "onUpdate:modelValue": _cache[165] || (_cache[165] = ($event: any) => ((_ctx.socialHealthcareInsuranceRegistration.type) = $event)),
                                    value: "BHYT12"
                                  }, null, 512), [
                                    [_vModelRadio, _ctx.socialHealthcareInsuranceRegistration.type]
                                  ]),
                                  _createElementVNode("span", _hoisted_770, [
                                    _createElementVNode("span", _hoisted_771, "Bảo hiểm y tế 12 tháng (có giá trị sử dụng từ 01/01/" + _toDisplayString(new Date().getFullYear() + 1) + " đến 31/12/" + _toDisplayString(new Date().getFullYear() + 1) + ")", 1),
                                    _createElementVNode("i", _hoisted_772, "(Dành cho thí sinh đã có thẻ BHYT còn hạn đến ngày 31/12/" + _toDisplayString(new Date().getFullYear()) + ")", 1)
                                  ])
                                ]),
                                (
                        _ctx.socialHealthcareInsuranceRegistration.type == 'BHYT12'
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_773, [
                                      _createElementVNode("div", _hoisted_774, [
                                        _hoisted_775,
                                        _createElementVNode("div", _hoisted_776, [
                                          _createVNode(_component_Field, {
                                            type: "text",
                                            name: "code",
                                            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                                            placeholder: "Mã số thẻ",
                                            modelValue: _ctx.socialHealthcareInsuranceRegistration.code,
                                            "onUpdate:modelValue": _cache[166] || (_cache[166] = ($event: any) => ((_ctx.socialHealthcareInsuranceRegistration.code) = $event))
                                          }, null, 8, ["modelValue"]),
                                          _createElementVNode("div", _hoisted_777, [
                                            _createElementVNode("div", _hoisted_778, [
                                              _createVNode(_component_ErrorMessage, { name: "code" })
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["col-lg-7 col-md-7 col-12", _ctx.isMobile ? '' : 'd-flex gap-3'])
                                      }, [
                                        _hoisted_779,
                                        _createElementVNode("div", _hoisted_780, [
                                          _createVNode(_component_el_date_picker, {
                                            modelValue: 
                              _ctx.socialHealthcareInsuranceRegistration.expiredDate
                            ,
                                            "onUpdate:modelValue": _cache[167] || (_cache[167] = ($event: any) => ((
                              _ctx.socialHealthcareInsuranceRegistration.expiredDate
                            ) = $event)),
                                            name: "expiredDate",
                                            placeholder: "Ngày/tháng/năm",
                                            format: "DD/MM/YYYY",
                                            value: 
                              _ctx.socialHealthcareInsuranceRegistration.expiredDate
                            ,
                                            class: "w-100"
                                          }, null, 8, ["modelValue", "value"]),
                                          _createElementVNode("div", _hoisted_781, [
                                            _createVNode(_component_Field, {
                                              type: "text",
                                              modelValue: 
                                _ctx.socialHealthcareInsuranceRegistration.expiredDate
                              ,
                                              "onUpdate:modelValue": _cache[168] || (_cache[168] = ($event: any) => ((
                                _ctx.socialHealthcareInsuranceRegistration.expiredDate
                              ) = $event)),
                                              class: "form-control form-control-solid",
                                              placeholder: "Ngày/tháng/năm",
                                              name: "expiredDate"
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createVNode(_component_ErrorMessage, {
                                            class: "fv-plugins-message-container invalid-feedback",
                                            name: "expiredDate"
                                          })
                                        ])
                                      ], 2)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("label", _hoisted_782, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input me-3",
                                    type: "radio",
                                    name: "isHealthInsurance",
                                    "onUpdate:modelValue": _cache[169] || (_cache[169] = ($event: any) => ((_ctx.socialHealthcareInsuranceRegistration.type) = $event)),
                                    value: "other",
                                    onChange: _cache[170] || (_cache[170] = 
//@ts-ignore
(...args) => (_ctx.socialHealthcareChange && _ctx.socialHealthcareChange(...args)))
                                  }, null, 544), [
                                    [_vModelRadio, _ctx.socialHealthcareInsuranceRegistration.type]
                                  ]),
                                  _hoisted_783
                                ]),
                                (
                        _ctx.socialHealthcareInsuranceRegistration.type == 'other'
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_784, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["col-12 mb-3", _ctx.isMobile ? '' : 'd-flex gap-5'])
                                      }, [
                                        _hoisted_785,
                                        _createElementVNode("div", _hoisted_786, [
                                          _withDirectives(_createElementVNode("textarea", {
                                            name: "reason",
                                            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0 w-100",
                                            placeholder: "Mô tả",
                                            "onUpdate:modelValue": _cache[171] || (_cache[171] = ($event: any) => ((
                              _ctx.socialHealthcareInsuranceRegistration.reason
                            ) = $event))
                                          }, null, 512), [
                                            [_vModelText, 
                              _ctx.socialHealthcareInsuranceRegistration.reason
                            ]
                                          ]),
                                          _createElementVNode("div", _hoisted_787, [
                                            _createVNode(_component_Field, {
                                              type: "text",
                                              name: "reason",
                                              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                                              placeholder: "Lý do",
                                              modelValue: 
                                _ctx.socialHealthcareInsuranceRegistration.reason
                              ,
                                              "onUpdate:modelValue": _cache[172] || (_cache[172] = ($event: any) => ((
                                _ctx.socialHealthcareInsuranceRegistration.reason
                              ) = $event))
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_788, [
                                            _createElementVNode("div", _hoisted_789, [
                                              _createVNode(_component_ErrorMessage, { name: "reason" })
                                            ])
                                          ])
                                        ])
                                      ], 2)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_790,
                              _createElementVNode("div", _hoisted_791, [
                                _hoisted_792,
                                _createElementVNode("label", _hoisted_793, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input me-2",
                                    type: "checkbox",
                                    name: "accidentInsuranceRegistration",
                                    value: "accident",
                                    "onUpdate:modelValue": _cache[173] || (_cache[173] = ($event: any) => ((_ctx.accidentInsuranceRegistration) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.accidentInsuranceRegistration]
                                  ]),
                                  _createElementVNode("span", _hoisted_794, [
                                    _createElementVNode("span", _hoisted_795, "Bảo hiểm 15 tháng, có giá trị từ ngày 01/10/" + _toDisplayString(new Date().getFullYear()) + " đến 31/12/" + _toDisplayString(new Date().getFullYear() + 1), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ], 2),
                        _createElementVNode("div", _hoisted_796, [
                          (
                  _ctx.accidentInsuranceRegistration ||
                  (_ctx.socialHealthcareInsuranceRegistration.type &&
                    _ctx.socialHealthcareInsuranceRegistration.type != 'other')
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_797, [
                                (
                    _ctx.dataSettingItem.length != 0 &&
                    _ctx.socialHealthcareInsuranceRegistration.type &&
                    _ctx.socialHealthcareInsuranceRegistration.type != 'other'
                  )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_798, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.dataSettingItem.filter(
                      (i) =>
                        i.type == _ctx.socialHealthcareInsuranceRegistration.type
                    )[0]?.name), 1),
                                      _createElementVNode("span", null, _toDisplayString((+_ctx.dataSettingItem.filter(
                        (i) =>
                          i.type == _ctx.socialHealthcareInsuranceRegistration.type
                      )[0]?.price).toLocaleString("vi-VN")), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                    _ctx.accidentInsuranceRegistration && _ctx.dataSettingItem.length != 0
                  )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_799, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.dataSettingItem.filter((i) => i.type == "BHTN15")[0]?.name), 1),
                                      _createElementVNode("span", null, _toDisplayString((+_ctx.dataSettingItem.filter((i) => i.type == "BHTN15")[0]
                        ?.price).toLocaleString("vi-VN")), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _hoisted_800,
                                _createElementVNode("div", _hoisted_801, [
                                  _createElementVNode("strong", _hoisted_802, _toDisplayString(_ctx.totalInsurance.toLocaleString("vi-VN")) + " đ", 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    (_ctx.isShowInsurance)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_803, [
                          _createElementVNode("span", {
                            onClick: _cache[174] || (_cache[174] = ($event: any) => {
              _ctx.initInsuranceReg();
              _ctx.isShowInsurance = false;
            }),
                            class: "btn btn-white btn-active-light-primary me-2"
                          }, " Hủy bỏ "),
                          _hoisted_804
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["validation-schema"])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "modelValue", "before-close"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isUniform)
      ? (_openBlock(), _createElementBlock("div", _hoisted_805, [
          _createElementVNode("div", _hoisted_806, [
            _createElementVNode("div", _hoisted_807, [
              _createElementVNode("h3", _hoisted_808, [
                _createElementVNode("span", _hoisted_809, _toDisplayString(_ctx.sectionNo.uniform), 1),
                _createTextVNode("Đồng phục thể dục và tặng phẩm")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_810, [
            _createElementVNode("div", _hoisted_811, [
              _createElementVNode("div", _hoisted_812, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-lg-7 col-12", {
                'notice bg-light-danger rounded border-danger border border-dashed error-form py-4':
                  _ctx.isErrorFormUniformReg,
              }]),
                  id: "kt_account_connected_clothes"
                }, [
                  _createElementVNode("div", _hoisted_813, [
                    false
                      ? (_openBlock(), _createElementBlock("div", _hoisted_814, [
                          _createElementVNode("div", _hoisted_815, [
                            _hoisted_816,
                            _createElementVNode("button", _hoisted_818, [
                              _createElementVNode("span", _hoisted_819, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr022.svg" })
                              ]),
                              _hoisted_820
                            ]),
                            _createElementVNode("button", _hoisted_821, [
                              _createElementVNode("span", _hoisted_822, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr023.svg" })
                              ]),
                              _hoisted_823
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-lg-12 col-md-12 col-12", { 'mt-5': _ctx.isMobile }])
                    }, [
                      _createElementVNode("div", _hoisted_824, [
                        _hoisted_825,
                        _createElementVNode("div", _hoisted_826, [
                          (_ctx.uniformRegistration.defaultSize != '')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode("Size " + _toDisplayString(_ctx.uniformRegistration.defaultSize), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock("i", _hoisted_827, "Chưa chọn size"))
                        ]),
                        (!_ctx.dataReceipt && !_ctx.isLocked)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "ms-auto flex-shrink-0",
                              onClick: _cache[177] || (_cache[177] = _withModifiers(($event: any) => {
                        _ctx.isShowUniformReg = true;
                        _ctx.isErrorFormUniformReg = false;
                      }, ["prevent"]))
                            }, _hoisted_829))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_830, [
                        _hoisted_831,
                        _createElementVNode("div", _hoisted_832, [
                          (_ctx.otherFees && _ctx.otherFees.some(i => i.quantity != 0))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.otherFees, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                  (item.quantity != 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(item.name), 1),
                                        (item.type != 'CAPS')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              _createTextVNode(" size " + _toDisplayString(item.size), 1)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        _createTextVNode(" × " + _toDisplayString(item.quantity), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("Không")
                              ], 64))
                        ]),
                        (!_ctx.dataReceipt && !_ctx.isLocked)
                          ? _withDirectives((_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "ms-auto flex-shrink-0",
                              onClick: _cache[178] || (_cache[178] = _withModifiers(($event: any) => {_ctx.isShowOtherFees = true;}, ["prevent"]))
                            }, _hoisted_834)), [
                              [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
                            ])
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_835
                    ], 2)
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-lg-5 col-12 d-flex align-items-start justify-content-center", _ctx.isMobile?'order-3':''])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-100 notice bg-light-primary rounded border-primary border border-dashed p-6", _ctx.isMobile ? 'mt-3' : 'mb-9'])
                  }, [
                    _createElementVNode("div", _hoisted_837, [
                      _createElementVNode("span", null, [
                        _createTextVNode("Tặng 1 bộ đồng phục thể dục "),
                        (_ctx.uniformRegistration.defaultSize != '')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" size " + _toDisplayString(_ctx.uniformRegistration.defaultSize), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_838
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherFees, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "",
                        key: index
                      }, [
                        (item.quantity != 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_839, [
                              _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                (item.type != 'CAPS')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" size " + _toDisplayString(item.size), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" x " + _toDisplayString(item.quantity), 1)
                              ]),
                              _createElementVNode("span", _hoisted_840, _toDisplayString((
                        +item.price *
                        item.quantity
                      ).toLocaleString("vi-VN")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _hoisted_841,
                    _createElementVNode("div", _hoisted_842, [
                      _createElementVNode("strong", _hoisted_843, _toDisplayString(_ctx.totalUniformReg.toLocaleString("vi-VN")) + " đ", 1)
                    ])
                  ], 2)
                ], 2)
              ])
            ])
          ]),
          _createVNode(_component_el_drawer, {
            onClose: _ctx.blurActiveEl,
            modelValue: _ctx.isShowUniformReg,
            "onUpdate:modelValue": _cache[183] || (_cache[183] = ($event: any) => ((_ctx.isShowUniformReg) = $event)),
            direction: "rtl",
            size: "500px",
            "with-header": false,
            "append-to-body": "",
            "before-close": (done)=>{ _ctx.initUniformRegistration(); done() }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_844, [
                _createElementVNode("div", _hoisted_845, [
                  _hoisted_846,
                  _createElementVNode("span", {
                    class: "btn btn-sm btn-icon btn-active-light-primary",
                    title: "Đóng",
                    onClick: _cache[179] || (_cache[179] = ($event: any) => {_ctx.initUniformRegistration(); _ctx.isShowUniformReg = false;})
                  }, [
                    _createElementVNode("span", _hoisted_847, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_848, [
                  _createVNode(_component_Form, {
                    id: "kt_account_connected_accounts_form",
                    class: "form",
                    "validation-schema": _ctx.uniformRegValidator,
                    onSubmit: _cache[182] || (_cache[182] = ($event: any) => (_ctx.submitUniform()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["border border-gray-300 border-dashed rounded p-5 mb-5", {
                'notice bg-light-danger rounded border-danger border border-dashed error-form py-4':
                  _ctx.isErrorFormUniformReg,
              }])
                      }, [
                        _createElementVNode("div", _hoisted_849, [
                          _createElementVNode("div", _hoisted_850, [
                            _createVNode(_component_ErrorMessage, { name: "defaultSize" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_851, [
                          _hoisted_852,
                          _createElementVNode("div", _hoisted_853, [
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "defaultSize",
                              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
                              placeholder: "Chọn size",
                              modelValue: _ctx.uniformRegistration.defaultSize,
                              "onUpdate:modelValue": _cache[180] || (_cache[180] = ($event: any) => ((_ctx.uniformRegistration.defaultSize) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_854, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSize, (size, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                onClick: ($event: any) => (_ctx.tabactiveData(size, 'defaultSize')),
                                class: _normalizeClass([[
                      _ctx.uniformRegistration.defaultSize === size && 'active',
                    ], "btn btn-active btn-active-primary px-2 py-1 me-2 fs-7"])
                              }, _toDisplayString(size), 11, _hoisted_855))
                            }), 128))
                          ]),
                          _hoisted_856
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_857, [
                        _createElementVNode("span", {
                          onClick: _cache[181] || (_cache[181] = ($event: any) => {
                  _ctx.initUniformRegistration();
                  _ctx.isShowUniformReg = false;
                }),
                          class: "btn btn-white btn-active-light-primary me-2"
                        }, " Hủy bỏ "),
                        _createElementVNode("button", _hoisted_858, _hoisted_861, 512)
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "modelValue", "before-close"]),
          _createVNode(_component_el_drawer, {
            onClose: _ctx.blurActiveEl,
            modelValue: _ctx.isShowOtherFees,
            "onUpdate:modelValue": _cache[187] || (_cache[187] = ($event: any) => ((_ctx.isShowOtherFees) = $event)),
            direction: "rtl",
            size: "600px",
            "with-header": false,
            "append-to-body": "",
            "before-close": (done)=>{ _ctx.initOtherFees(); done() }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_862, [
                _createElementVNode("div", _hoisted_863, [
                  _hoisted_864,
                  _createElementVNode("span", {
                    class: "btn btn-sm btn-icon btn-active-light-primary",
                    title: "Đóng",
                    onClick: _cache[184] || (_cache[184] = ($event: any) => {_ctx.initOtherFees(); _ctx.isShowOtherFees = false;})
                  }, [
                    _createElementVNode("span", _hoisted_865, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_866, [
                  _createElementVNode("div", _hoisted_867, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherFees, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_868, [
                          (item.quantity == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_869, [
                                _createElementVNode("span", _hoisted_870, " Chọn mua " + _toDisplayString(item.name) + "? ", 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_871, [
                                _createElementVNode("span", _hoisted_872, [
                                  _createTextVNode(" Bạn chọn mua " + _toDisplayString(item.quantity) + " " + _toDisplayString(item.name) + " ", 1),
                                  (item.type != 'CAPS')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" size " + _toDisplayString(item.size), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ])),
                          (item.type != 'CAPS')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_873, [
                                _hoisted_874,
                                _createElementVNode("div", _hoisted_875, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrSize, (size, i) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: i,
                                      onClick: ($event: any) => (_ctx.tabactiveSaleData(size, index)),
                                      class: _normalizeClass([[
                        item.size === size &&
                          'active',
                      ], "btn btn-active btn-active-primary px-2 py-1 me-2 fs-7"])
                                    }, _toDisplayString(size), 11, _hoisted_876))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_877, [
                            _hoisted_878,
                            _createElementVNode("div", _hoisted_879, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["cursor-pointer svg-icon svg-icon-danger svg-icon-2", 
                        item.quantity == 0
                          ? 'disabled'
                          : ''
                      ]),
                                onClick: ($event: any) => (_ctx.minusQuantity('quantity',index))
                              }, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr014.svg" })
                              ], 10, _hoisted_880),
                              _createElementVNode("span", _hoisted_881, _toDisplayString(item.quantity), 1),
                              _createElementVNode("span", {
                                class: "cursor-pointer svg-icon svg-icon-primary svg-icon-2",
                                onClick: ($event: any) => (_ctx.addQuantity('quantity',index))
                              }, [
                                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr013.svg" })
                              ], 8, _hoisted_882)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_883, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (img, i) => {
                            return (_openBlock(), _createElementBlock("img", {
                              src: img,
                              alt: "",
                              key: i
                            }, null, 8, _hoisted_884))
                          }), 128))
                        ]),
                        _hoisted_885
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_886, [
                    _createElementVNode("span", {
                      onClick: _cache[185] || (_cache[185] = ($event: any) => {
                _ctx.initOtherFees();
                _ctx.isShowOtherFees = false;
              }),
                      class: "btn btn-white btn-active-light-primary me-2"
                    }, " Hủy bỏ "),
                    _createElementVNode("span", {
                      onClick: _cache[186] || (_cache[186] = 
//@ts-ignore
(...args) => (_ctx.submitOtherFees && _ctx.submitOtherFees(...args))),
                      class: "btn btn-primary"
                    }, _hoisted_888)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onClose", "modelValue", "before-close"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_889, [
      _createElementVNode("div", _hoisted_890, [
        _createElementVNode("div", _hoisted_891, [
          _createElementVNode("div", _hoisted_892, [
            _createElementVNode("h3", _hoisted_893, [
              _createElementVNode("span", _hoisted_894, _toDisplayString(_ctx.sectionNo.tuition), 1),
              _createTextVNode("Thông tin học phí "),
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary ms-1",
                title: "Ghi chú: nguồn cấu hình, cách tính, lưu ý",
                onClick: _cache[188] || (_cache[188] = _withModifiers(($event: any) => (_ctx.showTuitionGuide = true), ["stop"]))
              }, _hoisted_896)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.isTuitionFilled ? 'badge-light-success' : 'badge-light-warning'])
            }, _toDisplayString(_ctx.isTuitionFilled ? '✓ Đã điền' : 'Chưa điền'), 3)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLocked)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_897, [
                ((!_ctx.isShowFreeTuition || _ctx.updatePromotion))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[189] || (_cache[189] = _withModifiers(($event: any) => {
              _ctx.isShowFreeTuition = true;
              _ctx.isErrorFormFreeTuitionReg = false;
            }, ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_898, [
                        _createElementVNode("span", _hoisted_899, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_el_drawer, {
        onClose: _ctx.blurActiveEl,
        modelValue: _ctx.showTuitionGuide,
        "onUpdate:modelValue": _cache[191] || (_cache[191] = ($event: any) => ((_ctx.showTuitionGuide) = $event)),
        direction: "rtl",
        size: "500px",
        "with-header": false,
        "append-to-body": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_900, [
            _createElementVNode("div", _hoisted_901, [
              _hoisted_902,
              _createElementVNode("span", {
                class: "btn btn-sm btn-icon btn-active-light-primary",
                title: "Đóng",
                onClick: _cache[190] || (_cache[190] = ($event: any) => (_ctx.showTuitionGuide = false))
              }, [
                _createElementVNode("span", _hoisted_903, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_904, [
              _hoisted_905,
              _createElementVNode("div", _hoisted_906, [
                _createElementVNode("div", _hoisted_907, [
                  _createTextVNode("• "),
                  _hoisted_908,
                  _createTextVNode(" theo ngành + loại chương trình + số học kỳ đóng — cấu hình tại "),
                  (_ctx.canViewSetting)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/caidatthutucnhaphoc/hocphi",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cài đặt học phí ↗")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_909, "Cài đặt học phí")),
                  _createTextVNode(".")
                ]),
                _createElementVNode("div", _hoisted_910, [
                  _createTextVNode("• "),
                  _hoisted_911,
                  _createTextVNode(" (ưu đãi chính, cộng thêm, đóng phí sớm, ưu đãi đặc biệt) — chỉ hiện chương trình đang kích hoạt & còn hạn, cấu hình tại "),
                  (_ctx.canViewSetting)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/caidatthutucnhaphoc/chuongtrinhuudai",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Chương trình ưu đãi ↗")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_912, "Chương trình ưu đãi")),
                  _createTextVNode(". Mỗi hồ sơ chọn "),
                  _hoisted_913,
                  _createTextVNode(", có thể kèm \"cộng thêm\"/\"đóng phí sớm\".")
                ]),
                _createElementVNode("div", _hoisted_914, [
                  _createTextVNode("• "),
                  _hoisted_915,
                  _createTextVNode(" — cấp/duyệt cho ứng viên ở "),
                  (_ctx.canViewScholarship)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_router_link, {
                          to: "/danhsachhocbong",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Danh sách học bổng ↗")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" · "),
                        _createVNode(_component_router_link, {
                          to: "/danhsachdangkyhocbong",
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Đăng ký học bổng ↗")
                          ]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_916, "Danh sách học bổng · Đăng ký học bổng")),
                  _createTextVNode("; gói học bổng nhập học cấu hình tại "),
                  (_ctx.canViewSetting)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: "/caidatthutucnhaphoc/hocbong",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cài đặt học bổng ↗")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_917, "Cài đặt học bổng")),
                  _createTextVNode(".")
                ]),
                _hoisted_918,
                _createElementVNode("div", null, [
                  _createTextVNode("• "),
                  _hoisted_919,
                  _createTextVNode(" — theo mục \"Đăng ký thi xếp lớp Tiếng Anh\" phía trên; điều kiện & danh mục môn Tiếng Anh được miễn giảm cấu hình tại "),
                  (_ctx.canViewSetting)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/caidatthutucnhaphoc/tienganh",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Cài đặt Tiếng Anh miễn giảm ↗")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_920, "Cài đặt Tiếng Anh miễn giảm")),
                  _createTextVNode(".")
                ])
              ])
            ]),
            _hoisted_921,
            _hoisted_922
          ])
        ]),
        _: 1
      }, 8, ["onClose", "modelValue"]),
      _createElementVNode("div", {
        id: "kt_account_connected_fee",
        class: _normalizeClass([{
        'notice bg-light-danger rounded border-danger border border-dashed error-form':
          _ctx.isErrorFormFreeTuitionReg,
      }, "collapse show"])
      }, [
        _createElementVNode("div", _hoisted_923, [
          (_ctx.expiredPromotion || (_ctx.checkIsUpdateScholarship && _ctx.firstLoad))
            ? (_openBlock(), _createElementBlock("div", _hoisted_924, [
                (_ctx.expiredPromotion)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[192] || (_cache[192] = e=>{
            _ctx.getPromotion()
            _ctx.orderDetails.otherPromotionsVip = {}
            _ctx.dataScholarshipPro.promotion = null
            _ctx.dataScholarshipPro.promotionExtend = []
            _ctx.isShowFreeTuition = true;
            _ctx.isErrorFormFreeTuitionReg = false;
            _ctx.freeTuitionRegistration.registrationTypeSiblings= false
          }),
                      class: "mb-0 text-primary cursor-pointer"
                    }, [
                      _createTextVNode("Cập nhật Khuyến mãi "),
                      _createElementVNode("span", _hoisted_925, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr029.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.checkIsUpdateScholarship && _ctx.firstLoad)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: _cache[193] || (_cache[193] = e=>{
          _ctx.orderDetails.otherPromotionsVip = {}
          _ctx.dataScholarshipPro.promotion = null
          _ctx.dataScholarshipPro.promotionExtend = []
          _ctx.firstLoad = false
          _ctx.isShowFreeTuition = true;
          _ctx.isErrorFormFreeTuitionReg = false;
          _ctx.freeTuitionRegistration.registrationTypeSiblings= false
        }),
                      class: "mb-0 text-primary cursor-pointer"
                    }, [
                      _createTextVNode("Cập nhật lại Học bổng "),
                      _createElementVNode("span", _hoisted_926, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr029.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form, {
            model: _ctx.tuitionRegistration,
            class: "form",
            id: "kt_account_connected_accounts_tuitionReg",
            onSubmit: _cache[223] || (_cache[223] = _withModifiers(($event: any) => (_ctx.submitTuitionReg()), ["prevent"])),
            rules: _ctx.freeTuitionRegistrationValidator,
            ref: "submitButton4"
          }, {
            default: _withCtx(() => [
              (_ctx.promotionConfigChanged && !_ctx.promoDriftDismissed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_927, [
                    _hoisted_928,
                    _createElementVNode("div", _hoisted_929, [
                      _createElementVNode("div", _hoisted_930, [
                        _createTextVNode("• "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.promotionConfigChanged.name), 1),
                        _createTextVNode(": lúc ứng viên chọn là "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.promotionConfigChanged.oldText), 1),
                        _createTextVNode(" → cài đặt hiện tại là "),
                        _createElementVNode("b", _hoisted_931, _toDisplayString(_ctx.promotionConfigChanged.newText), 1),
                        _createTextVNode(".")
                      ]),
                      _createElementVNode("div", _hoisted_932, [
                        _createTextVNode("Hồ sơ đang giữ khoản giảm "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.promotionConfigChanged.savedAmount.toLocaleString('vi-VN')) + "đ", 1),
                        _createTextVNode(" theo mức cũ. Chạm vào form rồi Lưu sẽ tính lại theo mức MỚI.")
                      ]),
                      _createElementVNode("div", _hoisted_933, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light umt-btn-32",
                          onClick: _cache[194] || (_cache[194] = ($event: any) => (_ctx.promoDriftDismissed = true))
                        }, " Giữ mức đã chốt "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light-danger umt-btn-32",
                          onClick: _cache[195] || (_cache[195] = ($event: any) => (_ctx.confirmDropPromotion()))
                        }, " Bỏ ưu đãi để áp lại theo mức mới ")
                      ]),
                      _hoisted_934
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_935, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-lg-6 col-12", { 'umt-view-dim': !_ctx.isShowFreeTuition }])
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_936, [
                      _hoisted_937,
                      _createElementVNode("div", {
                        class: _normalizeClass({'disabled' : _ctx.expiredPromotion && _ctx.dataPromotionListen})
                      }, [
                        _createVNode(_component_el_form_item, {
                          prop: "name",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              onChange: _ctx.changeTuitionRegistration,
                              modelValue: _ctx.tuitionRegistration.name,
                              "onUpdate:modelValue": _cache[196] || (_cache[196] = ($event: any) => ((_ctx.tuitionRegistration.name) = $event)),
                              disabled: !_ctx.isShowFreeTuition,
                              class: "form-select-solid",
                              style: {"min-width":"260px"},
                              "popper-class": "umt-form-dd",
                              placeholder: "Chọn mức học phí",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arr_dataTuition, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.label,
                                    value: item.releasedIn.toString()
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onChange", "modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ], 2)
                    ])
                  ]),
                  (_ctx.promotionChild && _ctx.promotionChild.length != 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["w-100 notice bg-light-warning border-warning border border-dashed p-4", {
                  'border-bottom-0 mb-0 pb-0': _ctx.dataPromotionListen 
                }
                ])
                      }, [
                        _hoisted_938,
                        _createElementVNode("div", _hoisted_939, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionChild, (promotion, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "",
                              key: index
                            }, [
                              _createElementVNode("label", _hoisted_940, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input me-3",
                                  type: "radio",
                                  name: "endow",
                                  onChange: e=> {
                          _ctx.firstLoad = false
                          _ctx.orderDetails.promotion.value = ''
                          _ctx.tempDataPromotion = null;
                          _ctx.tempDataPromotionAddition = null

                          _ctx.orderDetails.otherPromotions = []
                          _ctx.orderDetails.otherPromotionsVip = {}
                          _ctx.orderDetails.otherPromotionsVipPro = promotion
                          _ctx.dataScholarshipPro = {}
                          _ctx.freeTuitionRegistration.registrationTypeSiblings = false
                          _ctx.freeTuitionRegistration.siblings.studentId = ''
                          _ctx.freeTuitionRegistration.siblings.fullName = ''
                        },
                                  value: promotion.code,
                                  "onUpdate:modelValue": _cache[197] || (_cache[197] = ($event: any) => ((_ctx.orderDetails.otherPromotionsVipPro.code) = $event))
                                }, null, 40, _hoisted_941), [
                                  [_vModelRadio, _ctx.orderDetails.otherPromotionsVipPro.code]
                                ]),
                                _createElementVNode("span", _hoisted_942, [
                                  _createElementVNode("span", _hoisted_943, _toDisplayString(promotion.name), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.dataPromotionListen )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["w-100 notice bg-light-warning rounded border-warning border border-dashed mb-3 p-4", _ctx.expiredPromotion?'disabled':''])
                      }, [
                        _createElementVNode("div", _hoisted_944, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["fw-bolder fs-6 mb-0", { required: _ctx.dataPromotionListen.benefit.filter(item=>!item.allowMultiPromotions).length != 0 }])
                          }, _toDisplayString(_ctx.dataPromotionListen.promotionName), 3)
                        ]),
                        _createElementVNode("div", _hoisted_945, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPromotionListen.benefit.filter(item=>!item.allowMultiPromotions), (promotion, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "",
                              key: index
                            }, [
                              _createElementVNode("label", _hoisted_946, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input me-3",
                                  type: "radio",
                                  name: "endow",
                                  onChange: _cache[198] || (_cache[198] = e=>{
                          _ctx.firstLoad = false
                          _ctx.orderDetails.otherPromotionsVipPro = {}
                          _ctx.moneyPromotionVipPro = 0
                        }),
                                  value: promotion.value,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.orderDetails.promotion.value) = $event)
                                }, null, 40, _hoisted_947), [
                                  [_vModelRadio, _ctx.orderDetails.promotion.value]
                                ]),
                                _createElementVNode("span", _hoisted_948, [
                                  _createElementVNode("span", _hoisted_949, _toDisplayString(promotion.name), 1)
                                ])
                              ])
                            ]))
                          }), 128)),
                          (_ctx.dataPromotionListen.benefit.filter(item=>item.allowMultiPromotions).length !=0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.dataPromotionListen.benefit.filter(item=>!item.allowMultiPromotions).length !=0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _hoisted_950,
                                      _hoisted_951
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPromotionListen.benefit.filter(item=>item.allowMultiPromotions), (promotion, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "",
                                    key: index
                                  }, [
                                    _createElementVNode("label", _hoisted_952, [
                                      _createElementVNode("input", {
                                        class: "form-check-input me-3",
                                        type: "checkbox",
                                        name: "otherpromotion",
                                        checked: (_ctx.orderDetails.otherPromotions||[]).some(i => i && (i.code!=null && promotion.code!=null ? i.code==promotion.code : (i.name==promotion.name && String(i.value)==String(promotion.value)))),
                                        onChange: e=>{
                            _ctx.firstLoad = false
                            _ctx.orderDetails.otherPromotions = (_ctx.orderDetails.otherPromotions||[]).filter(i => !(i && (i.code!=null && promotion.code!=null ? i.code==promotion.code : (i.name==promotion.name && String(i.value)==String(promotion.value)))))
                            if(e.target.checked){ _ctx.orderDetails.otherPromotions.push({...promotion, amount: Number(promotion.amount != null ? promotion.amount : promotion.value)}) }
                          }
                                      }, null, 40, _hoisted_953),
                                      _createElementVNode("span", _hoisted_954, [
                                        _createElementVNode("span", _hoisted_955, _toDisplayString(promotion.name), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.orderDetails.promotion.value && _ctx.dataPromotionListen && _ctx.dataPromotionListen.addition )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_956, [
                                _hoisted_957,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPromotionListen.addition, (promotion, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "",
                                    key: index
                                  }, [
                                    _createElementVNode("label", _hoisted_958, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input me-3",
                                        type: "radio",
                                        name: "otherpromotion",
                                        value: {
                              description: promotion.description,
                              name: promotion.name,
                              value: promotion.value,
                            },
                                        onChange: _cache[199] || (_cache[199] = ($event: any) => (_ctx.firstLoad = false)),
                                        disabled: !!!_ctx.orderDetails.promotion.value,
                                        "onUpdate:modelValue": _cache[200] || (_cache[200] = ($event: any) => ((_ctx.orderDetails.otherPromotionsVip) = $event))
                                      }, null, 40, _hoisted_959), [
                                        [_vModelRadio, _ctx.orderDetails.otherPromotionsVip]
                                      ]),
                                      _createElementVNode("span", _hoisted_960, [
                                        _createElementVNode("span", _hoisted_961, _toDisplayString(promotion.name) + " trị giá " + _toDisplayString(promotion.value?.toLocaleString("vi-VN")), 1),
                                        (promotion.condition?.length || promotion.description)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_962, [
                                              _hoisted_963,
                                              (promotion.condition?.length)
                                                ? (_openBlock(), _createElementBlock("ul", _hoisted_964, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotion.condition, (con, ind) => {
                                                      return (_openBlock(), _createElementBlock("li", {
                                                        key: ind,
                                                        class: "fs-7 mb-0"
                                                      }, _toDisplayString(con.description), 1))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_965, _toDisplayString(promotion.description), 1))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.dataPromotionListenAddition )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_966, [
                        _createElementVNode("div", _hoisted_967, [
                          _createElementVNode("span", _hoisted_968, _toDisplayString(_ctx.dataPromotionListenAddition.promotionName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_969, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataPromotionListenAddition.benefit, (promotion, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "",
                              key: index
                            }, [
                              _createElementVNode("label", _hoisted_970, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input me-3",
                                  type: "radio",
                                  name: "endowAddition",
                                  onChange: _cache[201] || (_cache[201] = e=>{
                          _ctx.firstLoad = false
                          // orderDetails.otherPromotionsVipPro = {}
                          // moneyPromotionVipPro = 0
                        }),
                                  value: promotion.value,
                                  "onUpdate:modelValue": _cache[202] || (_cache[202] = ($event: any) => ((_ctx.orderDetails.promotionAddition.value) = $event))
                                }, null, 40, _hoisted_971), [
                                  [_vModelRadio, _ctx.orderDetails.promotionAddition.value]
                                ]),
                                _createElementVNode("span", _hoisted_972, [
                                  _createElementVNode("span", _hoisted_973, _toDisplayString(promotion.name), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.dataPromotionListenMulti)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.dataPromotionListenMulti, (itempromotion, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "w-100 notice bg-light-warning rounded border-warning border border-dashed mb-3 p-4",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_974, [
                            _createElementVNode("span", _hoisted_975, _toDisplayString(itempromotion.promotionName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_976, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itempromotion.benefit, (promotion, ind) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "",
                                key: ind
                              }, [
                                _createElementVNode("label", _hoisted_977, [
                                  _createElementVNode("input", {
                                    class: "form-check-input me-3",
                                    type: "radio",
                                    name: `promotionmulti_${index}_${promotion.allowMultiPromotions?ind:''}`,
                                    onChange: _cache[203] || (_cache[203] = 
//@ts-ignore
(...args) => (_ctx.changeMultiPromotion && _ctx.changeMultiPromotion(...args))),
                                    value: promotion,
                                    checked: _ctx.promotionMultiData.find(i=> i.name == promotion.name)
                                  }, null, 40, _hoisted_978),
                                  _createElementVNode("span", _hoisted_979, [
                                    _createElementVNode("span", _hoisted_980, _toDisplayString(promotion.name), 1)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_981, [
                      (_ctx.dataPromotionListen && _ctx.dataPromotionListen.promotionCode == _ctx.PROMOTIONSIBLING.code && _ctx.orderDetails.promotion.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_982, [
                            _hoisted_983,
                            _createElementVNode("label", _hoisted_984, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input me-3",
                                type: "checkbox",
                                name: "registrationTypeSiblings",
                                onChange: _cache[204] || (_cache[204] = ($event: any) => (_ctx.firstLoad = false)),
                                value: true,
                                "onUpdate:modelValue": _cache[205] || (_cache[205] = ($event: any) => ((
                          _ctx.freeTuitionRegistration.registrationTypeSiblings
                        ) = $event))
                              }, null, 544), [
                                [_vModelCheckbox, 
                          _ctx.freeTuitionRegistration.registrationTypeSiblings
                        ]
                              ]),
                              _hoisted_985
                            ]),
                            (_ctx.freeTuitionRegistration.registrationTypeSiblings)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["fv-row col-lg-8 col-md-8 col-12", _ctx.isMobile ? '' : 'd-flex gap-5 w-100 ps-12 mb-4'])
                                }, [
                                  _createElementVNode("div", null, [
                                    _hoisted_986,
                                    _createVNode(_component_el_form_item, {
                                      rules: _ctx.rulesSiblings()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Mã hồ sơ",
                                          modelValue: _ctx.freeTuitionRegistration.siblings.studentId,
                                          "onUpdate:modelValue": _cache[206] || (_cache[206] = ($event: any) => ((_ctx.freeTuitionRegistration.siblings.studentId) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _hoisted_987,
                                    _createVNode(_component_el_form_item, {
                                      rules: _ctx.rulesSiblings()
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          type: "text",
                                          class: "w-100 input-custom",
                                          placeholder: "Họ và tên",
                                          modelValue: _ctx.freeTuitionRegistration.siblings.fullName,
                                          "onUpdate:modelValue": _cache[207] || (_cache[207] = ($event: any) => ((_ctx.freeTuitionRegistration.siblings.fullName) = $event))
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["rules"])
                                  ])
                                ], 2))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dataScholarship.length != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_988, [
                            _createElementVNode("label", _hoisted_989, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input me-3",
                                type: "checkbox",
                                name: "dataScholarship",
                                value: _ctx.dataScholarship,
                                disabled: !_ctx.checkConditionscholarship || (_ctx.dataScholarship[0]['Scholarship.isactive'] === false && !_ctx.dataScholarshipPro.scholarship),
                                onChange: _cache[208] || (_cache[208] = e=>{
                          _ctx.changeScholaship(e)
                        }),
                                "onUpdate:modelValue": _cache[209] || (_cache[209] = ($event: any) => ((
                          _ctx.dataScholarshipPro.scholarship
                        ) = $event))
                              }, null, 40, _hoisted_990), [
                                [_vModelCheckbox, 
                          _ctx.dataScholarshipPro.scholarship
                        ]
                              ]),
                              _createElementVNode("span", _hoisted_991, [
                                _createElementVNode("span", _hoisted_992, _toDisplayString(_ctx.dataScholarship[0]['Scholarship.description']), 1),
                                (_ctx.dataScholarship[0]['Scholarship.condition']?.date)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_993, " với điều kiện " + _toDisplayString(_ctx.dataScholarship[0]['Scholarship.condition']?.description), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (_ctx.dataScholarshipListenAddition && _ctx.dataScholarshipPro.scholarship)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_994, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataScholarshipListenAddition, (itempromotion, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "w-100 notice bg-light-warning rounded border-warning border border-dashed mb-3 p-4",
                                      key: index
                                    }, [
                                      (itempromotion.benefitaddition?.length != 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_995, [
                                            _createElementVNode("span", _hoisted_996, _toDisplayString(itempromotion.namepromotion), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (itempromotion && itempromotion.benefitaddition)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_997, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itempromotion.benefitaddition, (promotion, ind) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "",
                                                key: ind
                                              }, [
                                                _createElementVNode("label", _hoisted_998, [
                                                  _createElementVNode("input", {
                                                    class: "form-check-input me-3",
                                                    type: "radio",
                                                    name: `scholarshippromotionmulti_${index}}`,
                                                    value: promotion,
                                                    onChange: _cache[210] || (_cache[210] = 
//@ts-ignore
(...args) => (_ctx.scholarshippromotionmultiChange && _ctx.scholarshippromotionmultiChange(...args))),
                                                    checked: _ctx.scholarshipPromotionMultiData.find(i=> i.name == promotion.name)
                                                  }, null, 40, _hoisted_999),
                                                  _createElementVNode("span", _hoisted_1000, [
                                                    _createElementVNode("span", _hoisted_1001, _toDisplayString(promotion.name), 1)
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_1002, [
                              (_ctx.dataScholarshipPro.scholarship && (_ctx.dataScholarshipAdditionExtend.length != 0 || _ctx.dataScholarshipAddition.length != 0))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1003, [
                                    _createElementVNode("div", _hoisted_1004, [
                                      _createTextVNode(" Ưu đãi đi kèm "),
                                      _createElementVNode("span", _hoisted_1005, _toDisplayString(_ctx.dataScholarship[0]['Scholarship.description']), 1)
                                    ]),
                                    (_ctx.dataScholarshipPro.scholarship && _ctx.dataScholarship[0]['Scholarship.addition'] && _ctx.dataScholarshipAdditionExtend.length !=0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_1006, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataScholarshipAdditionExtend, (promotion, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "",
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_1007, [
                                                _withDirectives(_createElementVNode("input", {
                                                  class: "form-check-input me-3",
                                                  type: "checkbox",
                                                  name: "inputPromotionExtend",
                                                  value: promotion,
                                                  onChange: _cache[211] || (_cache[211] = 
//@ts-ignore
(...args) => (_ctx.changePromotionExtend && _ctx.changePromotionExtend(...args))),
                                                  "onUpdate:modelValue": _cache[212] || (_cache[212] = ($event: any) => ((_ctx.dataScholarshipPro.promotionExtend) = $event))
                                                }, null, 40, _hoisted_1008), [
                                                  [_vModelCheckbox, _ctx.dataScholarshipPro.promotionExtend]
                                                ]),
                                                _createElementVNode("span", _hoisted_1009, [
                                                  _createElementVNode("span", _hoisted_1010, _toDisplayString(promotion.name) + " trị giá " + _toDisplayString(promotion.value?.toLocaleString("vi-VN")), 1),
                                                  (promotion.condition?.length || promotion.description)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1011, [
                                                        _hoisted_1012,
                                                        (promotion.condition?.length)
                                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_1013, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotion.condition, (con, ind) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                  key: ind,
                                                                  class: "fs-7 mb-0"
                                                                }, _toDisplayString(con.description), 1))
                                                              }), 128))
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_1014, _toDisplayString(promotion.description), 1))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.dataScholarshipPro.scholarship && _ctx.dataScholarship[0]['Scholarship.addition'] && _ctx.dataScholarshipAddition.length !=0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_1015, [
                                          _hoisted_1016,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataScholarshipAddition, (promotion, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "",
                                              key: index
                                            }, [
                                              _createElementVNode("label", _hoisted_1017, [
                                                _createElementVNode("input", {
                                                  class: "form-check-input me-3",
                                                  type: "checkbox",
                                                  name: "otherpromotion",
                                                  checked: _ctx.dataScholarshipPro.promotion && _ctx.dataScholarshipPro.promotion.name == promotion.name && _ctx.dataScholarshipPro.promotion.value == promotion.value,
                                                  onChange: e=>{
                                  _ctx.firstLoad = false
                                  _ctx.dataScholarshipPro.promotion = e.target.checked ? promotion : null
                                }
                                                }, null, 40, _hoisted_1018),
                                                _createElementVNode("span", _hoisted_1019, [
                                                  _createElementVNode("span", _hoisted_1020, _toDisplayString(promotion.name) + " trị giá " + _toDisplayString(promotion.value?.toLocaleString("vi-VN")), 1),
                                                  (promotion.condition?.length || promotion.description)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1021, [
                                                        _hoisted_1022,
                                                        (promotion.condition?.length)
                                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_1023, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotion.condition, (con, ind) => {
                                                                return (_openBlock(), _createElementBlock("li", {
                                                                  key: ind,
                                                                  class: "fs-7 mb-0"
                                                                }, _toDisplayString(con.description), 1))
                                                              }), 128))
                                                            ]))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_1024, _toDisplayString(promotion.description), 1))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.englishClassPlacementTest.registrationType == 'umt_test' && _ctx.arrChooseCourseexemptions)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _hoisted_1025,
                        _createElementVNode("div", _hoisted_1026, [
                          _hoisted_1027,
                          _createElementVNode("div", _hoisted_1028, [
                            _createElementVNode("div", _hoisted_1029, [
                              _hoisted_1030,
                              _createVNode(_component_el_input, {
                                onChange: _cache[213] || (_cache[213] = e=>{_ctx.firstLoad = false}),
                                type: "text",
                                class: "w-100 input-custom",
                                placeholder: "Nhập điểm",
                                modelValue: _ctx.englishClassPlacementTest.englishCertificate.score,
                                "onUpdate:modelValue": _cache[214] || (_cache[214] = ($event: any) => ((_ctx.englishClassPlacementTest.englishCertificate.score) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_1031, [
                              _hoisted_1032,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.chooseCourses.code,
                                "onUpdate:modelValue": _cache[215] || (_cache[215] = ($event: any) => ((_ctx.chooseCourses.code) = $event)),
                                onChange: _ctx.changeChooseCourse,
                                disabled: !_ctx.isShowFreeTuition,
                                clearable: "",
                                class: "form-select-solid w-100",
                                "popper-class": "umt-form-dd",
                                placeholder: "Chọn cấp độ",
                                size: "large"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrChooseCourseexemptions, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.name,
                                      value: item.code
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange", "disabled"])
                            ])
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_1033, [
                  (_ctx.tuitionRegistration.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1034, [
                        _createElementVNode("div", _hoisted_1035, [
                          _createElementVNode("span", null, "Học phí " + _toDisplayString(_ctx.dataTuition[_ctx.tuitionRegistration.name]?.label), 1),
                          _createElementVNode("span", null, _toDisplayString((+_ctx.dataTuition[_ctx.tuitionRegistration.name]
                      ?.value).toLocaleString("vi-VN")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_1036, [
                          (_ctx.reduceEnglish)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1037, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.reduceEnglish.label), 1),
                                _createElementVNode("span", _hoisted_1038, "- " + _toDisplayString((+_ctx.reduceEnglish.value).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.courseNextLevel && Array.isArray(_ctx.courseNextLevel))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.courseNextLevel, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex flex-stack fs-6 mb-2",
                                  key: index
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(item.description), 1),
                                  _createElementVNode("span", _hoisted_1039, _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.arrCourseexemptionsShow)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.arrCourseexemptionsShow, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "d-flex flex-stack fs-6 mb-2"
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(item.description), 1),
                                  _createElementVNode("span", _hoisted_1040, "- " + _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.freeTuitionRegistration.registrationTypeSiblings)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1041, [
                                _createElementVNode("span", null, [
                                  _createTextVNode(" Có anh/chị/em ruột cùng nhập học tại UMT "),
                                  (_ctx.freeTuitionUnit == '%')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1042, "(-" + _toDisplayString(_ctx.freeTuitionDiscount) + " %)", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_1043, "-" + _toDisplayString((+_ctx.moneySiblings.toFixed(0)).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionMultiData, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "d-flex flex-stack fs-6 mb-2",
                              key: index
                            }, [
                              _createElementVNode("span", null, [
                                (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "cursor-pointer me-1",
                                      title: "Bỏ ưu đãi này",
                                      onClick: e=>{
                        _ctx.promotionMultiData = _ctx.promotionMultiData.filter((i,ind) => ind !=index)
                        _ctx.firstLoad = false
                      }
                                    }, _hoisted_1046, 8, _hoisted_1044))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(item.name), 1)
                              ]),
                              (item.type != 'gift')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1047, "- " + _toDisplayString((+item.valueAmount?.toFixed(0))?.toLocaleString("vi-VN")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          (_ctx.orderDetails.otherPromotions?.length !=0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.orderDetails.otherPromotions, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex flex-stack fs-6 mb-2",
                                  key: index
                                }, [
                                  _createElementVNode("span", null, [
                                    (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "cursor-pointer me-1",
                                          title: "Bỏ ưu đãi này",
                                          onClick: e=>{
                        _ctx.orderDetails.otherPromotions = _ctx.orderDetails.otherPromotions.filter((i,ind) => ind != index)
                        _ctx.firstLoad = false
                      }
                                        }, _hoisted_1050, 8, _hoisted_1048))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_1051, "- " + _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.orderDetails.otherPromotionsVip && _ctx.orderDetails.otherPromotionsVip.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1052, [
                                _createElementVNode("span", null, [
                                  (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "cursor-pointer me-1",
                                        title: "Bỏ ưu đãi này",
                                        onClick: _cache[216] || (_cache[216] = e=>{
                      _ctx.orderDetails.otherPromotionsVip = {}
                      _ctx.firstLoad = false
                    })
                                      }, _hoisted_1054))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.orderDetails.otherPromotionsVip.name), 1)
                                ]),
                                _createElementVNode("span", _hoisted_1055, "- " + _toDisplayString((+_ctx.orderDetails.otherPromotionsVip.value).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderDetails.otherPromotionsVipPro && _ctx.orderDetails.otherPromotionsVipPro.percent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1056, [
                                _createElementVNode("span", null, [
                                  (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "cursor-pointer me-1",
                                        title: "Bỏ ưu đãi này",
                                        onClick: _cache[217] || (_cache[217] = e=>{
                      _ctx.orderDetails.otherPromotionsVipPro = {}
                      _ctx.moneyPromotionVipPro = 0
                      _ctx.firstLoad = false
                    })
                                      }, _hoisted_1058))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.orderDetails.otherPromotionsVipPro.name), 1)
                                ]),
                                _createElementVNode("span", _hoisted_1059, "-" + _toDisplayString((+_ctx.moneyPromotionVipPro.toFixed(0)).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.tempDataPromotion)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1060, [
                                _createElementVNode("span", null, [
                                  (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "cursor-pointer me-1",
                                        title: "Bỏ ưu đãi này",
                                        onClick: _cache[218] || (_cache[218] = e=>{
                          _ctx.orderDetails.promotion.value = ''
                          _ctx.tempDataPromotion = null;
                          _ctx.tempDataPromotionAddition = null

                          _ctx.orderDetails.otherPromotions = []
                          _ctx.orderDetails.otherPromotionsVip = {}
                          _ctx.firstLoad = false
                      })
                                      }, _hoisted_1062))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.tempDataPromotion.name), 1)
                                ]),
                                (_ctx.tempDataPromotion.type != 'gift')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_1063, "- " + _toDisplayString((+_ctx.moneyPromotion.toFixed(0)).toLocaleString("vi-VN")), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_1064, [
                            (_ctx.dataScholarshipPro.promotionExtend && _ctx.dataScholarshipPro.promotionExtend.length != 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataScholarshipPro.promotionExtend, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "d-flex flex-stack fs-6 mb-2"
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                    _createElementVNode("span", _hoisted_1065, "- " + _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true),
                            (_ctx.dataScholarshipPro.promotion)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1066, [
                                  _createElementVNode("span", null, [
                                    (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "cursor-pointer me-1",
                                          title: "Bỏ ưu đãi này",
                                          onClick: _cache[219] || (_cache[219] = e=>{
                        _ctx.dataScholarshipPro.promotion = null
                        _ctx.firstLoad = false
                      })
                                        }, _hoisted_1068))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.dataScholarshipPro.promotion.name), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_1069, "- " + _toDisplayString((+_ctx.dataScholarshipPro.promotion.value).toLocaleString("vi-VN")), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipPromotionMultiData, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-flex flex-stack fs-6 mb-2",
                                key: index
                              }, [
                                _createElementVNode("span", null, [
                                  (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "cursor-pointer me-1",
                                        title: "Bỏ ưu đãi này",
                                        onClick: e=>{
                          _ctx.scholarshipPromotionMultiData = _ctx.scholarshipPromotionMultiData.filter((i,ind) => ind !=index)
                          _ctx.firstLoad = false
                        }
                                      }, _hoisted_1072, 8, _hoisted_1070))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(item.name), 1)
                                ]),
                                (item.type != 'gift')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_1073, "- " + _toDisplayString((+item.valueAmount?.toFixed(0))?.toLocaleString("vi-VN")), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            (_ctx.tempDataPromotionAddition)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1074, [
                                  _createElementVNode("span", null, [
                                    (!_ctx.isChuyengiao && _ctx.isShowFreeTuition)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "cursor-pointer me-1",
                                          title: "Bỏ ưu đãi này",
                                          onClick: _cache[220] || (_cache[220] = e=>{
                          _ctx.orderDetails.promotionAddition = {}
                          _ctx.moneyPromotionAddition = 0
                          _ctx.tempDataPromotionAddition = null;
                          _ctx.firstLoad = false
                      })
                                        }, _hoisted_1076))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.tempDataPromotionAddition.name), 1)
                                  ]),
                                  (_ctx.tempDataPromotionAddition.type != 'gift')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1077, "- " + _toDisplayString((+_ctx.moneyPromotionAddition.toFixed(0)).toLocaleString("vi-VN")), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.dataScholarship.length != 0 && _ctx.dataScholarshipPro.scholarship)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1078, [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("span", _hoisted_1079, _toDisplayString(// dataScholarship[0]?.description
                        _ctx.dataScholarship[0]['Scholarship.description']), 1),
                                    (_ctx.dataScholarship[0]['Scholarship.rate'])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_1080, "(" + _toDisplayString(Math.round(+_ctx.dataScholarship[0]['Scholarship.rate']*100)) + "% học phí)", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.scholarshipValueListen)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1081, "- " + _toDisplayString((
                          _ctx.scholarshipValueListen
                        ).toLocaleString("vi-VN")), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_1082, [
                          _hoisted_1083,
                          _createElementVNode("strong", _hoisted_1084, _toDisplayString(_ctx.totalFee.toLocaleString("vi-VN")) + " đ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_1085, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFindprereceipts, (i, ind) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "d-flex flex-stack fs-6 mb-2",
                              key: ind
                            }, [
                              _createElementVNode("span", null, _toDisplayString(i.items[0]?.description), 1),
                              _createElementVNode("span", _hoisted_1086, _toDisplayString(+i.paymentConfirmation?.paid > 0 ?'-':'') + " " + _toDisplayString((Math.abs(+i.paymentConfirmation?.paid)).toLocaleString("vi-VN")), 1)
                            ]))
                          }), 128))
                        ]),
                        (_ctx.dataFindprereceipts.length !=0)
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_1087))
                          : _createCommentVNode("", true),
                        (_ctx.dataFindprereceipts.length !=0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1088, [
                              _hoisted_1089,
                              _createElementVNode("strong", _hoisted_1090, _toDisplayString(_ctx.totalFeeTuition.toLocaleString("vi-VN")) + " đ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isShowFreeTuition && _ctx.tuitionRegistration.name && !_ctx.isLocked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1091, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["btn btn-sm btn-primary fw-bold me-auto cursor-pointer", { 'mt-4': _ctx.isMobile }]),
                          onClick: _cache[221] || (_cache[221] = e=>{
                  _ctx.sendMailStudent(_ctx.id)
                })
                        }, _hoisted_1093, 2)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.isShowFreeTuition)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1094, [
                    (_ctx.checkIsUpdateScholarship && _ctx.firstLoad)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_1095, "(Kiểm tra lại chương trình học bổng)"))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      onClick: _cache[222] || (_cache[222] = ($event: any) => {
                _ctx.initfreeTuitionRegistration(true);
                _ctx.isShowFreeTuition = false;
              }),
                      class: "btn btn-white btn-active-light-primary me-2"
                    }, " Hủy bỏ "),
                    _hoisted_1096
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_1097, [
      _createElementVNode("div", _hoisted_1098, [
        _createElementVNode("div", _hoisted_1099, [
          _createElementVNode("div", _hoisted_1100, [
            _createElementVNode("h3", _hoisted_1101, [
              _createElementVNode("span", _hoisted_1102, _toDisplayString(_ctx.sectionNo.payment), 1),
              _createTextVNode("Lựa chọn phương thức thanh toán")
            ]),
            (_ctx.selectedPaymentName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1103, _toDisplayString(_ctx.selectedPaymentName), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLocked)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1104, [
                (!_ctx.isShowPayments && (!_ctx.dataReceipt ))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[224] || (_cache[224] = _withModifiers(($event: any) => (_ctx.isShowPayments = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_1105, [
                        _createElementVNode("span", _hoisted_1106, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_1107, [
        _createElementVNode("div", _hoisted_1108, [
          _createVNode(_component_Form, {
            id: "kt_account_connected_accounts_tuitionReg",
            class: "form",
            novalidate: "novalidate",
            onSubmit: _cache[226] || (_cache[226] = ($event: any) => (_ctx.submitPayments()))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1109, [
                _createElementVNode("div", _hoisted_1110, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1111, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionBanking, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: index
                        }, [
                          _createElementVNode("label", _hoisted_1112, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input me-3",
                              type: "radio",
                              name: "feetuition",
                              value: item.code,
                              disabled: !_ctx.isShowPayments,
                              "onUpdate:modelValue": _cache[225] || (_cache[225] = ($event: any) => ((_ctx.orderDetails.paymentMethod) = $event))
                            }, null, 8, _hoisted_1113), [
                              [_vModelRadio, _ctx.orderDetails.paymentMethod]
                            ]),
                            _createElementVNode("div", _hoisted_1114, [
                              _createElementVNode("span", _hoisted_1115, _toDisplayString(item.name), 1),
                              (_ctx.orderDetails.paymentMethod == item.code)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    innerHTML: item.description,
                                    class: "w-100 notice umt-payment-desc bg-light text-gray-800 rounded border-gray-300 border border-dashed p-4 mt-3"
                                  }, null, 8, _hoisted_1116))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_1117, [
                  (_ctx.tuitionRegistration.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1118, [
                        _hoisted_1119,
                        _createElementVNode("div", _hoisted_1120, [
                          _createElementVNode("span", null, "Học phí " + _toDisplayString(_ctx.dataTuition[_ctx.tuitionRegistration.name]?.label), 1),
                          _createElementVNode("span", null, _toDisplayString((+_ctx.dataTuition[_ctx.tuitionRegistration.name]
                      ?.value).toLocaleString("vi-VN")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_1121, [
                          (_ctx.reduceEnglish)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1122, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.reduceEnglish.label), 1),
                                _createElementVNode("span", _hoisted_1123, "- " + _toDisplayString((+_ctx.reduceEnglish.value).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.courseNextLevel && Array.isArray(_ctx.courseNextLevel))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.courseNextLevel, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex flex-stack fs-6 mb-2",
                                  key: index
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(item.description), 1),
                                  _createElementVNode("span", _hoisted_1124, _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.arrCourseexemptionsShow)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.arrCourseexemptionsShow, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "d-flex flex-stack fs-6 mb-2"
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(item.description), 1),
                                  _createElementVNode("span", _hoisted_1125, "- " + _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.freeTuitionRegistration.registrationTypeSiblings)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1126, [
                                _createElementVNode("span", null, [
                                  _createTextVNode(" Có anh/chị/em ruột cùng nhập học tại UMT "),
                                  (_ctx.freeTuitionUnit == '%')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1127, "(-" + _toDisplayString(_ctx.freeTuitionDiscount) + " %)", 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_1128, "-" + _toDisplayString((+_ctx.moneySiblings.toFixed(0)).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionMultiData, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "d-flex flex-stack fs-6 mb-2",
                              key: index
                            }, [
                              _createElementVNode("span", null, _toDisplayString(item.name), 1),
                              (item.type != 'gift')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1129, "- " + _toDisplayString((+item.valueAmount?.toFixed(0))?.toLocaleString("vi-VN")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128)),
                          (_ctx.orderDetails.otherPromotions?.length !=0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(_ctx.orderDetails.otherPromotions, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "d-flex flex-stack fs-6 mb-2",
                                  key: index
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                  _createElementVNode("span", _hoisted_1130, "- " + _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (_ctx.orderDetails.otherPromotionsVip && _ctx.orderDetails.otherPromotionsVip.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1131, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.orderDetails.otherPromotionsVip.name), 1),
                                _createElementVNode("span", _hoisted_1132, "- " + _toDisplayString((+_ctx.orderDetails.otherPromotionsVip.value).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.orderDetails.otherPromotionsVipPro && _ctx.orderDetails.otherPromotionsVipPro.percent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1133, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.orderDetails.otherPromotionsVipPro.name), 1),
                                _createElementVNode("span", _hoisted_1134, "-" + _toDisplayString((+_ctx.moneyPromotionVipPro.toFixed(0)).toLocaleString("vi-VN")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.tempDataPromotion)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1135, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.tempDataPromotion.name), 1),
                                (_ctx.tempDataPromotion.type != 'gift')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_1136, "- " + _toDisplayString((+_ctx.moneyPromotion.toFixed(0)).toLocaleString("vi-VN")), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", null, [
                            (_ctx.dataScholarshipPro.promotionExtend && _ctx.dataScholarshipPro.promotionExtend.length != 0)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataScholarshipPro.promotionExtend, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: "d-flex flex-stack fs-6 mb-2"
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                    _createElementVNode("span", _hoisted_1137, "- " + _toDisplayString((+item.value).toLocaleString("vi-VN")), 1)
                                  ]))
                                }), 128))
                              : _createCommentVNode("", true),
                            (_ctx.dataScholarshipPro.promotion)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1138, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.dataScholarshipPro.promotion.name), 1),
                                  _createElementVNode("span", _hoisted_1139, "- " + _toDisplayString((+_ctx.dataScholarshipPro.promotion.value).toLocaleString("vi-VN")), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scholarshipPromotionMultiData, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "d-flex flex-stack fs-6 mb-2",
                                key: index
                              }, [
                                _createElementVNode("span", null, _toDisplayString(item.name), 1),
                                (item.type != 'gift')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_1140, "- " + _toDisplayString((+item.valueAmount?.toFixed(0))?.toLocaleString("vi-VN")), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            (_ctx.tempDataPromotionAddition)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1141, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.tempDataPromotionAddition.name), 1),
                                  (_ctx.tempDataPromotionAddition.type != 'gift')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1142, "- " + _toDisplayString((+_ctx.moneyPromotionAddition.toFixed(0)).toLocaleString("vi-VN")), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.dataScholarship.length != 0 && _ctx.dataScholarshipPro.scholarship)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1143, [
                                  _createElementVNode("span", null, [
                                    _createElementVNode("span", _hoisted_1144, _toDisplayString(// dataScholarship[0]?.description
                      _ctx.dataScholarship[0]['Scholarship.description']), 1),
                                    (_ctx.dataScholarship[0]['Scholarship.rate'])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_1145, "(" + _toDisplayString(Math.round(+_ctx.dataScholarship[0]['Scholarship.rate']*100)) + "% học phí)", 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.scholarshipValueListen)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1146, "- " + _toDisplayString(parseInt(
                        _ctx.scholarshipValueListen
                      ).toLocaleString("vi-VN")), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.isInsurance)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                (
                    _ctx.dataSettingItem.length != 0 &&
                    _ctx.socialHealthcareInsuranceRegistration.type &&
                    _ctx.socialHealthcareInsuranceRegistration.type != 'other'
                  )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_1147, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.dataSettingItem.filter(
                      (i) =>
                        i.type == _ctx.socialHealthcareInsuranceRegistration.type
                    )[0]?.name), 1),
                                      _createElementVNode("span", null, _toDisplayString((+_ctx.dataSettingItem.filter(
                      (i) =>
                        i.type == _ctx.socialHealthcareInsuranceRegistration.type
                    )[0]?.price).toLocaleString("vi-VN")), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                    _ctx.accidentInsuranceRegistration && _ctx.dataSettingItem.length != 0
                  )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_1148, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.dataSettingItem.filter((i) => i.type == "BHTN15")[0]?.name), 1),
                                      _createElementVNode("span", null, _toDisplayString((+_ctx.dataSettingItem.filter((i) => i.type == "BHTN15")[0]
                      ?.price).toLocaleString("vi-VN")), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.isUniform)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                _createElementVNode("div", _hoisted_1149, [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("Tặng 1 bộ đồng phục thể dục "),
                                    (_ctx.uniformRegistration.defaultSize != '')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" size " + _toDisplayString(_ctx.uniformRegistration.defaultSize), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _hoisted_1150
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherFees, (item, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "",
                                    key: index
                                  }, [
                                    (item.quantity != 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_1151, [
                                          _createElementVNode("span", null, [
                                            _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                            (item.type != 'CAPS')
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" size " + _toDisplayString(item.size), 1)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" x " + _toDisplayString(item.quantity), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_1152, _toDisplayString((
                        +item.price *
                        item.quantity
                      ).toLocaleString("vi-VN")), 1)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_1153, [
                          _hoisted_1154,
                          _createElementVNode("strong", _hoisted_1155, _toDisplayString(_ctx.totalFee.toLocaleString("vi-VN")) + " đ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_1156, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFindprereceipts, (i, ind) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "d-flex flex-stack fs-6 mb-2",
                              key: ind
                            }, [
                              _createElementVNode("span", null, _toDisplayString(i.items[0]?.description), 1),
                              _createElementVNode("span", _hoisted_1157, _toDisplayString(+i.paymentConfirmation?.paid > 0 ?'-':'') + " " + _toDisplayString((Math.abs(+i.paymentConfirmation?.paid)).toLocaleString("vi-VN")), 1)
                            ]))
                          }), 128))
                        ]),
                        (_ctx.dataFindprereceipts.length !=0)
                          ? (_openBlock(), _createElementBlock("hr", _hoisted_1158))
                          : _createCommentVNode("", true),
                        (_ctx.dataFindprereceipts.length !=0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1159, [
                              _hoisted_1160,
                              _createElementVNode("strong", _hoisted_1161, _toDisplayString(_ctx.totalFeeTuition.toLocaleString("vi-VN")) + " đ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        (_ctx.isShowPayments)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1162, [
              _createElementVNode("span", {
                onClick: _cache[227] || (_cache[227] = ($event: any) => {
            _ctx.initPayments();
            _ctx.isShowPayments = false;
          }),
                class: "btn btn-white btn-active-light-primary me-2"
              }, " Hủy bỏ "),
              _createElementVNode("button", {
                ref: "submitButton2",
                class: "btn btn-primary",
                onClick: _cache[228] || (_cache[228] = ($event: any) => (_ctx.submitPayments()))
              }, _hoisted_1165, 512)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_1166, [
          _hoisted_1167,
          _createElementVNode("div", _hoisted_1168, [
            _createElementVNode("div", _hoisted_1169, [
              _createElementVNode("div", _hoisted_1170, [
                _createElementVNode("form", _hoisted_1171, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "d-none",
                    name: "idAdReg",
                    "onUpdate:modelValue": _cache[229] || (_cache[229] = ($event: any) => ((_ctx.idAdReg) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.idAdReg]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "d-none",
                    name: "adCode",
                    "onUpdate:modelValue": _cache[230] || (_cache[230] = ($event: any) => ((_ctx.adCode) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.adCode]
                  ]),
                  _createElementVNode("span", _hoisted_1172, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil010.svg" })
                  ])
                ]),
                _createVNode(_component_ErrorMessage, {
                  class: "fv-plugins-message-container invalid-feedback",
                  name: "files"
                })
              ]),
              _createElementVNode("div", _hoisted_1173, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataImg, (customer, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "position-relative flex-25 hover-file",
                    key: index
                  }, [
                    _createElementVNode("span", _hoisted_1174, [
                      (customer.processing)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1175, [
                            _createElementVNode("div", _hoisted_1176, [
                              _createElementVNode("img", {
                                src: `/media/svg/files/${_ctx.getTypeFile(
                        customer.fileType
                      )}.svg`,
                                alt: ""
                              }, null, 8, _hoisted_1177)
                            ]),
                            _createElementVNode("div", _hoisted_1178, [
                              _createElementVNode("div", {
                                class: "progress-bar progress-bar-primary data-dz-uploadprogress",
                                role: "progressbar",
                                id: customer.id
                              }, _hoisted_1181, 8, _hoisted_1179)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_1182, [
                            (_ctx.getTypeFile(customer.fileType) == 'image')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: customer.filePath,
                                  alt: ""
                                }, null, 8, _hoisted_1183))
                              : (_openBlock(), _createElementBlock("div", _hoisted_1184, [
                                  _createElementVNode("img", {
                                    src: `/media/svg/files/${_ctx.getTypeFile(
                        customer.fileType
                      )}.svg`,
                                    alt: ""
                                  }, null, 8, _hoisted_1185)
                                ])),
                            _createVNode(_component_Multiselect, {
                              class: "muti-select-custom position-absolute",
                              options: [
                    { value: 'hb10', label: 'Học bạ 10' },
                    { value: 'hb11', label: 'Học bạ 11' },
                    { value: 'hb12', label: 'Học bạ 12' },
                    { value: 'kqtdgnl', label: 'Kết quả thi ĐGNL' },
                    { value: 'btnpt', label: 'Bằng tốt nghiệp THPT ' },
                    { value: 'cntntt', label: 'Giấy chứng nhận TNTT' },
                    { value: 'shk', label: 'Sổ hộ khẩu' },
                    { value: 'cmnd', label: 'CMND' },
                    { value: 'gks', label: 'Giấy khai sinh' },
                    { value: 'bhyt', label: 'Bảo hiểm y tế' },
                    { value: 'ccnn', label: 'Chứng chỉ ngoại ngữ' },
                    { value: 'ctmg', label: 'Chứng từ miễn giảm' },
                    { value: 'ctnt', label: 'Chứng từ nộp tiền' },
                    { value: 'xndtut', label: 'Xác nhận đối tượng ưu tiên' },
                    { value: 'gtk', label: 'Giấy tờ khác' },
                  ],
                              placeholder: "Phân loại file",
                              searchable: true,
                              "clear-on-select": true,
                              modelValue: customer.label,
                              "onUpdate:modelValue": ($event: any) => ((customer.label) = $event),
                              onSelect: (e) => _ctx.onSelectTag({ ...customer, select: e })
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onSelect"]),
                            (!customer.label)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1186, _hoisted_1188))
                              : _createCommentVNode("", true)
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_1189, [
                      _createElementVNode("span", {
                        class: "cursor-pointer",
                        onClick: ($event: any) => (_ctx.deleteFile(customer)),
                        title: "Xóa"
                      }, [
                        _createElementVNode("span", _hoisted_1191, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr015.svg" })
                        ])
                      ], 8, _hoisted_1190)
                    ]),
                    _createElementVNode("div", _hoisted_1192, [
                      _createElementVNode("a", {
                        href: customer.filePath,
                        target: "_blank",
                        class: "bg-cirle-white cursor-pointer",
                        title: "Xem"
                      }, [
                        _createElementVNode("span", _hoisted_1194, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen57.svg" })
                        ])
                      ], 8, _hoisted_1193)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1195, [
      _createElementVNode("div", _hoisted_1196, [
        _createElementVNode("div", _hoisted_1197, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_1198, [
              _createElementVNode("span", _hoisted_1199, _toDisplayString(_ctx.sectionNo.finsupport), 1),
              _createTextVNode("Hỗ trợ tài chính")
            ]),
            (_ctx.financialSupportRegistration.isFinancialSupport)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1200, [
                  _createTextVNode("(Hồ sơ của bạn sẽ được chuyển sang "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.financialSupportRegistration.bankName), 1),
                  _createTextVNode(" để được tư vấn và hướng dẫn)")
                ]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isChuyengiao && !_ctx.isLocked)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1201, [
                (!_ctx.isShowFinancialSupport && !_ctx.dataReceipt)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "min-w-button-edit text-primary cursor-pointer d-flex flex-center py-3",
                      onClick: _cache[231] || (_cache[231] = _withModifiers(($event: any) => (_ctx.isShowFinancialSupport = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_1202, [
                        _createElementVNode("span", _hoisted_1203, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen055.svg" })
                        ]),
                        _createTextVNode(" Chỉnh sửa ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_permission, [_ctx.Permission.APPLICANT_EDIT, _ctx.Permission.APPLICANT]]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_1204, [
        _createElementVNode("div", _hoisted_1205, [
          _createVNode(_component_Form, {
            id: "kt_account_connected_accounts_financialsupport",
            class: "form",
            novalidate: "novalidate",
            onSubmit: _cache[238] || (_cache[238] = ($event: any) => (_ctx.submitFinancialSupport(true)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1206, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-12", { disabled: !_ctx.isShowFinancialSupport }])
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1207, [
                      _createElementVNode("div", _hoisted_1208, [
                        _hoisted_1209,
                        _createElementVNode("label", _hoisted_1210, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input me-3",
                            type: "checkbox",
                            name: "financial_support",
                            disabled: !_ctx.isPermission || (_ctx.dataReceipt ),
                            value: true,
                            onChange: _cache[232] || (_cache[232] = 
//@ts-ignore
(...args) => (_ctx.changeIsFinancialSupport && _ctx.changeIsFinancialSupport(...args))),
                            "onUpdate:modelValue": _cache[233] || (_cache[233] = ($event: any) => ((
                          _ctx.financialSupportRegistration.isFinancialSupport
                        ) = $event))
                          }, null, 40, _hoisted_1211), [
                            [_vModelCheckbox, 
                          _ctx.financialSupportRegistration.isFinancialSupport
                        ]
                          ]),
                          _hoisted_1212
                        ]),
                        _createElementVNode("label", _hoisted_1213, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input me-3",
                            type: "checkbox",
                            name: "financial_support_no",
                            disabled: !_ctx.isPermission || (_ctx.dataReceipt ),
                            value: true,
                            onChange: _cache[234] || (_cache[234] = 
//@ts-ignore
(...args) => (_ctx.changeIsFinancialSupportNo && _ctx.changeIsFinancialSupportNo(...args))),
                            "onUpdate:modelValue": _cache[235] || (_cache[235] = ($event: any) => ((_ctx.financialSupportNo) = $event))
                          }, null, 40, _hoisted_1214), [
                            [_vModelCheckbox, _ctx.financialSupportNo]
                          ]),
                          _hoisted_1215
                        ])
                      ]),
                      (_ctx.financialSupportRegistration.isFinancialSupport)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1216, [
                            _createElementVNode("div", _hoisted_1217, [
                              _createElementVNode("div", _hoisted_1218, [
                                _createElementVNode("div", _hoisted_1219, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataBank, (bank, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["mb-3 position-relative", _ctx.isMobile ? 'css-mobile-wrap-bank' : '']),
                                      key: index
                                    }, [
                                      _createElementVNode("label", {
                                        class: _normalizeClass([{ disabled: bank.disabled }, "mb-3 form-check form-check-custom form-check-solid align-items-start"])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input me-1",
                                          type: "radio",
                                          name: "financialSupport",
                                          disabled: !_ctx.isPermission || (_ctx.dataReceipt ),
                                          value: bank.bankName,
                                          onChange: _cache[236] || (_cache[236] = 
//@ts-ignore
(...args) => (_ctx.changeBankName && _ctx.changeBankName(...args))),
                                          "onUpdate:modelValue": _cache[237] || (_cache[237] = ($event: any) => ((_ctx.financialSupportRegistration.bankName) = $event))
                                        }, null, 40, _hoisted_1220), [
                                          [_vModelRadio, _ctx.financialSupportRegistration.bankName]
                                        ]),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["form-check-label d-flex flex-column align-items-start", 
                                  bank.disabled ? 'pb-12 pb-lg-10 pb-md-10' : ''
                                ])
                                        }, [
                                          _createElementVNode("span", _hoisted_1221, _toDisplayString(bank.bankName), 1)
                                        ], 2)
                                      ], 2),
                                      (bank.disabled)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1222, [
                                            _createElementVNode("span", _hoisted_1223, [
                                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                                            ]),
                                            _hoisted_1224
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 2))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2)
              ])
            ]),
            _: 1
          })
        ]),
        (_ctx.isShowFinancialSupport)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1225, [
              _createElementVNode("span", {
                onClick: _cache[239] || (_cache[239] = ($event: any) => {
            _ctx.initFinancialSupport();
            _ctx.isShowFinancialSupport = false;
          }),
                class: "btn btn-white btn-active-light-primary me-2"
              }, " Hủy bỏ "),
              _createElementVNode("button", {
                ref: "submitButton2",
                class: "btn btn-primary",
                onClick: _cache[240] || (_cache[240] = ($event: any) => (_ctx.submitFinancialSupport(true)))
              }, _hoisted_1228, 512)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_1229, [
      _createElementVNode("div", _hoisted_1230, [
        _createElementVNode("div", _hoisted_1231, [
          _createElementVNode("div", _hoisted_1232, [
            _createElementVNode("div", _hoisted_1233, [
              _createElementVNode("div", {
                class: _normalizeClass(["col-lg-12 col-12", _ctx.isMobile ? 'text-center' : 'd-flex flex-stack align-items-center'])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["d-flex align-items-center", { 'justify-content-center mb-4': _ctx.isMobile }])
                }, [
                  (_ctx.dataInitial?.status == 'confirmed')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_1234
                      ], 64))
                    : (_ctx.dataInitial?.status == 'completed')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_1236
                        ], 64))
                      : (_ctx.isCancelled)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _hoisted_1238
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _hoisted_1240,
                            _createElementVNode("div", _hoisted_1241, [
                              _hoisted_1242,
                              (!_ctx.tuitionRegistration.name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_1243, "Cần chọn mức học phí ở mục Thông tin học phí trước khi xác nhận hoàn tất."))
                                : (_openBlock(), _createElementBlock("div", _hoisted_1244, "Hồ sơ đủ thông tin thì bấm Xác nhận hoàn tất."))
                            ])
                          ], 64))
                ], 2),
                (!_ctx.isCancelled)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["d-flex flex-wrap gap-3", { 'mt-2 justify-content-center': _ctx.isMobile }])
                    }, [
                      (_ctx.dataInitial?.open !== false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-light-primary fw-bold text-nowrap",
                            title: `Đợt xét hiện tại: ${_ctx.dataInitial?.phase || '(trống)'} — cập nhật lại đợt của phiếu nhập học`,
                            onClick: _cache[241] || (_cache[241] = ($event: any) => (_ctx.changePhase()))
                          }, [
                            _hoisted_1246,
                            _createTextVNode("Chuyển đợt xét ")
                          ], 8, _hoisted_1245))
                        : _createCommentVNode("", true),
                      (_ctx.dataInitial?.status == 'completed')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-light-warning fw-bold text-nowrap",
                            onClick: _cache[242] || (_cache[242] = ($event: any) => (_ctx.reopenProfile()))
                          }, [
                            _hoisted_1247,
                            _createTextVNode("Mở lại phiếu ")
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.dataInitial?.status == 'confirmed' && _ctx.isSuperAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "btn btn-light-danger fw-bold text-nowrap",
                            disabled: !_ctx.dataInitial?.open,
                            title: !_ctx.dataInitial?.open ? 'Hồ sơ đã chuyển giao SIS — không hoàn tác được' : 'Gỡ hồ sơ về Chờ xác nhận để sửa lại',
                            onClick: _cache[243] || (_cache[243] = ($event: any) => (_ctx.undoConfirmProfile()))
                          }, [
                            _hoisted_1249,
                            _createTextVNode("Hoàn tác xác nhận ")
                          ], 8, _hoisted_1248))
                        : _createCommentVNode("", true),
                      (_ctx.dataInitial?.status == 'confirmed')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            class: "btn btn-primary fw-bold text-nowrap",
                            onClick: _cache[244] || (_cache[244] = e=>{ _ctx.sendMailStudent(_ctx.id) })
                          }, _hoisted_1252))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 4,
                            class: "btn btn-primary fw-bold text-nowrap",
                            disabled: !_ctx.tuitionRegistration.name,
                            title: !_ctx.tuitionRegistration.name ? 'Cần chọn mức học phí trước' : 'Xác nhận hoàn tất nhập học — chốt hồ sơ, cấp MSSV/email và đẩy SIS',
                            onClick: _cache[245] || (_cache[245] = e=>{ _ctx.completeAdmission() })
                          }, _hoisted_1256, 8, _hoisted_1253))
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_policy),
    _createVNode(_component_tableSize),
    _createVNode(_component_guidePicture)
  ], 64))
}